/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme', [
      'toastr',
      'chart.js',            
      'textAngular',
      'DifactWeb.theme.components'
  ]);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components', []);

})();

'use strict';

angular.module('DifactWeb', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',  
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'ui.mask',
  'ngMaterial',
  'ngMessages',
  'ngMask',
  'ui.utils.masks',
  'ngTable',
  'angularFileUpload',
  'ngCookies',
  'ngStorage',
  'ngLocale',
  'angularXml2json',
  'youtube-embed',

  
  'DifactWeb.theme',
  'DifactWeb.pages'
]);
/**
 * @author Carlos Rodrigues
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages', [
    'ui.router'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider, $locationProvider) {
    $locationProvider.hashPrefix('');
    // $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/999/999/login');
    $stateProvider
      .state('login', {
        url: '/login',
        template: '<span>Redirecionando</span>',
        controller: function ($rootScope, $state, $localStorage) {
          if ($localStorage.empcod && $localStorage.empfaccod) {
            $state.go('empresa.login', { empcod: $localStorage.empcod, empfaccod: $localStorage.empfaccod })
            delete $localStorage.empcod;
            delete $localStorage.empfaccod;
            delete $localStorage.admittance;
            delete $localStorage.nomeFactoring;
            delete $localStorage.nomeHeader;
            delete $localStorage.papelUsuario;
            delete $localStorage.token;
            delete $localStorage.perGrafico;
            delete $localStorage.perFuncionalidades;
          } else {
            $state.go('empresa.login', { empcod: $rootScope.parametrosEmpresa.empcod, empfaccod: $rootScope.parametrosEmpresa.empfaccod })
          }

        }
      })
      .state('empresa', {
        abstract: true,
        url: '/{empcod}/{empfaccod}',
        template: '<ui-view/>',
      })
      .state('empresa.inicio', {
        url: '/inicio',
        templateUrl: 'app/pages/painel_inicio/painel.inicio.html',
        title: 'Início',
        controller: 'painelInicioController',
        sidebarMeta: {
          icon: 'ion-home',
          order: 0,
          papel: 'cliente'
        },
      })
      .state('empresa.novaremessa', {
        url: '/titulosEnvio',
        templateUrl: 'app/pages/remessas/painel_remessa/painel.remessa.html',
        title: 'Envio de Títulos',
        controller: 'painelRemessaController',
        sidebarMeta: {
          icon: 'ion-android-send',
          order: 1,
          papel: 'cliente'
        },
        params: { reload: 'recarregar' }
      })
      .state('empresa.remessas', {
        url: '/lotesTitulos',
        templateUrl: 'app/pages/remessas/painel_remessas/painel.remessas.html',
        title: 'Títulos Enviados',
        controller: 'painelRemessasController',
        sidebarMeta: {
          icon: 'ion-ios-filing',
          order: 2,
          papel: 'cliente'
        },
      })
      .state('empresa.novaprorrogacao', {
        url: '/prorrogacao',
        templateUrl: 'app/pages/prorrogacoes/enviar_prorrogacao/new-prorrogacao.html',
        title: 'Prorrogar Títulos',
        controller: 'newProrrogacaoController',
        sidebarMeta: {
          icon: 'ion-ios-time',
          order: 3,
          papel: 'cliente'
        },
      })
      .state('empresa.prorrogaTitulo', {
        url: '/prorrogaTitulo',
        templateUrl: 'app/pages/prorrogacoes/enviar_prorrogacao/prorrogar-titulo.html',
        title: 'Prorrogar Títulos',
        controller: 'newProrrogacaoController',
        params: { item: null }
      })
      .state('empresa.prorrogacoes', {
        url: '/prorrogacao/consulta',
        templateUrl: 'app/pages/prorrogacoes/painel_prorrogacoes/painel.prorrogacoes.html',
        title: 'Prorrogações Enviadas',
        controller: 'painelProrrogacoesController',
        sidebarMeta: {
          icon: 'ion-ios-list',
          order: 3,
          papel: 'cliente'
        },
      })
      .state('empresa.anexos', {
        url: '/anexotitulos',
        templateUrl: 'app/pages/painel_anexos/painel.anexos.html',
        title: 'Comprovantes',
        controller: 'painelAnexosController',
        sidebarMeta: {
          icon: 'ion-android-attach',
          order: 6,
          papel: 'cliente'
        },
      })
      .state('empresa.operacao', {
        url: '/operacao',
        templateUrl: 'app/pages/painel_operacao/painel.operacao.html',
        title: 'Operações',
        controller: 'painelOperacaoController',
        sidebarMeta: {
          icon: 'ion-archive',
          order: 3,
          papel: 'cliente'
        },
        resolve: {
          retornaOperacoes: function (painelOperacaoFactory) {
            return painelOperacaoFactory.getPainelOperacaoFactory();
          }
        }
      })
      .state('empresa.relatorio', {
        url: '/relatorio',
        templateUrl: 'app/pages/painel_relatorio/painel.relatorio.html',
        title: 'Extrato',
        controller: 'painelRelatorioController',
        sidebarMeta: {
          icon: 'ion-pie-graph',
          order: 4,
          papel: 'cliente'
        }
      })
      .state('empresa.emitirBoleto', {
        url: '/emitirBoleto',
        templateUrl: 'app/pages/painel_boleto/painel.boletoTitulos.html',
        title: '2ª Via Boletos',
        controller: 'painelBoletoTitulosController',
        sidebarMeta: {
          icon: 'icon ion-ios-barcode-outline',
          order: 5,
          papel: 'cliente'
        }
      })
      .state('empresa.alteraremessa', {
        url: '/alteraTitulos',
        templateUrl: 'app/pages/remessas/painel_remessa/painel.alteraremessa.html',
        title: 'Títulos Enviados',
        controller: 'painelAlteraRemessaController',
        params: { reload: 'recarregar' }
      })
      .state('empresa.login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        controller: 'loginCtrl'
      })
      .state('empresa.administrador', {
        url: '/administrador',
        templateUrl: 'app/pages/painel_decisao/painel.administrador.html',
        controller: 'painelAdministradorController',
        title: 'Empresas',
        sidebarMeta: {
          icon: 'ion-android-settings',
          order: 5,
          papel: 'administrador'
        }
      })
      .state('empresa.admlog', {
        url: '/log',
        templateUrl: 'app/pages/painel_decisao/painel.administrador.log.html',
        controller: 'painelAdministradorController',
        title: 'Relatório de Uso',
        sidebarMeta: {
          icon: 'ion-podium',
          order: 6,
          papel: 'administrador'
        }
      })
      .state('empresa.factoring', {
        url: '/factoring',
        templateUrl: 'app/pages/painel_factoring/painel.factoring.html',
        controller: 'painelFactoringController',
        title: 'Parâmetros',
        sidebarMeta: {
          icon: 'ion-android-options',
          order: 5,
          papel: 'factoring'
        }
      })
      .state('empresa.carregarArquivo', {
        url: '/carregarArquivo',
        templateUrl: 'app/pages/painel_factoring/painel.factoring.arquivo.html',
        controller: 'painelFactoringController',
        title: 'Carregar Arquivo',
        sidebarMeta: {
          icon: 'ion-ios-cloud-upload',
          order: 6,
          papel: 'factoring'
        }
      })

      .state('empresa.usandoSistema', {
        url: '/comoUsar',
        templateUrl: 'app/pages/painel_comoUsar/painel.usandoSistema.html',
        controller: 'painelUsandoSistemaController',
        title: 'Como Usar',
      })
      .state('empresa.titulosOperacao', {
        url: '/titulosOperacao',
        templateUrl: 'app/pages/painel_inicio/painel.titulosOperacao.html',
        controller: 'painelTituloCtrl',
        title: 'Titulos Operação',
        params: { reload: 'recarregar' },
      });
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .run(pagesRun);

    /** @ngInject */
    function pagesRun($state, $rootScope, $location, loginService, storageService) {

               $rootScope.$on('$stateChangeStart', function (event, toState, $stateParams) {
            if (toState.name === 'empresa.administrador') {

                if (atob(storageService.getPapelUsuario()) !== "administrador") { // Check if user allowed to transition                  
                    event.preventDefault();   // Prevent migration to default state                  
                    $state.go('empresa.login', { empcod: $stateParams.empcod, empfaccod: $stateParams.empfaccod });
                }
            }
            if (toState.name === 'empresa.factoring') {

                if (atob(storageService.getPapelUsuario()) !== "factoring") { // Check if user allowed to transition                  
                    event.preventDefault();   // Prevent migration to default state                  
                    $state.go('empresa.login', { empcod: $stateParams.empcod, empfaccod: $stateParams.empfaccod });
                }
            }           
        });



        $rootScope.animacaoMenu = true;
        $rootScope.parametrosEmpresa = $location.search();
      
    }

})(); 

(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .service('loginService', loginService)
        .service('ajusteDatas', ajusteDatas)
        .service('paddingLeft', paddingLeft)
        .service('paddingRight', paddingRight)
        .service('formatarMoeda', formatarMoeda)
        .service('formatarValor', formatarValor)

    function formatarValor() {
        this.ajustarValor = function (numero, c, d, t) {
            var n = numero,
                c = isNaN(c = Math.abs(c)) ? 2 : c,
                d = d == undefined ? "." : d,
                t = t == undefined ? "," : t,
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        };
    }

    function paddingLeft() {
        this.alinharEsquerda = function (s, c, n) {
            if (!s || s.length >= n) {
                return s;
            }
            var max = (n - s.length);
            for (var i = 0; i < max; i++) {
                s = c + s;
            }
            return s;
        }
    }

    function paddingRight() {
        this.alinharDireita = function (s, c, n) {
            if (!s || s.length >= n) {
                return s;
            }
            var max = (n - s.length);
            for (var i = 0; i < max; i++) {
                s += c;
            }
            return s;
        }
    }

    /** @ngInject */
    function ajusteDatas() {
        this.formatarData = function (date) {
            return moment(date).format('DD/MM/YYYY');
        }
    }
    function loginService($state, $window, $stateParams) {

        this.logar = function (dados) {                        
            var oldPapel = dados.papel;
            dados.papel = btoa(dados.papel);
            dados.permissao = btoa(dados.permissao);

            $window.localStorage.setItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod, JSON.stringify(dados));            
            if (oldPapel === 'administrador') {
                $state.go('empresa.administrador', {empcod: $stateParams.empcod, empfaccod: $stateParams.empfaccod});
            }
            if (oldPapel === 'cliente') {
                $state.go('empresa.inicio', {empcod: $stateParams.empcod, empfaccod: $stateParams.empfaccod} );
            }
            if (oldPapel === 'factoring') {
                $state.go('empresa.factoring', {empcod: $stateParams.empcod, empfaccod: $stateParams.empfaccod});
            }
        }

        this.logout = function () {
            $window.localStorage.removeItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod);
            $state.go('empresa.login' ,{empcod: $stateParams.empcod , empfaccod: $stateParams.empfaccod });
        }
    }

    function formatarMoeda() {
        this.moedaReal = function (valor, casas, separdor_decimal, separador_milhar) {
            var valor_total = parseFloat(valor * (Math.pow(10, casas)));
            valor_total = Math.round(valor_total, 1);

            var inteiros = parseInt(parseInt(valor * (Math.pow(10, casas))) / parseFloat(Math.pow(10, casas)));
            var centavos = parseFloat(parseFloat(valor * (Math.pow(10, casas))) % parseFloat(Math.pow(10, casas)));
            centavos = Math.round(centavos, 1);

            if (centavos % 10 == 0 && centavos + "".length < 2) {
                centavos = centavos + "0";
            } else if (centavos < 10) {
                centavos = "0" + centavos;
            }

            var milhares = parseInt(inteiros / 1000);
            inteiros = inteiros % 1000;

            var retorno = "";

            if (milhares > 0) {
                retorno = milhares + "" + separador_milhar + "" + retorno
                if (inteiros == 0) {
                    inteiros = "000";
                } else if (inteiros < 10) {
                    inteiros = "00" + inteiros;
                } else if (inteiros < 100) {
                    inteiros = "0" + inteiros;
                }
            }
            retorno += inteiros + "" + separdor_decimal + "" + centavos;

            return retorno;
        }
    }

})();
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .service('storageService', storageService);

    function storageService($window, $stateParams, loginService) {
        this.getPapelUsuario = function () {
            var storage = $window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)
            if(storage){                
                return JSON.parse(storage).papel;
            }else{
                return false;    
            }            
            
        }
        this.getPermissao = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).permissao;
        }
        this.getNomeFactoring = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).nomeFactoring;
        }
        this.getNomeEmpresa = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).nomeEmpresa;
        }
        this.getToken = function () {
            var data = $window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod);
            if (data !== null) {
                return JSON.parse(data).token;
            } else {
                loginService.logout();
                return '';
            }
        }

        this.getPerFuncional = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).perFuncionalidades;
        }

        this.getPerGrafico = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).perGrafico;
        }

        this.getEmpresas = function () {
            return JSON.parse($window.localStorage.getItem('difactweb-' + $stateParams.empcod + '|' + $stateParams.empfaccod)).empresas;
        }

        this.verificaExistencia = function(empcod, empfaccod){
            if($window.localStorage.getItem('difactweb-' + empcod + '|' + empfaccod)){
                return true;
            } else{
                return false;
            }            
        }

    }

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .config(config)
    .config(function ($mdDateLocaleProvider) {
      $mdDateLocaleProvider.formatDate = function (date) {
        return date ? moment(date).format('DD/MM/YYYY') : '';
      };

      $mdDateLocaleProvider.parseDate = function (dateString) {
        var m = moment(dateString, 'DD/MM/YYYY', true);
        return m.isValid() ? m.toDate() : new Date(NaN);
      };
    })

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#209E91',
  };

  angular.module('DifactWeb.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  // //****** MAQUINA LOCAL ****** 
  //  var URL_API_REST = "http://localhost:8080/DifactwebJP/rest/"; 
  //  var URL_API_DOC = "http://localhost:8080/DifactwebJP/arquivos/termo_aditivo/";
  //  var URL_API_GX = "http://localhost:8080/DifactwebJP/gxobject";
  //  var URL_API_ARQUIVO = "http://localhost:8080/DifactwebJP/arquivos/";
  //  var URL_API_SERVER = 'http://diacesso.decisaosistemas.com.br/webservices/servlet/';

  //****** SERVIDOR PRODUÇÃO ******
 var URL_API_REST = "https://www.difactweb.com.br/rest/";
 var URL_API_DOC = "https://www.difactweb.com.br/arquivos/termo_aditivo/";
 var URL_API_ARQUIVO = "https://www.difactweb.com.br/arquivos/";
 var URL_API_GX = "https://www.difactweb.com.br/gxobject";
 var URL_API_SERVER = 'http://diacesso.decisaosistemas.com.br/webservicesdecisao/servlet/';


  angular.module('DifactWeb.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      },
      urlAPI: {
        atualizaStatusDocumento:      URL_API_REST + 'apiAtualizaStatusDocumento',
        atualizaStatusOperacao:       URL_API_REST + 'apiAtualizaStatusOperacao',
        monitoraDisponivel:           URL_API_REST + 'apiRetornaDtUltMonitoramento',
        monitoraRelatorio:            URL_API_REST + 'apiRetornaDtUlRel',
        geraBoletoOperacao:           URL_API_REST + 'apiGeraBoletoTitulosOpe',
        geraBoleto:                   URL_API_REST + 'apiGeraBoletoTitulo',
        titulosPosicaoCarteira:       URL_API_REST + 'apiTitulosCarteira',
        validarTituloDuplicado:       URL_API_REST + 'apiValidarTituloDuplicado',
        salvarConfiguracoes:          URL_API_REST + 'apiSalvarConfiguracoes',
        importarArquivo:              URL_API_REST + 'apiUpload',
        validaConsistencia:           URL_API_REST + 'apiValidarConsistencia',
        enviarRemessa:                URL_API_REST + 'apiEnviarRemessa',
        removerTitulo:                URL_API_REST + 'apiRemoverTitulo',
        editarTitulo:                 URL_API_REST + 'apiEditarTitulo',
        removerRemessa:               URL_API_REST + 'apiExcluirRemessa',
        buscarTitulos:                URL_API_REST + 'apiRetornaTitulosRemessa',
        gravarTitulo:                 URL_API_REST + 'apiGravarTitulo',
        buscarRemessas:               URL_API_REST + 'apiBuscaRemessas',
        buscarTitulosNaoEnviados:     URL_API_REST + 'apiBuscarTitulosNaoEnviados',
        gravarSacado:                 URL_API_REST + 'apiGravarSacado',
        buscarDadosSacado:            URL_API_REST + 'apiBuscaDadosSacado',
        buscarSacados:                URL_API_REST + 'apiBuscarSacados',
        incluirBanco:                 URL_API_REST + 'apiIncluirBanco',
        carregarBancos:               URL_API_REST + 'apiRetornaBancos',
        removerBanco:                 URL_API_REST + 'apiExcluirBanco',
        buscarOperacoes:              URL_API_REST + 'apiBuscaOperacoes',
        validarUsuario:               URL_API_REST + 'api_login',
        carregarEmpresas:             URL_API_REST + 'apiRetornaEmpresas',
        carregarEmpresa:              URL_API_REST + 'apiRetornaEmpresa',
        incluirEmpresa:               URL_API_REST + 'apiIncluirEmpresa',
        buscarFactoring:              URL_API_REST + 'apiBuscarFactoring',
        excluirEmpresaCadastrada:     URL_API_REST + 'apiExcluirEmpresaCadastrada',
        verificarEmpresaCadastrada:   URL_API_REST + 'apiVerificarEmpresaCadastrada',
        uploadArquivo:                URL_API_REST + 'uploadArquivoImportacao',
        buscaDocumentosAberto:        URL_API_REST + 'apiBuscaDocumentosAbertos',
        buscaOperacoesRealizadas:     URL_API_REST + 'apiBuscaOperacoesRealizadas',
        buscaDadosExtrato:            URL_API_REST + 'apiBuscaDadosExtrato',
        buscaDadosSistema:            URL_API_REST + 'apiBuscaExtratoSistema',
        dadosExtratoSistema:          URL_API_REST + 'apiGravaDadosExtrato',
        buscarCEP:                    URL_API_SERVER + 'apcepp001',
        visualizarTermo:              URL_API_REST + 'apiVisualizarTermo',
        imprimeDuplicata:             URL_API_REST + 'apiImprimeDuplicata',
        atualizaStatusDoc:            URL_API_REST + 'apiAtualizaStatusDoc',
        uploadDocumentoEmail:         URL_API_REST + 'apiUploadDocumentoEmail', 
        enviarEmailDireto:            URL_API_REST + 'apiEnviarEmail',
        buscarLog:                    URL_API_REST + 'apiBuscaLog',
        detalharLog:                  URL_API_REST + 'apiBuscaDetalhesLog',
        buscaDocumentos:              URL_API_REST + 'apiBuscaDocumentos',
        buscarProrrogaNaoEnviadas:    URL_API_REST + 'apiBuscarProrrogacoesNaoEnviadas',
        gravarProrrogacao:            URL_API_REST + 'apiGravarProrrogacao',
        removerProrrogacao:           URL_API_REST + 'apiRemoverProrrogacao',
        atualizaStatusNaoEnviado:     URL_API_REST + 'apiAtualizaDocNaoEnviado',
        enviarComprovantesEmail:      URL_API_REST + 'apiEnviarComprovantes',
        carregarArquivo:              URL_API_GX,
        buscarDocumentosWord:         URL_API_DOC,
        abrirArquivo:                 URL_API_ARQUIVO

      },
    })
    .constant('colorHelper', {
      tint: function (color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function (color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for (var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {    
    var whatToWait = [
      //preloader.loadAmCharts(),
      $timeout(10)
    ];


    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 0);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : 'true';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    angular.module('DifactWeb.pages').factory("painelLoginFactory", painelLoginFactory);

    function painelLoginFactory(layoutPaths, $http) {

        var factory = {
            postPainelLoginFactory: postPainelLoginFactory,
        }
        return factory;

        function postPainelLoginFactory(login) {     
            return $http.post(layoutPaths.urlAPI.validarUsuario, '{"login": ' + angular.toJson(login) + '}').then(function (response) {                
                return response.data;
            });        
        }
    };    
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('loginCtrl', loginCtrl);

    /** @ngInject */
    function loginCtrl($scope, $rootScope, toastr, $stateParams, painelLoginFactory, $localStorage, loginService, $window) {
        $scope.login = {};   
        
        $scope.login.empfaccod = $stateParams.empfaccod;
        $scope.login.empcod = $stateParams.empcod;
 
        $rootScope.showDetails = false; 

        $scope.validarUsuario = function () {
            if ($scope.login) {
                if ($scope.login.usuario != undefined && $scope.login.senha != undefined) {
                    //aqui vai fazer o login
                    $rootScope.loading = true;
                    painelLoginFactory.postPainelLoginFactory($scope.login).then(function (response) {
                        var retornoLogin = response.retorno;
                        
                        if (retornoLogin.success) {
                            
                            if ($localStorage.token == "") {
                                toastr.error("Falha ao realizar login.", { timeOut: 1200 });
                            } else {
                                loginService.logar(retornoLogin);
                            }
                            $rootScope.loading = false;
                        } else {
                            toastr.error(retornoLogin.description, { timeOut: 1200 });
                            $rootScope.loading = false;
                        }
                    });

                } else {
                    toastr.error('Necessário informar dados para logar.', { timeOut: 1200 });
                };
            } else {
                toastr.error('Necessário informar usuário e senha para logar.', { timeOut: 1200 });
            }
        };
    }
})();


(function () {
    'use strict'

    angular.module('DifactWeb.pages')
        .controller('painelAnexosController', painelAnexosController);

    /** @ngInject */
    function painelAnexosController($scope, $state, $rootScope, $uibModal, toastr, layoutPaths,
        storageService, $http, FileUploader, $stateParams) {

        $rootScope.showDetails = true;

        $scope.pagination = {
            currentPage: 1,
            pageSize: 10,
            maxSize: 10
        };

        $scope.novaProrrogacao = {};

        $scope.buscarTitulos = function () {
            $http.post(layoutPaths.urlAPI.buscaDocumentos, '{"tipo": "T"}',
                { headers: { 'Authorization': storageService.getToken() } })
                .then(function (response) {
                    if (response.data.retornaDocumentos) {
                        
                        $scope.titulos = response.data.retornaDocumentos.retornaDocumentos;
                        $scope.titulosOrdena = $scope.titulos;
                        $scope.totalItens = response.data.retornaDocumentos.retornaDocumentos.length;
                        $scope.qtdPages = Math.ceil($scope.totalItens / $scope.pagination.pageSize);
                        if ($scope.titulos) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.titulos.length;
                            $scope.qtdPages = Math.ceil($scope.titulos.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                            $scope.mensagemVazio = "";
                        }
                    } else {
                        $scope.mensagemVazio = "Nenhuma informação encontrada.";
                    }
                });
        };

        $scope.converterData = function (dataParm) {
            var dia = dataParm.substring(0, 2);
            var mes = dataParm.substring(3, 5);
            var ano = dataParm.substring(6, 10);

            var data = mes + '/' + dia + '/' + ano;
            var novoData = new Date(data);

            return novoData
        };

        $scope.addAnexo = function (item) {
            $scope.fileStrings = [];
            $rootScope.fileStrings = [];
            $rootScope.itemModal = item;
            $scope.observacao = 'Documento: '+item.numeroDoc+' Sacado: '+item.nomeSacado+' Vencimento: '+item.vencimento
            $scope.openAddAnexo('app/pages/painel_anexos/painel.anexos.modal.html', 'vm', 'enviar');
        };

        $scope.openAddAnexo = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope,
                backdrop: 'static'
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'enviar') {
                    if ($scope.fileStrings.length > 0) {
                        toastr.warning('Comprovantes sendo Enviados...', {
                            timeOut: 2400
                        });
                        $scope.enviarRemessa($scope.observacao);
                    }else{
                        toastr.error('Nenhum arquivo adicionado para ser enviado!', {
                            timeOut: 2400
                        });
                        $scope.addAnexo($rootScope.itemModal)
                    }
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };

       //********************************************************************************
        //*************************** IMPORTAÇÃO DE ARQUIVO *****************************
        //********************************************************************************
        $scope.desabilitarItem = false;

        var uploader = $scope.uploader = new FileUploader({
            url: layoutPaths.urlAPI.carregarArquivo,
            headers: {
                'Authorization': storageService.getToken()
            }
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function () {
                $scope.tamanho = this.queue.length;
                return this.queue.length < 50;
            }

        });

        $scope.remover = function () {
            $scope.desabilitarItem = false;
        }

        // CALLBACKS
        uploader.onCompleteItem = function (fileItem) {
            fileItem.isSucess = true;
        };

        uploader.onErrorItem = function (fileItem) {
            fileItem.isSucess = false;
            $scope.erroImportacao = true;
        };

        $scope.uploaderAnexos = new FileUploader();

        $scope.fileStrings = [];
        $rootScope.fileStrings = [];

        $scope.removeAnexo = function (obj) {
            var remFile = $scope.fileStrings.findIndex(function (item) {
                return item.$$hashKey === obj.$$hashKey;
            });
            $scope.fileStrings.splice(remFile, 1);
            $rootScope.fileStrings.splice(remFile,1);
        }

        $scope.uploaderAnexos.onAfterAddingFile = function (fileItem) {
            var data = (/[.]/.exec(fileItem.file.name)) ? /[^.]+$/.exec(fileItem.file.name) : undefined
            
            if (fileItem.file.size <= 5242880) {
                if ($scope.fileStrings.length >= 500) {
                    toastr.error('Você atingiu o limite de 500 arquivos no envio.', {
                        timeOut: 2400
                    });
                } else {
                    $scope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                    $rootScope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                }
            } else {
                toastr.error('Arquivo muito grande, não é possível anexar!', {
                    timeOut: 2400
                });
            }
        };

        /////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////Realizar envio dos anexos via email/////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////
        $scope.enviarRemessa = function (observacao) {
            $rootScope.loading = true;

            $scope.filesSend = [];
            angular.forEach($scope.fileStrings, function (fileUp, i) {
                var fileReader = new FileReader();
                fileReader.onload = function (event) {
                    var uri = event.target.result;

                    $scope.filesSend.push({
                        filename: fileUp.fileName,
                        filetype: fileUp.fileType,
                        filebase64: uri.split("base64,")[1]
                    });
                    setTimeout(function () {
                        if (i == ($scope.fileStrings.length - 1)) {
                            var data = '{"observacao": '+angular.toJson(observacao)+', "files": { "operacao":' + angular.toJson(0) + ',  "files": ' + angular.toJson($scope.filesSend) + '}}';
                            $scope.uploadDocumento(data);
                        }
                    }, 1000);
                };
                fileReader.readAsDataURL(fileUp.fileUpload);
            })
            $rootScope.loading = false;
        };

        $scope.uploadDocumento = function (data) {
            $http.post(layoutPaths.urlAPI.enviarComprovantesEmail, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
            .then(function (response) {
                if(response.data.response){
                    toastr.success('Documentos enviados com sucesso!', {
                        timeOut: 2400
                    });
                }else{
                    toastr.error('Ocorreu um erro no envio dos documentos!', {
                        timeOut: 2400
                    });
                }
            })
        }
    };
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelBoletoTitulosController', emissaoBoleto);

    /** @ngInject */
    function emissaoBoleto($scope, toastr, $interval, $rootScope, painelEmissaoBoletoFactory, ajusteDatas, storageService) {
        $rootScope.showDetails = true;

        $scope.pageSize = '10';
        $scope.boletoTitulos = [];
        $scope.cont = 0;

        function myTimer() {
            $scope.buscarTitulosBoletos();
        }

        function myStopFunction() {
            clearInterval($scope.tempo);
        }

        $scope.$on('$destroy', function () {
            myStopFunction()
        });
        
        $scope.buscarTitulosBoletos = function () {
            $scope.posicaoCarteira = "Todos Títulos";
            $rootScope.loading = true;
            painelEmissaoBoletoFactory.getPainelEmissaoBoletoFactory($scope.posicaoCarteira)
                .then(function (response) {                    
                    if (response.retornaTitulosCarteira.statusdoc != 'EB') {
                        myStopFunction();
                        $rootScope.bloquearTela = false;
                        $rootScope.mensagemTela = '';
                        if (response.retornaTitulosCarteira.status) {
                            $scope.boletoTitulos = response.retornaTitulosCarteira.sdtRetornaTitulosPosicaoCarteiraItem;
                            if ($scope.dadosTitulo) {
                                //Abrir documento gerado    
                                var tamanho = $scope.boletoTitulos.length;
                                var contador = 0;
                                var existe = false;
                                var geraPdf = false;
                                var msgerro = '';
                                while (contador < tamanho) {
                                    if ($scope.boletoTitulos[contador].titDocSeq == $scope.dadosTitulo.docSequen) {
                                        msgerro = $scope.boletoTitulos[contador].titMsgErr;
                                        if ($scope.boletoTitulos[contador].titDocBol != '') {                                        
                                        geraPdf = true;
                                        var dlnk = document.getElementById('dwnldLnk');
                                        dlnk.href = $scope.boletoTitulos[contador].titDocBol;
                                        dlnk.click();
                                        break;
                                        }
                                    }
                                    contador++;
                                }
                                if (!geraPdf) {
                                    if (msgerro != '') {
                                        toastr.error('Boleto não pode ser gerado. '+ msgerro, { timeOut: 6500 });
                                    } else {
                                        toastr.error('Boleto não pode ser gerado. Verificar junto a empresa ' + storageService.getNomeFactoring() + ' as configurações necessárias do cliente para emissão do boleto.', { timeOut: 4500 })
                                    }
                                }
                            }
                            $scope.boletoTitulosOrdena = $scope.boletoTitulos;
                        } else {
                            $scope.mensagemVazio = "Nenhuma informação encontrada.";
                        }

                        $rootScope.loading = false;
                    }
                    else {                        
                        $scope.cont += 1;
                        if ($scope.cont >= 6) {
                            $scope.cont = 0
                            myStopFunction();
                            painelEmissaoBoletoFactory.postPainelAtualizaStatusFactory($scope.dadosTitulo)
                                .then(function (response) {                                    
                                    $rootScope.bloquearTela = false;
                                    toastr.error('Não foi possível conectar com a Empresa ' + storageService.getNomeFactoring() + ' - ' + $scope.dadosTitulo.titDocBase, { timeOut: 4500 })
                                    $rootScope.loading = false;
                                }, function (error) {                                    
                                    $rootScope.loading = false;
                                    $scope.mensagemVazio = "";
                                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                                    $rootScope.bloquearTela = false;
                                    $rootScope.mensagemTela = '';
                                });
                        } 
                    }
                }, function (response) {
                    $rootScope.loading = false;
                    $scope.mensagemVazio = "";
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.bloquearTela = false;
                    $rootScope.mensagemTela = '';
                });

            $scope.boletoTitulosOrdena = $scope.boletoTitulos;
            $scope.totalItens = $scope.boletoTitulosOrdena.length;
            $scope.qtdPages = Math.ceil($scope.boletoTitulosOrdena.length / $scope.pageSize);
            $scope.currentPage = 1;
            $scope.maxSize = 6;
        }

        $scope.emitirBoleto = function (item) {
            $scope.dadosTitulo = {};
            $scope.dadosTitulo.opeNumero = item.titNumOpe
            $scope.dadosTitulo.docSequen = item.titDocSeq
            $scope.dadosTitulo.titDocBase = item.titDocBase

            // Vamos considerar que todo boleto estará atrasado para poder ir no servidor
            $scope.dadosTitulo.situacao = '';    
            painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory()
                .then(function (response) {
                    $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel
                    $rootScope.loading = true;
                    $scope.dadosTitulo.monitoraDisponivel = $scope.servidorDisponivel;
                    if ($scope.servidorDisponivel) {
                        $rootScope.bloquearTela = true;
                        $rootScope.mensagemTela = 'Gerando 2ª via do Boleto. Aguarde Conexão com a Empresa...';
                        $scope.tempo = setInterval(function () { myTimer() }, 7000);
                        //Gerar um novo boleto            
                        painelEmissaoBoletoFactory.postPainelGeraBoletoFactory($scope.dadosTitulo)
                            .then(function (response) {
                                //Aguardar processamento do boleto para abrir
                                $rootScope.loading = false;
                            }, function (response) {
                                $rootScope.loading = false;
                                console.log(response)
                                toastr.error('Falha ao gerar boleto do título. Entre em contato com a empresa ' +  storageService.getNomeFactoring() + '.', { timeOut: 2500 });
                                $rootScope.bloquearTela = false;
                                $rootScope.mensagemTela = '';
                            });
                    } else {
                        toastr.error('Serviço indisponível. Entre em contato com a empresa ' +  storageService.getNomeFactoring() + '.', { timeOut: 2500 })
                    }
                    $rootScope.loading = false;
                }, function (response) {
                    toastr.error('Falha ao gerar boleto do título. Entre em contato com a empresa ' +  storageService.getNomeFactoring() + '.', { timeOut: 2500 });
                });
        }
    }
})();
(function () {
    angular.module('DifactWeb.pages').factory("painelEmissaoBoletoFactory", painelEmissaoBoletoFactory);

    function painelEmissaoBoletoFactory(layoutPaths, $http, storageService) {

        var factory = {
            getPainelEmissaoBoletoFactory: getPainelEmissaoBoletoFactory,
            postPainelGeraBoletoFactory: postPainelGeraBoletoFactory,
            getPainelMonitoraDisponivelFactory: getPainelMonitoraDisponivelFactory,
            postPainelAtualizaStatusFactory: postPainelAtualizaStatusFactory
        }
        return factory;

        function getPainelEmissaoBoletoFactory(titulos) {
            titulos = "Todos Títulos";
            return $http.post(layoutPaths.urlAPI.titulosPosicaoCarteira, '{"posicaoCarteira":' + angular.toJson(titulos) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

        function postPainelGeraBoletoFactory(dadosTitulo) {
            return $http.post(layoutPaths.urlAPI.geraBoleto, '{"dadosTitulo":' + angular.toJson(dadosTitulo) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

        function postPainelAtualizaStatusFactory(dadosTitulo) {
            return $http.post(layoutPaths.urlAPI.atualizaStatusDocumento, '{"dadosTitulo":' + angular.toJson(dadosTitulo) + '}',{ headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }        

        function getPainelMonitoraDisponivelFactory() {
            return $http.post(layoutPaths.urlAPI.monitoraDisponivel, {},{ headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }        
    };
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelUsandoSistemaController', usandoSistema);

    /** @ngInject */
    function usandoSistema($rootScope, $scope) {
        $rootScope.showDetails = true;

        //$scope.theBestVideo = 'K3IMWWE-w3I';
        $scope.theBestVideo = 'pcAIvvbwC4w';
    }
})();

(function () {
    angular.module('DifactWeb.pages').factory("painelAdministradorFactory", painelAdministradorFactory);

    function painelAdministradorFactory(layoutPaths, $http, storageService) {

        var factory = {
            postPainelAdministradorFactory: postPainelAdministradorFactory,
            getPainelAdministradorFactory: getPainelAdministradorFactory,
            viewPainelAdministradorFactory: viewPainelAdministradorFactory,
            deletePainelAdministradorFactory: deletePainelAdministradorFactory
        }
        return factory;

        function postPainelAdministradorFactory(factoring) {
            return $http.post(layoutPaths.urlAPI.incluirEmpresa, '{"factoring": ' + angular.toJson(factoring) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

        function getPainelAdministradorFactory() {
            return $http.post(layoutPaths.urlAPI.carregarEmpresas, {}, { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

        function viewPainelAdministradorFactory(codigo) {
            return $http.post(layoutPaths.urlAPI.verificarEmpresaCadastrada, '{"codigoFactoring": ' + angular.toJson(codigo) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

        function deletePainelAdministradorFactory(codigo) {
            return $http.post(layoutPaths.urlAPI.excluirEmpresaCadastrada, '{"codigoEmpresa": ' + angular.toJson(codigo) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }

    };
})();

(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelAdministradorController', administrador)
    .config(function ($mdDateLocaleProvider) {
      $mdDateLocaleProvider.months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
      $mdDateLocaleProvider.shortMonths = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY');
      };

    })
    .filter('ajustaSituacao', function () {
      return function (input) {
        var situacao;

        switch (input) {

          case input = 'L':
            situacao = 'Liberado';
            break;
          case input = 'B':
            situacao = 'Bloqueado';
            break;
          case input = 'C':
            situacao = 'Cancelado';
            break;
        }

        return situacao;
      }
    });

  function administrador($rootScope, $scope, toastr, painelAdministradorFactory, paddingLeft, ajusteDatas, $uibModal, $http, layoutPaths, storageService) {

    $scope.currentPage = 1;
    $scope.log = {}
    $scope.parametrosIniciais = function () {
      $scope.mostrarCampo = true;
      $scope.ocultar = false;
      $scope.situacoes = [
        { id: "B", nome: "Bloqueado" },
        { id: "C", nome: "Cancelado" },
        { id: "L", nome: "Liberado" }
      ];
      $rootScope.showDetails = true;
      $scope.factoring = {};
      $scope.tituloIcone = 'Incluir nova factoring';
    }

    $scope.parametrosIniciaisLog = function(){
      $scope.log.mesReferencia = new Date().getMonth() + 1
      $scope.log.anoReferencia = new Date().getFullYear()
      $scope.montarData($scope.log.mesReferencia, $scope.log.anoReferencia);
      $rootScope.showDetails = true;
      $scope.ocultar = false;
    }

    $scope.open = function (page, size, opcao) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope
      });

      // promise
      modalInstance.result.then(function success() {
        if (opcao.toLowerCase() == 'excluir') {
          $scope.excluirTituloRemessa($scope.remessaItem);
        } else if (opcao.toLowerCase() == 'salvar') {
          $scope.ocultar = true;
        }
      }, function error() {
        $scope.ocultar = false;
      });
    };

    $scope.alteraIcone = function () {
      if ($scope.ocultar == false) {
        $scope.ocultar = true;
        $scope.tituloIcone = 'Cancelar inclusão';
        $scope.acionarFocoBotao = true;
      } else {
        $scope.factoring = {};
        $scope.rest('cancelar');
        $scope.tituloIcone = 'Incluir nova factoring';
        $scope.ocultar = false;
        $scope.acionarFocoBotao = false;
      };
    };

    $scope.mudarSituacao = function () {
      $scope.factoring.situacao = "L";
    }

    $scope.salvarDadosFactoring = function () {

      if ($scope.factoring.situacao != undefined && $scope.factoring.situacao != '' &&
        $scope.factoring.nome != undefined &&
        ($scope.factoring.senha != undefined || $scope.factoring.senha == undefined && $scope.mostrarCampo == false)) {

        $rootScope.loading = true;
        painelAdministradorFactory.postPainelAdministradorFactory($scope.factoring).then(function (response) {
          $scope.factorings = response.retornoFactorings.sdtFactoringsItem;
          $scope.factoringOrdena = $scope.factorings;
          $rootScope.loading = false;
          if (response.retornoFactorings.status == true) {
            toastr.success(response.retornoFactorings.mensagem, { timeOut: 1200 });
            $scope.factoring = {};
            $scope.ocultar = false;
          } else {
            toastr.error(response.retornoFactorings.mensagem, { timeOut: 1200 });
          }

          $scope.rest('salvar');
        }, function (response) {
          $rootScope.loading = false;
          $scope.ocultar = true;
          toastr.error('Falha de conexão', { timeOut: 1200 });
        });
      } else {
        $scope.factoringForm.nome.$touched = true;
        $scope.factoringForm.senha.$touched = true;
      };
      $scope.mostrarCampo = true;
    }//fim função salvarDadosFactoring

    $scope.buscaFactoringCadastradas = function () {
      $rootScope.loading = true;
      painelAdministradorFactory.getPainelAdministradorFactory().then(function (response) {
          $scope.factorings = response.factorings.sdtFactoringsItem;
          $scope.factoringOrdena = $scope.factorings;

          //Paginação dos itens em grade
          $scope.pageSize = 10;
          $scope.totalItens = $scope.factoringOrdena.length;
          $scope.qtdPages = Math.ceil($scope.factoringOrdena.length / $scope.pageSize);
          $scope.currentPage = 1;
          $scope.maxSize = 6;
          $rootScope.loading = false;

        }, function (response) {
          $scope.ocultar = false;
          toastr.error('Falha de conexão.', { timeOut: 1200 });
          $rootScope.loading = false;
        });
    } //fim função buscaFactoringCadastradas        

    $scope.editarFactoring = function (item) {
      $scope.tituloIcone = 'Cancelar alteração';
      $scope.mostrarCampo = false;
      $scope.ocultar = true;
      $scope.factoring.codigo = item.codigo;
      $scope.factoring.senha = item.senha;
      $scope.factoring.nome = item.nome;
      $scope.factoring.baseNuvem = item.baseNuvem;

      $scope.factoring.situacao = item.situacao;
      $scope.factoring.identificador = item.identificador;

    } //fim função editarFactoring

    $scope.excluirBaseClientesFactoring = function (item) {
      //Verificar se existe Empresa cadastrada para esta Factoring
      painelAdministradorFactory.viewPainelAdministradorFactory(item.codigo).then(function (response) {
          if (response.retornoValidacao) {
            $rootScope.codigo = item.codigo;
            $scope.open('app/pages/painel_decisao/painel.administrador.validarExclusaoBase.html', 'item');
          } else {
            toastr.error('Não existe dados vinculados à Empresa.', { timeOut: 1200 });
          };
        }, function (response) {
          toastr.error('Falha na conexão.', { timeOut: 1200 });
        });
    }//fim função excluirBaseclientesFactoring

    $scope.excluirBase = function (validar) {
      if (validar) {
        $rootScope.loading = true;
        painelAdministradorFactory.deletePainelAdministradorFactory($rootScope.codigo).then(function (response) {
            if (response.retornoValidacao) {
              toastr.success('Dados excluídos com sucesso.', { timeOut: 1200 });
              $rootScope.loading = false;
            };
          }, function (response) {
            toastr.error('Falha na conexão.', { timeOut: 1200 });
            $rootScope.loading = false;
          });
      };

    }//fim função excluirBase

///////////// Controle do Log///////////////

    $scope.log.mes = [
      {id: 1, nome:'JANEIRO'},
      {id: 2, nome:'FEVEREIRO'},
      {id: 3, nome:'MARÇO'},
      {id: 4, nome:'ABRIL'},
      {id: 5, nome:'MAIO'},
      {id: 6, nome:'JUNHO'},
      {id: 7, nome:'JULHO'},
      {id: 8, nome:'AGOSTO'},
      {id: 9, nome:'SETEMBRO'},
      {id: 10, nome:'OUTUBRO'},
      {id: 11, nome:'NOVEMBRO'},
      {id: 12, nome:'DEZEMBRO'},
    ]

    $scope.log.ano = [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2
    ]

    $scope.montarData = function(itemMes, itemAno){
      $scope.dataLog = "01/"+itemMes+"/"+itemAno
      $scope.buscarLog();
    }

    $scope.buscarLog = function(){
      $rootScope.loading = true;
       $http.post(layoutPaths.urlAPI.buscarLog, '{"DataLog": ' + angular.toJson($scope.dataLog) + '}', { headers: { 'Authorization': storageService.getToken() } } )
       .then(function(response){
        if (response.data.sdtRetornaLog){
          $scope.logs = response.data.sdtRetornaLog;
          $scope.logOrdena = $scope.logs    

          $scope.pageSize = 10;
          $scope.totalItens = $scope.logOrdena.length;
          $scope.qtdPages = Math.ceil($scope.logOrdena.length / $scope.pageSize);
          $scope.currentPage = 1;
          $scope.maxSize = 6;
          $rootScope.loading = false;

          }
       })
    }
 
    $scope.diferenca = function(item){
      if(item < 0){
        return "R"; // Red
      }else{
        return "G"; // Green
      }
    }

    $scope.detalharCli = function(item){

      if(!$scope.ocultar){
        $scope.infoEmp = {};
        $scope.infoEmp.dataLog = $scope.dataLog;
        $scope.infoEmp.empFacCod = item.LogEmpFacCod;
      }

      $http.post(layoutPaths.urlAPI.detalharLog, '{"infoEmp": ' + angular.toJson($scope.infoEmp) + '}' , { headers: { 'Authorization': storageService.getToken() } } )
      .then(function(response){
        if(response.data.sdtRetornaLog.sdtRetornaDetalhes.length != 0){
            if(!$scope.ocultar){
            $scope.ocultar = true;
            $scope.detalhes = response.data.sdtRetornaLog.sdtRetornaDetalhes;
            $scope.detalhesOrdena = $scope.detalhes;

            $scope.empNom = item.LogEmpNom;

            $scope.pageSize = 10;
            $scope.totalItens = $scope.detalhesOrdena.length;
            $scope.qtdPages = Math.ceil($scope.detalhesOrdena.length / $scope.pageSize);
            $scope.currentPage = 1;
            $scope.maxSize = 6;
            $rootScope.loading = false;
            
          }else{
            $scope.ocultar = false;
          }
        }else{
          $scope.ocultar = false;
          toastr.warning('Não há clientes ativos nesse período para a empresa ' + item.LogEmpNom + '.', { timeOut: 1500 })
        }
      })        
    }
/////////////////////////////////////////////////////////////////////////////////////////

    $scope.rest = function (opcao) {
      if ($scope.factoringForm) {

        $scope.factoringForm.nome.$untouched = true;
        $scope.factoringForm.nome.$touched = false;

        $scope.factoringForm.senha.$untouched = true;
        $scope.factoringForm.senha.$touched = false;

        $scope.factoringForm.identificador.$untouched = true;
        $scope.factoringForm.identificador.$touched = false;

        $scope.factoringForm.$setPristine();
      }
    }

  }//fim função Administrador
})();
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('removerController', removerController);

  /** @ngInject */
  function removerController($scope, $rootScope, $http, layoutPaths, toastr) {

    $scope.excluirFactoring = function(opcao){
        if(opcao){
            $http.post(layoutPaths.urlAPI.removerEmpresa, '{"codigo": ' +  angular.toJson($rootScope.codigo) + '}')            
                .then(function(response) {
                    $rootScope.factorings = response.data.retornoFactorings.sdtFactoringsItem;
                    $rootScope.factoringOrdena =  $rootScope.factorings;

                    if (response.data.retornoFactorings.status == true){
                        toastr.success(response.data.retornoFactorings.mensagem, {timeOut: 1200});
                   
                    } else{
                    toastr.error('Empresa não pode ser excluída.', {timeOut: 1200});
                    }
                   
                }, function(response) {  
                    toastr.error('Falha na conexão.', {timeOut: 1200});
            });
        }
    }  
  } //fim função removerController
})(); 

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelInicioController', InicioController);

  /** @ngInject */
  function InicioController($http, $scope, $interval, $state, stopableInterval, $rootScope, storageService, layoutPaths, toastr) {

    if(storageService.getToken() == ''){
      $state.go('empresa.login')
    }

    $rootScope.showDetails = true;

    $scope.carteiraDup = [];
    $scope.carteiraPen = [];
    $rootScope.posicaoCarteira = "";    

    $scope.nomeFactoring = storageService.getNomeEmpresa();

    //Capturo as permições de gráfico
    $scope.perGrafico = storageService.getPerGrafico();

    //Organizo cada uma das permições
    $scope.liquidez = $scope.perGrafico.substr(0,1);
    $scope.limite = $scope.perGrafico.substr(1,1);
    $scope.titAberto = $scope.perGrafico.substr(2,1);
    $scope.titMeses = $scope.perGrafico.substr(3,1);

    $scope.labels = [];
    $scope.buscaOperacoesUltimosAnos = function () {
      $rootScope.loading = true;
      $http.post(layoutPaths.urlAPI.buscaOperacoesRealizadas, {}, { headers: { 'Authorization': storageService.getToken() }})
        .then(function (response) {
          $scope.retornoMes = response.data.retornaOperacoesRealizadas;

          var retornoPosicao = response.data.retornaPosicaoCarteira;
          $scope.carteiraDup = [
            { "descricao": "Títulos em Aberto", "qtde": retornoPosicao.dTitAbeQtd, "valor": retornoPosicao.dTitAbeVlr },
            { "descricao": "Títulos Vencidos", "qtde": retornoPosicao.dTitVenQtd, "valor": retornoPosicao.dTitVenVlr },
            { "descricao": "Títulos A Vencer", "qtde": retornoPosicao.dTitAvenQtd, "valor": retornoPosicao.dTitAvenVlr },
            { "descricao": "Títulos Liquidados nos últimos 15 dias", "qtde": retornoPosicao.dTitLiqQtd, "valor": retornoPosicao.dTitLiqVlr }
            //   { "descricao": "Cheques em Aberto", "qtde": retornoPosicao.cTitAbeQtd, "valor": retornoPosicao.cTitAbeVlr },
            //   { "descricao": "Cheques Vencidos", "qtde": retornoPosicao.cTitVenQtd, "valor": retornoPosicao.cTitVenVlr },
            //   { "descricao": "Cheques A Vencer", "qtde": retornoPosicao.cTitAvenQtd, "valor": retornoPosicao.cTitAvenVlr },            
            //   { "descricao": "Cheques Reapresentados", "qtde": retornoPosicao.cTitReaQtd, "valor": retornoPosicao.cTitReaVlr },
            //   { "descricao": "Cheques Liquidados nos últimos 15 dias", "qtde": retornoPosicao.cTitLiqQtd, "valor": retornoPosicao.cTitLiqVlr }            
          ];

          $scope.carteiraPen = [
            { "descricao": "Títulos em Cartório", "qtde": retornoPosicao.dTitCarQtd, "valor": retornoPosicao.dTitCarVlr },
            { "descricao": "Títulos Devolvidos", "qtde": retornoPosicao.dTitDevQtd, "valor": retornoPosicao.dTitDevVlr },
            { "descricao": "Títulos Prorrogados", "qtde": retornoPosicao.dTitProQtd, "valor": retornoPosicao.dTitProVlr },
            { "descricao": "Títulos Protestados", "qtde": retornoPosicao.dTitPrtQtd, "valor": retornoPosicao.dTitPrtVlr }
          ];

          $scope.dataUltAtu = response.data.retornaOperacoesRealizadas.dataUltAtu;
          $scope.horaUltAtu = response.data.retornaOperacoesRealizadas.horaUltAtu;
          $scope.limNegativo = false;
          if(Math.sign(response.data.retornaOperacoesRealizadas.saldoCliente) != -1){
            $scope.limiteDisponivel = (response.data.retornaOperacoesRealizadas.saldoCliente * 1).toLocaleString("pt-BR");
          }else{
            $scope.limNegativo = true;
            $scope.limiteDisponivel = (response.data.retornaOperacoesRealizadas.saldoCliente * -1).toLocaleString("pt-BR");
          };
          $scope.valorLiquidez = response.data.retornaOperacoesRealizadas.valorLiquidez;

          //Apresentando o label referente aos meses
          $scope.posicao1 = $scope.retornoMes.labelMes.slice(1, 7);
          $scope.posicao2 = $scope.retornoMes.labelMes.slice(10, 16);
          $scope.posicao3 = $scope.retornoMes.labelMes.slice(19, 25);
          $scope.posicao4 = $scope.retornoMes.labelMes.slice(28, 34);
          $scope.posicao5 = $scope.retornoMes.labelMes.slice(37, 43);
          $scope.posicao6 = $scope.retornoMes.labelMes.slice(46, 52);
          $scope.posicao7 = $scope.retornoMes.labelMes.slice(55, 61);
          $scope.posicao8 = $scope.retornoMes.labelMes.slice(64, 70);
          $scope.posicao9 = $scope.retornoMes.labelMes.slice(73, 79);
          $scope.posicao10 = $scope.retornoMes.labelMes.slice(82, 88);
          $scope.posicao11 = $scope.retornoMes.labelMes.slice(91, 97);
          $scope.posicao12 = $scope.retornoMes.labelMes.slice(100, 106);

          $scope.labels = [$scope.posicao1, $scope.posicao2, $scope.posicao3, $scope.posicao4, $scope.posicao5, $scope.posicao6, $scope.posicao7, $scope.posicao8, $scope.posicao9, $scope.posicao10, $scope.posicao11, $scope.posicao12];

          //Apresentando o resultado do gráfico

          var tam = $scope.retornoMes.resultadoGrafico.length;
          var string = $scope.retornoMes.resultadoGrafico;
          var separador = "|";
          var contador = 0;
          var character = "";
          var novaString = "";
          var cont = 0;
          $scope.teste = [];

          while (contador < tam) {
            character = string.substring(contador, contador + 1)

            if (character != "|") {
              novaString += character;
            } else {
              $scope.teste[cont] = novaString;
              novaString = "";
              cont += 1;
            }
            contador += 1
          }

          $scope.posicao1 = $scope.teste[0];
          $scope.posicao2 = $scope.teste[1];
          $scope.posicao3 = $scope.teste[2];
          $scope.posicao4 = $scope.teste[3];
          $scope.posicao5 = $scope.teste[4];
          $scope.posicao6 = $scope.teste[5];
          $scope.posicao7 = $scope.teste[6];
          $scope.posicao8 = $scope.teste[7];
          $scope.posicao9 = $scope.teste[8];
          $scope.posicao10 = $scope.teste[9];
          $scope.posicao11 = $scope.teste[10];
          $scope.posicao12 = $scope.teste[11];

          $scope.data = [[$scope.posicao1, $scope.posicao2, $scope.posicao3, $scope.posicao4, $scope.posicao5, $scope.posicao6, $scope.posicao7, $scope.posicao8, $scope.posicao9, $scope.posicao10, $scope.posicao11, $scope.posicao12]
            .map(function (e) {
              return e;// * 25 + 25;
            })];
          $rootScope.loading = false;
        }, function (response) {
          toastr.error('Falha de conexão.', { timeOut: 1200 });
          $rootScope.loading = false;
        }
        );
    }

    $scope.visualizarTitulos = function (item) {
      $rootScope.posicaoCarteira = item.descricao;

      $state.go('empresa.titulosOperacao');
    }

  }
})();
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelGraficoController', GraficoController);

  /** @ngInject */
  function GraficoController($rootScope, $scope, baConfig, $http, storageService, layoutPaths, toastr) {
    $rootScope.showDetails = true;
    $scope.doughnutData = [];
    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    $scope.color = baConfig.colors.dashboard;

    $rootScope.loading = true;
    $http.post(layoutPaths.urlAPI.buscaDocumentosAberto, {}, { headers: { 'Authorization': storageService.getToken() } })
      .then(function (response) {

        $scope.doughnutData = response.data.retornaDocumentosAbertos.sdtDocumentosAbertos;
        $scope.totalAberto = response.data.retornaDocumentosAbertos.contaValorAberto;
    
        var ctx = document.getElementById('chart-area').getContext('2d');
        window.myDoughnut = new Chart(ctx).Doughnut($scope.doughnutData, {
          segmentShowStroke: false,
          percentageInnerCutout: 64,
          responsive: false,
          animateScale: true,
        });
        $rootScope.loading = false;
      }, function (response) {
        toastr.error('Falha de conexão.', { timeOut: 1200 });
        $rootScope.loading = false;
      }
      );
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelTituloCtrl', TitulosOperacao);

    /** @ngInject */
    function TitulosOperacao($scope, toastr, $rootScope, $state, painelTitulosOperacaoFactory) {

        $scope.pageSize = '10';
        if ($rootScope.posicaoCarteira) {
            // $scope.tituloCarteira = $rootScope.posicaoCarteira.descricao + ' - ' + $rootScope.posicaoCarteira.definicaoCarteira;
            $scope.tituloCarteira = $rootScope.posicaoCarteira;
        } else {
            $state.go('inicio');
        }

        $scope.titulosOperacao = [];

        if ($rootScope.posicaoCarteira) {
            $rootScope.loading = true;
            painelTitulosOperacaoFactory.getPainelTitulosOperacaoFactory($rootScope.posicaoCarteira)
                .then(function (response) {
                    if (response.retornaTitulosCarteira.status) {
                        $scope.titulosOperacao = response.retornaTitulosCarteira.sdtRetornaTitulosPosicaoCarteiraItem;
                        $scope.titulosOperacaoOrdena = $scope.titulosOperacao;    
                    }
                    
                    $rootScope.loading = false;
                }, function (response) {
                    $rootScope.loading = false;
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                });    
        };

        $scope.titulosOperacaoOrdena = $scope.titulosOperacao;
        $scope.totalItens = $scope.titulosOperacaoOrdena.length;
        $scope.qtdPages = Math.ceil($scope.titulosOperacaoOrdena.length / $scope.pageSize);

        $scope.currentPage = 1;
        $scope.maxSize = 6;
        $scope.mensagemVazio = "";

    }


})();  
(function () {
    angular.module('DifactWeb.pages').factory("painelTitulosOperacaoFactory", painelTitulosOperacaoFactory);

    function painelTitulosOperacaoFactory(layoutPaths, storageService, $http) {

        var factory = {
            getPainelTitulosOperacaoFactory: getPainelTitulosOperacaoFactory,
        }
        return factory;

        function getPainelTitulosOperacaoFactory(titulos) {
            return $http.post(layoutPaths.urlAPI.titulosPosicaoCarteira, '{"posicaoCarteira":' + angular.toJson(titulos)  + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response.data;
            });        
        }
    };    
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'painelGraficoController',
      templateUrl: 'app/pages/painel_inicio/painel.inicio.grafico.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelFactoringController', factoring);

  function factoring($scope, FileUploader, painelFactoringFactory, $rootScope, toastr, layoutPaths, storageService) {
    $rootScope.showDetails = true;
    $scope.desabilitarItem = false;
    $scope.factoring = {};
    painelFactoringFactory.getPainelFactoringFactory().then(function (response) {
      $scope.empresa = response.sdtRetornaEmpresa;
      $scope.factoring = response.sdtRetornaEmpresa;
      $scope.pegarValor($scope.factoring.modeloImpressao);
    }
    );

    $scope.tipoImpressao = [{
      title: 'modoGrafico',
      value: 'G',
      nome: 'Modo Gráfico'
    }, {
      title: 'modoWord',
      value: 'W',
      nome: 'Modo Word'
    }];


    $scope.remover = function () {
      $scope.desabilitarItem = false;
    }

    $scope.pegarValor = function (item) {
      if (item == "G") {
        $scope.bloqueiaDuplicata = true;
        $scope.bloqueiaBordero = false;
        $scope.esconderTermo = false;
        $scope.esconderBordero = false;
        $scope.esconderRecibo = false;

      } else {
        $scope.bloqueiaDuplicata = false;
        $scope.bloqueiaBordero = true;
        $scope.esconderTermo = true;
        $scope.esconderBordero = true;
        $scope.esconderRecibo = true;
      }

    }

    $scope.salvarConfiguracoes = function () {
      $rootScope.loading = true;
      painelFactoringFactory.postPainelFactoringFactory($scope.factoring).then(function (response) {
        $scope.factoring = response.retornaEmpresa;
        if (response.retornaEmpresa.status) {
          toastr.success(response.retornaEmpresa.mensagem, { timeOut: 1200 });
        } else {
          toastr.error(response.retornaEmpresa.mensagem, { timeOut: 1200 });
        }
        $rootScope.loading = false;
      }, function (response) {
        toastr.error('Falha de conexão.', { timeOut: 1200 });
        $rootScope.loading = false;
      }
      );
    }
    
    var uploader = $scope.uploader = new FileUploader(
    
      {
        url: layoutPaths.urlAPI.carregarArquivo,
        headers: {
          'Authorization': storageService.getToken()}
      });

    uploader.filters.push({
      name: 'customFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        return this.queue.length < 10;
      }
    });

    // CALLBACKS
    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
      //console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
      // console.info('Inclusão do arquivo', fileItem);
    };

    uploader.onBeforeUploadItem = function (item) {
      //console.info('onBeforeUploadItem', item);
    };

    uploader.onProgressItem = function (fileItem, progress) {
      //console.info('onProgressItem', fileItem, progress);
    };

    uploader.onProgressAll = function (fileItem, progress) {
    };

    uploader.onErrorItem = function (fileItem, response, status, headers) {
      //console.info('Erro de importação', fileItem, response, status, headers);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers);
      $scope.retorno = response.object_id;
      $scope.desabilitarItem = true;

      var data = '{"caminho": ' + angular.toJson($scope.retorno.replace("gxupload:", "")) + '}';
      $scope.ativaLoading = true;
      
      painelFactoringFactory.uploadPainelFactoringFactory($scope.retorno).then(function (response) {
          $scope.ativaLoading = false;
        }, function (response) {
          toastr.error('Falha de conexão.', { timeOut: 1200 });
          $rootScope.loading = false;
        });
    }

    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      fileItem.isSucess = true;
    };

    uploader.onErrorItem = function (fileItem, response, status, headers) {
      fileItem.isSucess = false;
    };

    uploader.onCancelItem = function (fileItem, response, status, headers) {
      // console.info('onCancelItem', fileItem, response, status, headers);
    };

  } //fim função factoring
})(); 
(function () {
    angular.module('DifactWeb.pages').factory("painelFactoringFactory", painelFactoringFactory);

    function painelFactoringFactory(layoutPaths, storageService, $http) {

        var factory = {
            postPainelFactoringFactory: postPainelFactoringFactory,
            getPainelFactoringFactory: getPainelFactoringFactory,
            uploadPainelFactoringFactory: uploadPainelFactoringFactory,
        }
        return factory;

        function postPainelFactoringFactory(dadosFactoring) {
            return $http.post(layoutPaths.urlAPI.salvarConfiguracoes, '{"configuracao": ' + angular.toJson(dadosFactoring) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response.data;
            });        
        }

        function getPainelFactoringFactory() {
            return $http.post(layoutPaths.urlAPI.carregarEmpresa, {}, { headers: { 'Authorization': storageService.getToken() }}).then(function(response){
                return response.data;
            });        
        }

        function uploadPainelFactoringFactory(arquivo) {
            return  $http.post(layoutPaths.urlAPI.uploadArquivo, '{"caminho": ' + angular.toJson(arquivo.replace("gxupload:", "")) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response){
                return response.data;
            });        
        }
      
    };    
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
  "use strict";

  angular
    .module("DifactWeb.pages")
    .controller("painelOperacaoController", Operacao);

  /** @ngInject */
  function Operacao($scope, toastr, layoutPaths, retornaOperacoes,  $rootScope, painelOperacaoFactory, painelEmissaoBoletoFactory, $stateParams, storageService) {
  
    $scope.cont = 0
    function myTimer() {
      $scope.buscarOperacaoBoleto();
    }

    function myStopFunction() {
      clearInterval($scope.tempo);
    }

    if (retornaOperacoes.operacoes.status) {
      $scope.operacaoOrdena = retornaOperacoes.operacoes.sdtOperacoesItem;
      $scope.emiteBoleto = retornaOperacoes.operacoes.emiteBoleto;
      $scope.parametroFactoring =
        retornaOperacoes.operacoes.sdtFactoringParametro;

      if ($scope.parametroFactoring.tipoImpressaoTermo == "G") {
        if (
          $scope.parametroFactoring.imprimeTermo ||
          $scope.parametroFactoring.imprimeRecibo ||
          $scope.parametroFactoring.imprimeBordero
        ) {
          $scope.habilitaTermo = true;
        } else {
          $scope.habilitaTermo = false;
        }

        $scope.ocultarModoGrafico = true;
        $scope.ocultarAditivo = false;
        $scope.ocultarRecibo = false;
        $scope.ocultarDuplicata = false;

      } else {
        $scope.ocultarModoGrafico = false;

        if ($scope.parametroFactoring.imprimeTermo) {
          $scope.ocultarAditivo = true;
        } else {
          $scope.ocultarAditivo = false;
        }

        if ($scope.parametroFactoring.imprimeRecibo) {
          $scope.ocultarRecibo = true;
        } else {
          $scope.ocultarRecibo = false;
        }

        if ($scope.parametroFactoring.imprimeCartaSacado) {
          $scope.ocultarCartaSacado = true;
        } else {
          $scope.ocultarCartaSacado = false;
        }

        if (
          $scope.parametroFactoring.imprimeDuplicata &&
          $scope.parametroFactoring.tipoImpressaoTermo == "W"
        ) {
          $scope.ocultarDuplicata = true;
        } else {
          $scope.ocultarDuplicata = false;
        }
      }

      $scope.buscarOperacaoBoleto = function () {
        painelOperacaoFactory.getPainelOperacaoFactory().then(
          function (response) {
            //console.log($scope.cont + " BOLETO", response);
            if (response.operacoes.opeStatBol != "EB") {
              myStopFunction();
              $rootScope.bloquearTela = false;
              $rootScope.mensagemTela = "";
              if ($scope.dadosTitulo) {
                //Abrir documento gerado
                var tamanho = response.operacoes.sdtOperacoesItem.length;
                var contador = 0;
                var existe = false;
                var geraPdf = false;
                while (contador < tamanho) {
                
                  if (
                    response.operacoes.sdtOperacoesItem[contador].numero ==
                      $scope.dadosTitulo.opeNumero &&
                    response.operacoes.sdtOperacoesItem[contador].opeDocBol !=
                      ""

                  ) {

                    geraPdf = true;

                    var dlnk = document.getElementById("dwnldLnk");
                    dlnk.href =
                      response.operacoes.sdtOperacoesItem[contador].opeDocBol;
                    dlnk.click();
                    break;
                  }
                  
                  if(response.operacoes.sdtOperacoesItem[contador].opeMsgErr != '' && response.operacoes.sdtOperacoesItem[contador].numero ==
                  $scope.dadosTitulo.opeNumero){
                    $scope.msgErr = response.operacoes.sdtOperacoesItem[contador].opeMsgErr;
                  break;
                }
                  contador++;

                }

                if (!geraPdf) {
                  if($scope.msgErr != ''){
                  toastr.error($scope.msgErr + ' Verificar junto a empresa ' +
                  storageService.getNomeFactoring() + '.',
                    { timeOut: 4500 }
                  );
                }else{
                  toastr.error(
                    "Boleto não pode ser gerado. Verificar junto a empresa " +
                      storageService.getNomeFactoring() +
                      " as configurações necessárias do cliente para emissão do boleto.",
                    { timeOut: 4500 }
                  );
                }
                }
              }
            } else {
              $scope.cont += 1;
              if ($scope.cont >= 200) {
                $scope.cont = 0;
                myStopFunction();
                painelOperacaoFactory.postPainelAtualizaStatusOperacaoFactory($scope.dadosTitulo)
                  .then(function (response) {
                      $rootScope.bloquearTela = false;
                      toastr.error(
                        "Não foi possível conectar com a Empresa " +
                        storageService.getNomeFactoring() + ' - ' + $scope.dadosTitulo.titDocBase,
                        { timeOut: 4500 }
                      );
                      $rootScope.loading = false;
                    },
                    function(error) {
                      $rootScope.loading = false;
                      $scope.mensagemVazio = "";
                      toastr.error("Falha de conexão.", { timeOut: 1200 });
                      $rootScope.bloquearTela = false;
                      $rootScope.mensagemTela = "";
                    }
                  );
                }
              }
            },
          function(response) {
            $rootScope.loading = false;
            $scope.mensagemVazio = "";
            toastr.error("Falha de conexão.", { timeOut: 1200 });
            $rootScope.bloquearTela = false;
            $rootScope.mensagemTela = "";
          }
        );
      };

      $scope.numeroMod = function() {
        numeroAltera = true;
      };
      $scope.operacoes = $scope.operacaoOrdena;
      if ($scope.operacaoOrdena) {
        $scope.pageSize = 10;
        $scope.totalItens = $scope.operacaoOrdena.length;
        $scope.qtdPages = Math.ceil(
          $scope.operacaoOrdena.length / $scope.pageSize
        );
        $scope.currentPage = 1;
        $scope.maxSize = 6;
        $scope.mensagemVazio = "";
      }
    } else {
      $scope.mensagemVazio = retornaOperacoes.operacoes.mensagem;
    }

    $rootScope.showDetails = true;
    $scope.operacoes = [];

    $scope.imprimirBoleto = function(item) {
      $scope.dadosTitulo = {};
      $scope.dadosTitulo.opeNumero = item.numero;
      $scope.dadosTitulo.titDocBase = item.opeBase
      $scope.cont = 0;

      painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory().then(
        function(response) {
          $scope.servidorDisponivel =
            response.monitoraDisponivel.monitoraDisponivel;
          $rootScope.loading = true;
          $scope.dadosTitulo.monitoraDisponivel = $scope.servidorDisponivel;
          painelOperacaoFactory.postPainelGeraBoletoOperacaoFactory($scope.dadosTitulo)
            .then(
              function(response) {
                //console.log(response);
                if (response.retorno.status) {
                  if ($scope.servidorDisponivel) {
                    $rootScope.bloquearTela = true;
                    $rootScope.mensagemTela =
                      "Gerando 2ª via do Boleto. Aguarde conexão com a Empresa...";
                    $scope.tempo = setInterval(function() {
                      myTimer();
                    }, 5000);
                  } else {
                    toastr.error(
                      "Serviço indisponível. Para que esta requisição seja processada o sistema da empresa " +
                        storageService.getNomeFactoring() +
                        " deve estar ativo.",
                      { timeOut: 4000 }
                    );
                  }
                } else {
                  toastr.error(
                    "Operação selecionada não contém títulos para emissão de boleto",
                    { timeOut: 4000 }
                  );
                }
                //}
                $rootScope.loading = false;
              },
              function (response) {
                $rootScope.loading = false;
                toastr.error(
                  "Falha ao gerar boleto da operação. Entre em contato com a empresa " +
                  storageService.getNomeFactoring() +
                    ".",
                  { timeOut: 2500 }
                );
              }
            );
        },
        function(response) {
          toastr.error(
            "Falha ao gerar boleto da operação. Entre em contato com a empresa " +
            storageService.getNomeFactoring() +
              ".",
            { timeOut: 2500 }
          );
        }
      );
    };

    $scope.abrirTermoModoGrafico = function(item) {
      $rootScope.loading = true;
      painelOperacaoFactory.visualizarTermo(item.numero).then(
        function(response) {
          $rootScope.loading = false;
          if (response.retornoDadosTermo.status) {
            $scope.cpfCliente = response.retornoDadosTermo.cpfCliente;
            $scope.urlArquivo =
              layoutPaths.urlAPI.abrirArquivo +
              "bordero/" +
              "bordero" +
              $stateParams.empfaccod.padStart(3,'0') +
              $stateParams.empcod.padStart(3,'0') +
              $scope.cpfCliente +
              ".pdf";
            window.open($scope.urlArquivo);
          } else {
            toastr.error(response.retornoDadosTermo.mensagem, {
              timeOut: 1200
            });
          }
        },
        function(response) {
          $rootScope.loading = false;
          toastr.error("Falha de conexão.", { timeOut: 1200 });
        }
      );
    };

    $scope.abrirTermo = function(item, opcao) {
      $scope.CaminhoDoc = layoutPaths.urlAPI.buscarDocumentosWord;

      //Incluindo zeros a esquerda - Código da Empresa
      $scope.empcod = '"' + item.opeBase + '"';
      $scope.empcod = "000" + $scope.empcod.replace(/\D/g, "");
      $scope.empcod = $scope.empcod.slice(-3, -1) + $scope.empcod.slice(-1);

      //Incluindo zeros a esquerda - Código da Factoring
      $scope.empfaccod = '"' + item.empfac + '"';
      $scope.empfaccod = "000" + $scope.empfaccod.replace(/\D/g, "");
      $scope.empfaccod = $scope.empfaccod.slice(-3, -1) + $scope.empfaccod.slice(-1);

      //Incluindo zeros a esquerda - Cliente
        $scope.cliente = '"' + item.cliente + '"';
        $scope.cliente = "00000" + $scope.cliente.replace(/\D/g, "");
        $scope.cliente = $scope.cliente.slice(-5, -1) + $scope.cliente.slice(-1);
      

      //Incluindo zeros a esquerda - Operacao
      $scope.operacao = '"' + item.opeNumBase + '"';
      $scope.operacao = "000000" + $scope.operacao.replace(/\D/g, "");
      $scope.operacao =
        $scope.operacao.slice(-6, -1) + $scope.operacao.slice(-1);

      var http = new XMLHttpRequest();
      $scope.CaminhoPadrao =
        $scope.CaminhoDoc +
        $scope.empcod +
        $scope.empfaccod +
        $scope.cliente +
        $scope.operacao;
      switch (opcao) {
        case "aditivo":
          //Montando link do documento - Termo Aditivo
          $scope.ArqTermo = $scope.CaminhoPadrao + "TA.DOC";
          http.open("HEAD", $scope.ArqTermo, false);
          http.send();

          if (http.status != 404) {
            window.open($scope.ArqTermo);
          } else {
            $scope.ArqTermo = $scope.CaminhoPadrao + "TC.DOC";
            http.open("HEAD", $scope.ArqTermo, false);
            http.send();
            if (http.status != 404) {
              window.open($scope.ArqTermo);
            } else {
              toastr.warning("O termo desta operação não existe.", {
                timeOut: 1200
              });
            }
          }
          break;
        case "recibo":
          //Montando link do documento - Recibo
          $scope.ArqRecibo = $scope.CaminhoPadrao + "RQ.DOC";
          http.open("HEAD", $scope.ArqRecibo, false);
          http.send();

          if (http.status != 404) {
            window.open($scope.ArqRecibo);
          } else {
            toastr.warning("O Recibo desta operação não existe.", {
              timeOut: 1200
            });
          }
          break;
        case "duplicata":
          //Montando link do documento - Duplicatas
          $scope.ArqDuplicata = $scope.CaminhoPadrao + "CD.DOC";
          http.open("HEAD", $scope.ArqDuplicata, false);
          http.send();

          if (http.status != 404) {
            window.open($scope.ArqDuplicata);
          } else {
            toastr.warning("A duplicata desta operação não existe.", {
              timeOut: 1200
            });
          }
          break;
        case "carta ao sacado":
          $scope.ArqCartaSacado = $scope.CaminhoPadrao + "CS.DOC";
          http.open("Head", $scope.ArqCartaSacado, false);
          http.send();

          if(http.status != 404) {
            window.open($scope.ArqCartaSacado);
          } else {
            toastr.warning("A carta ao sacado desta operação não existe.", {
              timeOut: 1200
            });
          }
          break;
      }
    };
  }
})();

(function () {
    angular.module('DifactWeb.pages').factory("painelOperacaoFactory", painelOperacaoFactory);

    function painelOperacaoFactory(layoutPaths, storageService, $http) {

        var factory = {
            getPainelOperacaoFactory: getPainelOperacaoFactory,
            visualizarTermo: visualizarTermo,
            postPainelGeraBoletoOperacaoFactory: postPainelGeraBoletoOperacaoFactory,
            postPainelAtualizaStatusOperacaoFactory: postPainelAtualizaStatusOperacaoFactory,
        }
        return factory;

        function getPainelOperacaoFactory() {
            return $http.post(layoutPaths.urlAPI.buscarOperacoes, {}, { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response.data;
            });        
        }

        function visualizarTermo(numero) {
            return $http.post(layoutPaths.urlAPI.visualizarTermo, '{"numeroOperacao": ' + angular.toJson(numero) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response){
                return response.data;
            });        
        }

        function postPainelGeraBoletoOperacaoFactory(dadosTitulo) {
            return $http.post(layoutPaths.urlAPI.geraBoletoOperacao, '{"dadosTitulo":' + angular.toJson(dadosTitulo) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }
        
        function postPainelAtualizaStatusOperacaoFactory(dadosTitulo) {
            return $http.post(layoutPaths.urlAPI.atualizaStatusOperacao, '{"dadosTitulo":' + angular.toJson(dadosTitulo) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }
    };    
})();
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelRelatorioController', RelatorioController);

    /** @ngInject */
    function RelatorioController($uibModal, $scope, painelRelatorioFactory, $rootScope, toastr, $http, layoutPaths, ajusteDatas, $stateParams, storageService) {
        if(storageService.getToken() == ''){
            $state.go('empresa.login')
        }
        
        $scope.isOpen = false;
        $scope.selectedMode = 'md-scale';
        $scope.selectedDirection = 'left';
        $scope.nomeEmail = {};
        var permAtuSaldo = storageService.getPerFuncional();
        var permAtuSaldo = permAtuSaldo.substr(14,1)

        $scope.open = function (page, size, opcao) {
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: 5,
                scope: $scope,
                resolve: {
                    param: function () {
                        return $scope.data;
                    }
                }
            })
        };

        // $scope.openTipoRecebimento = function (page, size, opcao) {
        //     $scope.modalInstance = $uibModal.open({
        //         animation: true,
        //         templateUrl: page,
        //         size: size,
        //         scope: $scope
        //     })
        // };

        // $scope.visualizarRecebidos = function () {
        //     $scope.openTipoRecebimento('app/pages/painel_relatorio/tipo.recebimento.modal.html');
        // }


        $rootScope.showDetails = true;
        $scope.relatorio = {};
        $scope.parametrosIniciais = function () {
            $scope.relatorio.devolvidos = true;
            $scope.relatorio.prorrogados = true;
            $scope.relatorio.protestados = true;
            $scope.relatorio.cartorio = true
            $scope.relatorio.tipoSituacao = 'T';
            $scope.relatorio.tipoOperacao = 'OC';
            $scope.relatorio.tipoPeriodo = 0;
            $scope.relatorio.operacaoInicio = 0;
            $scope.relatorio.operacaoFinal = 999999;
            $scope.relatorio.dataInicio = new Date('01/01/1901');
            $scope.relatorio.dataFinal = new Date('12/31/9999');

            $scope.relatorio.emitePendencias = 0;
            $scope.relatorio.tipoDocumento = 0;
            $scope.relatorio.tipoRecebimento = 0;
            $scope.valorTipoOperacao($scope.relatorio.tipoOperacao);
            $scope.validaPendencias($scope.relatorio.emitePendencias);
            $scope.validaPeriodo($scope.relatorio.tipoPeriodo);
            if(permAtuSaldo == '0'){
                $scope.relatorio.atualizaVencidos = false;
                $scope.relatorio.atualizaVencer = false;
                $scope.desabilitaVencidos = true;
                $scope.desabilitaVencer = true;
            }
        }

        $scope.valorTipoOperacao = function (item) {
            if (item == 'OC' && permAtuSaldo != '0') {
                $scope.desabilitaVencidos = false;
                $scope.desabilitaVencer = false;
            } else {
                $scope.relatorio.atualizaVencidos = false;
                $scope.relatorio.atualizaVencer = false;
                $scope.desabilitaVencidos = true;
                $scope.desabilitaVencer = true;
            }
        }

        $scope.validaPendencias = function (item) {
            if (item == 1) {
                $scope.desabilitaCheckDevolvidos = true;
                $scope.desabilitaCheckProtestados = true;
                $scope.desabilitaCheckProrrogados = true;
                $scope.desabilitaCheckCartorio = true;
                $scope.relatorio.devolvidos = false;
                $scope.relatorio.prorrogados = false;
                $scope.relatorio.protestados = false;
                $scope.relatorio.cartorio = false;
            } else {
                $scope.desabilitaCheckDevolvidos = false;
                $scope.desabilitaCheckProtestados = false;
                $scope.desabilitaCheckProrrogados = false;
                $scope.desabilitaCheckCartorio = false;
                $scope.relatorio.devolvidos = true;
                $scope.relatorio.prorrogados = true;
                $scope.relatorio.protestados = true;
                $scope.relatorio.cartorio = true;
            }
        }

        $scope.validaPeriodo = function(item){
            if(item == 1){
                $scope.desabilitaRecebidos = false;
            } else{
                $scope.desabilitaRecebidos = true;
                $scope.relatorio.selectedRecebimentos = []
            }
        }

        $scope.tipoPeriodo = [{
            title: 'vencimento',
            value: 0,
            nome: 'Vencimento'
        }, {
            title: 'recebimento',
            value: 1,
            nome: 'Recebimento'
        }, {
            title: 'quitacao',
            value: 2,
            nome: 'Quitação'
        }
        ];
        $scope.tipoOperacao = [{
            title: 'convencional',
            value: 'OC',
            nome: 'Convencional'
        }, {
            title: 'trustee',
            value: 'OT',
            nome: 'Trustee'
        }
        ];
        $scope.tipoSituacao = [{
            title: 'vencidos',
            value: 'V',
            nome: 'Vencidos'
        }, {
            title: 'avencer',
            value: 'A',
            nome: 'A Vencer'
        }, {
            title: 'abertos',
            value: 'B',
            nome: 'Abertos'
        }, {
            title: 'quitados',
            value: 'Q',
            nome: 'Quitados'
        }, {
            title: 'todos',
            value: 'T',
            nome: 'Todos'
        }
        ];

        $scope.opcaoPendencia = [
            { id: 0, nome: "SIM" },
            { id: 1, nome: "NÃO" },
            { id: 2, nome: "SOMENTE PENDÊNCIAS" }
        ];

        $scope.opcaoDocumentos = [
            { id: 0, nome: "TODOS" },
            { id: 1, nome: "CHEQUE" },
            { id: 2, nome: "DUPLICATA" },
            { id: 3, nome: "DUPLICATA DE SERVIÇO" },
            { id: 4, nome: "NOTA PROMISSÓRIA" },
            { id: 5, nome: "NOTA PROMISSÓRIA RURAL" },
            { id: 6, nome: "CARTÃO DE CRÉDITO" },
            { id: 7, nome: "OUTROS" }
        ];

        // $scope.opcaoRecebimento = [
        //     'NO VENCIMENTO',
        //     'ANTECIPADO',
        //     'EM ATRASO',
        //     'POR RECOMPRA',
        //     'DE TERCEIROS',
        //     'DO SACADO NO CAIXA',
        //     'DO CLIENTE NO CAIXA',
        //     'DO CLIENTE NA OPERAÇÃO',
        //     'DO SACADO NO CARTÓRIO',
        //     'DO CLIENTE NO CARTÓRIO',
        //     'DO SACADO NO CLIENTE',
        //     'DEPÓSITO EM CONTA',
        //     'NO BANCO NO VENCIMENTO',
        //     'NO BANCO ANTECIPADO',
        //     'NO BANCO EM ATRASO'
        // ];

        $scope.relatorio.selectedRecebimentos= [];
        $scope.opcaoRecebimento = [
            { id: "RVC", nome: "NO VENCIMENTO"},
            { id: "RAN", nome: "ANTECIPADO"},
            { id: "RAT", nome: "EM ATRASO"},
            { id: "CRE", nome: "POR RECOMPRA"},
            { id: "RTE", nome: "DE TERCEIROS"},
            { id: "SCX", nome: "DO SACADO NO CAIXA"},
            { id: "CCX", nome: "DO CLIENTE NO CAIXA"},
            { id: "COP", nome: "DO CLIENTE NA OPERAÇÃO"},
            { id: "SCT", nome: "DO SACADO NO CARTÓRIO"},
            { id: "CCT", nome: "DO CLIENTE NO CARTÓRIO"},
            { id: "RSC", nome: "DO SACADO NO CLIENTE"},
            { id: "DCP", nome: "DEPÓSITO EM CONTA"},
            { id: "BVC", nome: "NO BANCO NO VENCIMENTO"},
            { id: "BAN", nome: "NO BANCO ANTECIPADO"},
            { id: "BAT", nome: "NO BANCO EM ATRASO"},
            { id: "NIF", nome: "NÃO INFORMADO"}
        ];

        $scope.validaRecebimento = function (obj) {                         
            if(obj.length == $scope.opcaoRecebimento.length){ 
                
                $scope.opcaoRecebimento.forEach(function(opcao) {                
                    obj = obj.splice(0, Number.MAX_VALUE)
                })
            }else{                
                $scope.opcaoRecebimento.forEach(function(opcao) { 
                    if(obj.indexOf(opcao.id) === -1 ) {                                    
                        obj.push(opcao.id)
                    }
                })
            }
            
            // obj = $scope.opcaoRecebimento;


            // if ($scope.selectedRecebimentos !== $scope.opcaoRecebimento) {                
            //     $scope.selectedRecebimentos = $scope.opcaoRecebimento
            //     console.log("cheio", $scope.selectedRecebimentos)
            // }
            // else {                
            //     $scope.selectedRecebimentos = ''
            //     console.log("vazio", $scope.selectedRecebimentos)
            // }
        }

        $scope.visualizarDados = function (tipoEnvio) {
            $scope.retorno = $scope.validarCampos(); //Validar campos
            if ($scope.retorno) {
                $scope.relatorio.tipoEnvio = tipoEnvio;

                $scope.relatorio.dtInicioFormatada = ajusteDatas.formatarData($scope.relatorio.dataInicio);
                $scope.relatorio.dtFinalFormatada = ajusteDatas.formatarData($scope.relatorio.dataFinal);

                $rootScope.loading = true;
                painelRelatorioFactory.getPainelRelatorioDisponivelFactory()
                .then(function (response) {
                    
                    $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel
                    $rootScope.loading = true;
                    
                    if (!$scope.servidorDisponivel) {
                        painelRelatorioFactory.getPainelRelatorioFactory($scope.relatorio).then(function (response) {
                            $scope.dadosExtrato = response.data.retornoDadosExtrato;
                            $rootScope.loading = false;

                            if ($scope.dadosExtrato.status) {
                                var http = new XMLHttpRequest();
                                switch (tipoEnvio) {
                                    case 'pdf':
                                        //Montando link do documento - Extrato da carteira PDF
                                        $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'extratodacarteira' + $stateParams.empfaccod + $stateParams.empcod.padStart(3,'0') + $scope.dadosExtrato.cnpjEmpresa + '.pdf'
                                        window.open($scope.urlArquivo);
                                        break;
                                    case 'txt':
                                        //Montando link do documento - Extrato da carteira TXT
                                        $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'DocumentosCarteira.txt';
                                        http.open('HEAD', $scope.urlArquivo, true);
                                        http.send();
                                        window.open($scope.urlArquivo);
                                        break;
                                    case 'csv':
                                        //Montando link do documento - Extrato da carteira CSV
                                        $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'ExcelTemplate.xls';
                                        http.open('HEAD', $scope.urlArquivo, false);
                                        http.send();
                                        window.open($scope.urlArquivo);
                                        break;
                                }

                            } else {
                                toastr.error($scope.dadosExtrato.mensagem);
                            }
                        }, function (response) {
                            $rootScope.loading = false;
                            toastr.error('Falha de conexão.');
                        }); 
                    } else {
                        painelRelatorioFactory.getPainelRelatorioSistemaFactory($scope.relatorio).then(function (response) {
                            $scope.dadosExtrato = response;
                            painelRelatorioFactory.getPainelRelSistemaFactory($scope.relatorio).then(function (response) {
                                $scope.dadosExtrato = response.retornoDadosExtrato;
                                $rootScope.loading = false;
                                if ($scope.dadosExtrato.status) {
                                    var http = new XMLHttpRequest();
                                    switch (tipoEnvio) {
                                        case 'pdf':
                                            //Montando link do documento - Extrato da carteira PDF
                                            $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'extratodacarteira' + $stateParams.empfaccod + $stateParams.empcod.padStart(3,'0') + $scope.dadosExtrato.cnpjEmpresa + '.pdf'
                                            window.open($scope.urlArquivo);
                                            break;
                                        case 'txt':
                                            //Montando link do documento - Extrato da carteira TXT
                                            $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'DocumentosCarteira.txt';
                                            http.open('HEAD', $scope.urlArquivo, true);
                                            http.send();
                                            window.open($scope.urlArquivo);
                                            break;
                                        case 'csv':
                                            //Montando link do documento - Extrato da carteira CSV
                                            $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'ExcelTemplate.xls';
                                            http.open('HEAD', $scope.urlArquivo, false);
                                            http.send();
                                            window.open($scope.urlArquivo);
                                            break;
                                    }
            
                                } else {
                                    toastr.error($scope.dadosExtrato.mensagem);
                                }
                            }, function (response) {
                                $rootScope.loading = false;
                                toastr.error('Falha de conexão.');
                            }); 
                        }, function (response) {
                            $rootScope.loading = false;
                            toastr.error('Falha de conexão.');
                        });  
                    }
                }, function (response) {
                    toastr.error('Falha ao gerar relatorio. Entre em contato com a empresa ' +  storageService.getNomeFactoring() + '.', { timeOut: 2500 });
                });           
            } else {
                toastr.error($scope.mensagem, { timeOut: 1500 });
            }
        };

        $scope.visualizarDadosSistema = function (tipoEnvio) {
            $scope.retorno = $scope.validarCampos(); //Validar campos
            if ($scope.retorno) {
                $scope.relatorio.tipoEnvio = tipoEnvio;

                $scope.relatorio.dtInicioFormatada = ajusteDatas.formatarData($scope.relatorio.dataInicio);
                $scope.relatorio.dtFinalFormatada = ajusteDatas.formatarData($scope.relatorio.dataFinal);

                $rootScope.loading = true;
                painelRelatorioFactory.getPainelRelatorioSistemaFactory($scope.relatorio).then(function (response) {
                    $scope.dadosExtrato = response;
                    $rootScope.loading = false;
                    $scope.visualizarDados();
                    // if ($scope.dadosExtrato.status) {
                    //     var http = new XMLHttpRequest();
                    //     switch (tipoEnvio) {
                    //         case 'pdf':
                    //             //Montando link do documento - Extrato da carteira PDF
                    //             $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'extratodacarteira' + $stateParams.empfaccod + $stateParams.empcod.padStart(3,'0') + $scope.dadosExtrato.cnpjEmpresa + '.pdf'
                    //             window.open($scope.urlArquivo);
                    //             break;
                    //         case 'txt':
                    //             //Montando link do documento - Extrato da carteira TXT
                    //             $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'DocumentosCarteira.txt';
                    //             http.open('HEAD', $scope.urlArquivo, true);
                    //             http.send();
                    //             window.open($scope.urlArquivo);
                    //             break;
                    //         case 'csv':
                    //             //Montando link do documento - Extrato da carteira CSV
                    //             $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'carteira/' + 'ExcelTemplate.xls';
                    //             http.open('HEAD', $scope.urlArquivo, false);
                    //             http.send();
                    //             window.open($scope.urlArquivo);
                    //             break;
                    //     }

                    // } else {
                    //     toastr.error($scope.dadosExtrato.mensagem);
                    // }
                }, function (response) {
                    $rootScope.loading = false;
                    toastr.error('Falha de conexão.');
                });                
            } else {
                toastr.error($scope.mensagem, { timeOut: 1500 });
            }
        };

        $scope.dataFinal = function () {
            if ($scope.relatorio.dataFinal == 'Fri Dec 31 9999 00:00:00 GMT-0300 (Hora padrão de Brasília)'){
                $scope.relatorio.dataFinal = new Date();
            };
        };

        $scope.validarCampos = function () {

            if ($scope.relatorio.dataInicio == undefined) {
                $scope.mensagem = 'A data inicial deve ser informada.'
                return false;
            }
            // $scope.periodoInicial = ajusteDatas.formatarData($scope.relatorio.dataInicio);
            // $scope.periodoFinal = ajusteDatas.formatarData($scope.relatorio.dataFinal);

            if ($scope.relatorio.dataInicio > $scope.relatorio.dataFinal) {
                $scope.mensagem = 'A data inicial não pode ser maior que data final.'
                return false;
            } else {
                if ($scope.relatorio.operacaoInicio > $scope.relatorio.operacaoFinal) {
                    $scope.mensagem = 'A operação inicial não pode ser maior que a operação final.'
                    return false;
                } else {
                    if ($scope.relatorio.operacaoInicio < 0) {
                        $scope.mensagem = 'A operação inicial não pode ser um número negativo.'
                        return false;
                    } else {
                        if ($scope.relatorio.operacaoFinal < 0) {
                            $scope.mensagem = 'A operação final não pode ser um número negativo.'
                            return false;
                        } else {
                            if($scope.relatorio.selectedRecebimentos.length == 0 && $scope.relatorio.tipoPeriodo == 1){
                                $scope.mensagem = 'Campo de Recebimentos está vazio.'
                                return false;
                            }else{
                                return true;
                            }                            
                        }
                    }
                }
            };
        }
    }
})();
(function () {
    angular.module('DifactWeb.pages').factory("painelRelatorioFactory", painelRelatorioFactory);

    function painelRelatorioFactory(layoutPaths, storageService, $http) {

        var factory = {
            getPainelRelatorioFactory: getPainelRelatorioFactory, 
            getPainelRelatorioSistemaFactory: getPainelRelatorioSistemaFactory,
            getPainelRelatorioDisponivelFactory: getPainelRelatorioDisponivelFactory,
            getPainelRelSistemaFactory: getPainelRelSistemaFactory
        }
        return factory;

        function getPainelRelatorioFactory(dadosRelatorio) {
            return $http.post(layoutPaths.urlAPI.buscaDadosExtrato, '{"extrato": ' + angular.toJson(dadosRelatorio) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response;
            });        
        }

        function getPainelRelSistemaFactory(dadosRelatorio) {   
            return $http.post(layoutPaths.urlAPI.buscaDadosSistema, '{"extrato": ' + angular.toJson(dadosRelatorio) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response.data;
            });      
        }

        function getPainelRelatorioSistemaFactory(dadosRelatorio) {
            return $http.post(layoutPaths.urlAPI.dadosExtratoSistema, '{"extrato": ' + angular.toJson(dadosRelatorio) + '}', { headers: { 'Authorization': storageService.getToken() }}).then(function(response) {
                return response;
            });        
        }

        function getPainelRelatorioDisponivelFactory() {
            return $http.post(layoutPaths.urlAPI.monitoraRelatorio, {},{ headers: { 'Authorization': storageService.getToken() }}).then(function (response) {
                return response.data;
            });
        }  
    };    
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 1200,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('DifactWeb.theme')
        .service('PagerService', PagerService);

    
    function PagerService() {
        // service definition
        var service = {};

        service.GetPager = GetPager;

        return service;

        // service implementation
        function GetPager(totalItems, currentPage, pageSize) {            
            // default to first page
            currentPage = currentPage || 1;            
            // default page size is 10
            pageSize = pageSize || 10;

            // calculate total pages
            var totalPages = Math.ceil(totalItems / pageSize);

            var startPage, endPage;
            if (totalPages <= 5) {
                // less than 10 total pages so show all
                startPage = 1;
                endPage = totalPages;
            } else {
                // more than 10 total pages so calculate start and end pages
                if (currentPage <= 3) {
                    startPage = 1;
                    endPage = 5;
                } else if (currentPage + 2 >= totalPages) {
                    startPage = totalPages - 4;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 2;
                    endPage = currentPage + 2;
                }
            }

            // calculate start and end item indexes
            var startIndex = (currentPage - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

            // create an array of pages to ng-repeat in the pager control
            var pages = _.range(startPage, endPage + 1);
            // var pages = [];
            // for( var i = 0; i < endPage ; i++){
            // pages.push(i+1); 
            // }

            // return object with all pager properties required by the view
            return {
                totalItems: totalItems,
                currentPage: currentPage,
                pageSize: pageSize,
                totalPages: totalPages,
                startPage: startPage,
                endPage: endPage,
                startIndex: startIndex,
                endIndex: endIndex,
                pages: pages
            };
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      }
      // loadAmCharts : function(){
      //   var d = $q.defer();
      //   AmCharts.ready(function(){
      //     d.resolve();
      //   });
      //   return d.promise;
      // }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author 
 * created on 05.08.2016
 */
(function() {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('dadosBancariosController', dadosBancariosController);

    /** @ngInject */
    function dadosBancariosController($scope, $uibModal, $rootScope, $http, toastr, layoutPaths, storageService) {
        
        $scope.open = function(page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                $scope.excluirBanco();
            }, function error() {

            });
        };

        $scope.parametrosIniciais = function() {
            $scope.ocultar = false;
            $rootScope.showDetails = true;
            $scope.dadosBancarios = {};
            $scope.tituloIcone = 'Incluir Banco';
        }

        $scope.alteraIcone = function() {
            if ($scope.ocultar == false) {
                $scope.ocultar = true;
                $scope.tituloIcone = 'Cancelar inclusão';
                $scope.acionarFocoBotao = true;
            } else {
                $scope.dadosBancarios = {};
                $scope.rest();
                $scope.tituloIcone = 'Incluir Banco';
                $scope.ocultar = false;
                $scope.acionarFocoBotao = false;
            };
        };

        $scope.salvarDadosBancarios = function() {
            if ($scope.dadosBancarios.nomeBanco != undefined && $scope.dadosBancarios.agencia != undefined
                && $scope.dadosBancarios.conta != undefined) {

                $rootScope.loading = true;
                $http.post(layoutPaths.urlAPI.incluirBanco, '{"banco": ' + angular.toJson($scope.dadosBancarios) + '}', { headers: { 'Authorization': storageService.getToken() }})
                    .then(function(response) {
                        $scope.bancoOrdena = response.data.retornoBancos.sdtBancosItem;
                        $scope.bancos = $scope.bancoOrdena;

                        if ($scope.bancoOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.bancoOrdena.length;
                            $scope.qtdPages = Math.ceil($scope.bancoOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                        }

                        if (response.data.retornoBancos.status == true) {
                            toastr.success(response.data.retornoBancos.mensagem, { timeOut: 1500 });
                            $scope.dadosBancarios = {};
                            $scope.ocultar = false;
                        } else {
                            toastr.error(response.data.retornoBancos.mensagem, { timeOut: 1500 });
                        }

                        $rootScope.loading = false;
                    }, function(response) {
                        $rootScope.loading = false;
                        $scope.ocultar = true;
                        toastr.error('Falha de conexão', { timeOut: 1000 });
                    });

                $scope.rest();
            }//fim if
            else {
                $scope.dadosBancariosForm.agencia.$touched = true;
                $scope.dadosBancariosForm.conta.$touched = true;
            }
        }//fim função salvaDadosBancarios

        $scope.buscaBancosCadastrados = function() {
            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.carregarBancos, {}, { headers: { 'Authorization': storageService.getToken() }})
                .then(function(response) {
                    $scope.bancoOrdena = response.data.bancos.sdtBancosItem;
                    $scope.bancos = $scope.bancoOrdena

                    if ($scope.bancoOrdena) {
                        //Paginação dos itens em grade
                        $scope.pageSize = 10;
                        $scope.totalItens = $scope.bancoOrdena.length;
                        $scope.qtdPages = Math.ceil($scope.bancoOrdena.length / $scope.pageSize);
                        $scope.currentPage = 1;
                        $scope.maxSize = 6;
                    }

                    $rootScope.loading = false;

                }, function(response) {
                    $scope.ocultar = false;
                    toastr.error('Falha de conexão', { timeOut: 1200 });
                    $rootScope.loading = false;
                });
        } //fim função buscaBancosCadastrados 

        $scope.editarBanco = function(item) {
            $scope.tituloIcone = 'Cancelar alteração';
            $scope.ocultar = true;

            $scope.dadosBancarios.codigo = item.codigo;
            $scope.dadosBancarios.nomeBanco = item.nomeBanco;
            $scope.dadosBancarios.agencia = item.agencia;
            $scope.dadosBancarios.conta = item.conta;
            $scope.dadosBancarios.gerente = item.gerente;

        } //fim função editarBanco

        $scope.verificaExclusao = function(item) {
            $scope.dadosBancariosItem = item;
            $scope.open('app/pages/cadastros/painel_bancos/removemodal.html', 'vm');

        }
        $scope.excluirBanco = function() {
            $http.post(layoutPaths.urlAPI.removerBanco, '{"codigo": ' + angular.toJson($scope.dadosBancariosItem.codigo) + '}', { headers: { 'Authorization': storageService.getToken() }})
                .then(function(response) {
                    $scope.bancos = [];
                    $scope.bancoOrdena = response.data.retornoBancos.sdtBancosItem;
                    $scope.bancos = $scope.bancoOrdena;

                    if (response.data.retornoBancos.status == true) {
                        toastr.success(response.data.retornoBancos.mensagem, { timeOut: 1200 });

                        if ($scope.bancoOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.bancoOrdena.length;
                            $scope.qtdPages = Math.ceil($scope.bancoOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                        }

                        if ($scope.ocultar) {
                            $scope.alteraIcone();
                        }

                        $rootScope.loading = false;
                    } else {
                        toastr.error('Banco não pode ser excluído.', { timeOut: 1200 });
                    }


                }, function(response) {
                    toastr.error('Falha na conexão.', { timeOut: 1200 });
                });
        }//fim função excluirBanco

        $scope.rest = function() {
            $scope.dadosBancariosForm.nomeBanco.$untouched = true;
            $scope.dadosBancariosForm.nomeBanco.$touched = false;
            $scope.dadosBancariosForm.agencia.$untouched = true;
            $scope.dadosBancariosForm.agencia.$touched = false;
            $scope.dadosBancariosForm.conta.$untouched = true;
            $scope.dadosBancariosForm.conta.$touched = false;
            $scope.dadosBancariosForm.$setPristine();
        }

    } //fim função dadosBancariosController

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelSacadosController', sacadosController);

  /** @ngInject */
  function sacadosController($scope, $rootScope) {
    $scope.ativaLoading = true;
    $rootScope.showDetails = true;
    $scope.sacados = [];

    //criando função que será tratada pelo controlador SacadoCtrl.js para busca dos dados do sacado
    $scope.buscaDados = function (item) {
      $rootScope.sacado = item;
    };

  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Dados atualizados com sucesso!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("Remessa enviada a Factoring!", '');
    };

    $scope.showInfoMsgdoc = function() {
      toastr.info("Título incluído na remessa.", '');
    };
    
    $scope.showErrorMsg = function() {
      toastr.error("CNPJ/CPF inválido", 'Erro');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelSacadoController', sacadoController);

    /** @ngInject */
    function sacadoController($scope, $uibModal, ngXml2json, $rootScope, toastr, $http, layoutPaths, storageService) {
        //iniciar variáveis
        $rootScope.showDetails = true;
        $rootScope.flagTelefone = 0;
        $rootScope.flagEndereco = 0;
        $scope.ocultar = false;
        $scope.tituloIcone = 'Incluir Sacado';
        //Tratamento campo Endereços
        $scope.enderecos = [];
        $scope.sacado = {};
        $scope.tiposTelefones = [
            { id: 1, name: 'Celular' },
            { id: 2, name: 'Comercial' },
            { id: 3, name: 'Fax' },
            { id: 4, name: 'Residencial' },
        ];

        $scope.alteraIcone = function () {
            if ($scope.ocultar == false) {
                $scope.ocultar = true;
                $scope.tituloIcone = 'Cancelar inclusão';
                $scope.acionarFocoBotao = true;
            } else {
                $scope.sacado = {};

                $scope.tituloIcone = 'Incluir Sacado';
                $scope.ocultar = false;
                $rootScope.flagTelefone = 0;
                $rootScope.flagEndereco = 0;
                $scope.acionarFocoBotao = false;
                $scope.cpfInvalido = false;
                $scope.rest();
            };
        };

        $scope.rest = function () {
            //$scope.sacado.cgccic = "";
            $scope.sacadoForm.cgccic.$untouched = true;
            $scope.sacadoForm.cgccic.$touched = false;

            $scope.sacadoForm.nome.$untouched = true;
            $scope.sacadoForm.nome.$touched = false;

            $scope.sacadoForm.email.$untouched = true;
            $scope.sacadoForm.email.$touched = false;

            $scope.sacadoForm.nascimento.$untouched = true;
            $scope.sacadoForm.nascimento.$touched = false;

            $scope.cpfInvalido = false;
            $scope.enderecos = [];
            $scope.telefones = [];
            $scope.sacadoForm.$setPristine();
        }

        $scope.gravarSacado = function () {
            if ($scope.sacado.nome != undefined && $scope.sacado.cgccic != undefined) {
                if ($scope.sacado.nascimento != undefined) {
                    if ($scope.sacado.email != undefined) {
                        $scope.sacado.telefones = $scope.telefones; //concatenando os telefones do sacado
                        $scope.sacado.enderecos = $scope.enderecos; //concatenando os endereços do sacado

                        //Validação do campo endereço
                        var tamanho = $scope.sacado.enderecos.length;
                        var contador = 0;
                        while (contador < tamanho) {
                            if ($scope.sacado.enderecos[contador].CepId == null) {
                                //código comentado abaixo permite remover a linha
                                toastr.warning('Existe campo de endereço em branco para ser preenchido.', { timeOut: 1200 });
                                return
                            } else {
                                if ($scope.sacado.enderecos[contador].CEP == '') {
                                    toastr.warning('Existe campo de endereço em branco para ser preenchido.', { timeOut: 1200 });
                                    return
                                }
                            }
                            contador++;
                        };//fim do laço

                        //Validação do campo telefone
                        tamanho = 0;
                        contador = 0;
                        if ($scope.sacado.telefones.length > 0) {
                            tamanho = $scope.sacado.telefones.length;
                            var lengthTel = $scope.sacado.telefones[contador].numero.length;
                        }
                        
                        while (contador < tamanho) {
                            if ($scope.sacado.telefones[contador].tipo == "") {
                                toastr.warning('Existe telefone se o tipo informado.', { timeOut: 1200 });
                                return
                            } else {
                                if (lengthTel < 8) {
                                    toastr.warning('Existe telefone inválido informado.', { timeOut: 1200 });
                                    return
                                } else {
                                    $scope.telInvalido = false;
                                    if ($scope.sacado.telefones[contador].numero == '') {
                                        //código comentado abaixo permite remover a linha
                                        toastr.warning('Existe campo de telefone em branco para ser preenchido.', { timeOut: 1200 });
                                        return
                                    }
                                }
                            }

                            contador++;
                        };//fim do laço

                        $rootScope.loading = true;
                        $http.post(layoutPaths.urlAPI.gravarSacado, '{"dados": ' + angular.toJson($scope.sacado) + '}', { headers: { 'Authorization': storageService.getToken() }})
                            .then(function (response) {
                                //Populando o grid com o retorno dos dados do banco.
                                $scope.sacadosOrdena = response.data.retornoSacados.sdtSacadosItem;
                                $scope.sacados = $scope.sacadosOrdena;

                                if ($scope.sacadosOrdena) {
                                    //Paginação dos itens em grade
                                    $scope.pageSize = 10;
                                    $scope.totalItens = $scope.sacadosOrdena.length;
                                    $scope.qtdPages = Math.ceil($scope.sacadosOrdena.length / $scope.pageSize);
                                    $scope.currentPage = 1;
                                    $scope.maxSize = 6;
                                    $rootScope.loading = false;
                                }

                                toastr.success(response.data.retornoSacados.mensagem, { timeOut: 1200 });
                                $rootScope.loading = false;
                                $scope.alteraIcone();
                            }, function (response) {
                                $scope.ocultar = false;
                                toastr.error('Falha de conexão.', { timeOut: 1200 });
                                $rootScope.loading = false;
                                $scope.ocultar = true;
                            });
                        $scope.rest();

                    } else {
                        toastr.error('O e-mail informado é inválido.', { timeOut: 1200 });
                    }
                } else {
                    toastr.error('A data de nascimento informada é inválida.', { timeOut: 1200 });
                }
            } else {
                //toastr.error('Informações obrigatórias não preenchidas', { timeOut: 1200 });
                $scope.sacadoForm.cgccic.$touched = true;
                $scope.sacadoForm.nome.$touched = true;
            }
        };

        $scope.pegaCEP = function (value, index) {
            var cep = value.CepId;
            var res;
            res = cep.replace(".", "");
            res = res.replace("-", "");
            cep = res;

            //Armazenando URL para consulta do CEP
            if (cep.length <= 7) {
                toastr.error('CEP inválido.', { timeOut: 1200 });
                return
            } else
                if (cep.length == 8) {
                    $rootScope.loading = true;

                    var url = 'http://viacep.com.br/ws/' + cep + '/xml/'

                    $http.get(url).success(function (response, status) {
                        $rootScope.loading = false;
                        $scope.JsonOutput = ngXml2json.parser(response)

                        if ($scope.JsonOutput.xmlcep.erro) {
                            toastr.error('O CEP informado não foi encontrado.', { timeOut: 1200 });
                            $scope.enderecos[index].CepLog = "";
                            $scope.enderecos[index].CepBai = "";
                            $scope.enderecos[index].CepComp = "";
                            $scope.enderecos[index].CidUf = "";
                        } else {
                            $scope.enderecos[index] = {};

                            $scope.enderecos[index].CepId = $scope.JsonOutput.xmlcep.cep;
                            $scope.enderecos[index].CepUF = $scope.JsonOutput.xmlcep.uf;

                            if ($scope.JsonOutput.xmlcep.localidade) {
                                $scope.enderecos[index].CepCid = $scope.JsonOutput.xmlcep.localidade;
                            }

                            if ($scope.JsonOutput.xmlcep.bairro.length > 0) {
                                $scope.enderecos[index].CepBai = $scope.JsonOutput.xmlcep.bairro;
                            }

                            if ($scope.JsonOutput.xmlcep.logradouro.length > 0) {
                                $scope.enderecos[index].CepLog = $scope.JsonOutput.xmlcep.logradouro;
                            }
                            $scope.enderecos[index].CepIbge = $scope.JsonOutput.xmlcep.ibge;
                            $scope.enderecos[index].CepOrg = 0;
                            $scope.enderecos[index].CidUf = $scope.JsonOutput.xmlcep.localidade + '/' + $scope.JsonOutput.xmlcep.uf;
                        }


                    }).error(function () {
                        $rootScope.loading = false;
                        toastr.error('Não foi possível buscar o CEP informado.', { timeOut: 1200 });

                    });

                    // $http.post(layoutPaths.urlAPI.buscarCEP, "<cep>" + cep + "</cep>", { headers: { 'format': 'json' } })
                    //     .then(function (response) {
                    //         $scope.enderecos[index] = response.data;
                    //         $rootScope.loading = false;
                    //         if ($scope.enderecos[index].CepCid) {
                    //             $scope.enderecos[index].CidUf = $scope.enderecos[index].CepCid.trim() + '/' + $scope.enderecos[index].CepUF;
                    //         }

                    //         if (!$scope.enderecos[index].CepLog) {
                    //             toastr.error('CEP não Encontrado.', { timeOut: 1200 });
                    //         }

                    //     }, function (response) {
                    //         toastr.error('Houve falha ao buscar CEP informado.', { timeOut: 1200 });
                    //         $rootScope.loading = false;
                    //     });
                }
        };

        $scope.cancelarEndereco = function (index) {
            $scope.removeEnd(index);
            $rootScope.flagEndereco = 0;
        }

        $scope.addEnd = function () {
            var tamanho = $scope.enderecos.length;
            var contador = 0;
            while (contador < tamanho) {
                if ($scope.enderecos[contador].CepId != undefined) {
                    $rootScope.flagEndereco = 0;
                } else {
                    $rootScope.flagEndereco = 1;
                }
                contador++;
            };//fim do laço

            if ($rootScope.flagEndereco == 0) {
                $rootScope.flagEndereco = 1;
                $scope.inserted = {
                    CEP: '',
                    logradouro: '',
                    complemento: '',
                    bairro: '',
                    ciduf: ''
                };

                $scope.enderecos.push($scope.inserted);
            }
        };

        $scope.removeEnd = function (index) {
            $scope.enderecos.splice(index, 1);
        };

        //Tratamento campo Telefones
        $scope.telefones = [];

        $scope.cancelarTelefone = function (index) {
            $scope.removeTel(index);
            $rootScope.flagTelefone = 0;
        }

        $scope.addTel = function () {

            var tamanho = $scope.telefones.length;
            var contador = 0;

            while (contador < tamanho) {
                if ($scope.telefones[contador].tipo != '') {
                    $rootScope.flagTelefone = 0;
                } else {
                    $rootScope.flagTelefone = 1;
                }
                contador++;
            };//fim do laço

            if ($rootScope.flagTelefone == 0) {
                $rootScope.flagTelefone = 1;
                $scope.inserted = {
                    tipo: '',
                    numero: '',
                    obs: ''
                };
                $scope.telefones.push($scope.inserted);
            }
        };

        $scope.removeTel = function (index) {
            $scope.telefones.splice(index, 1);
        };

        //Popular o grid com os sacados cadastrados na base
        $scope.buscarSacadosCadastrados = function () {
            $rootScope.sacado = "";
            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.buscarSacados, {}, { headers: { 'Authorization': storageService.getToken() }})
                .then(function (response) {

                    //Populando o grid com o retorno dos dados do banco.
                    $scope.sacadosOrdena = response.data.sacados.sdtSacadosItem;
                    $scope.sacados = $scope.sacadosOrdena;

                    if ($scope.sacadosOrdena) {
                        //Paginação dos itens em grade
                        $scope.pageSize = 10;
                        $scope.totalItens = $scope.sacadosOrdena.length;
                        $scope.qtdPages = Math.ceil($scope.sacadosOrdena.length / $scope.pageSize);
                        $scope.currentPage = 1;
                        $scope.maxSize = 6;
                        $rootScope.loading = false;
                    }
                }, function (response) {
                    //$scope.ocultar = false;                   
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.loading = false;
                }
                );
        }

        $scope.buscaDados = function (item) {
            $scope.tituloIcone = 'Cancelar alteração';
            $scope.ocultar = true;
            
            //Buscando informações do banco de dados
            $http.post(layoutPaths.urlAPI.buscarDadosSacado,  '{"cpfSacado": ' + angular.toJson(item.SacCgcCic) + '}', { headers: { 'Authorization': storageService.getToken() }})
                .then(function (response) {
                    //Populando o grid com o retorno dos dados do banco.
                    $scope.sacado = response.data.dadosSacado;
                    $scope.enderecos = $scope.sacado.enderecos;
                    $scope.telefones = $scope.sacado.telefones;

                    //Limpando para que, ao tentar incluir um novo sacado, não venha com os campos já preenchidos
                    //com dados da consulta anterior.
                    delete $scope.sacado.SacCgcCic;
                });
        };

        //Caso o usuário informe um CPF já existente na base, retorno os dados em tela
        $scope.buscaSacado = function () {
            $scope.cpfInvalido = false;
            $scope.acionarFocoBotao = false;
            if ($scope.sacado.cgccic != undefined) {

                var cgc = $scope.sacado.cgccic;
                var nome = $scope.sacado.nome;
                var email = $scope.sacado.email;
                var nascimento = $scope.sacado.nascimento;

                $rootScope.loading = true;
                $http.post(layoutPaths.urlAPI.buscarDadosSacado, '{"cpfSacado": ' + angular.toJson($scope.sacado.cgccic) + '}', { headers: { 'Authorization': storageService.getToken() }})
                    .then(function (response) {
                        //Populando o grid com o retorno dos dados do banco.
                        $scope.sacado = response.data.dadosSacado;

                        if ($scope.sacado.cgccic) {
                            toastr.warning('O sacado informado já existe no cadastro.', { timeOut: 1200 })
                            if ($scope.sacado.enderecos != undefined) {
                                $scope.enderecos = $scope.sacado.enderecos;
                            } else {
                                $scope.enderecos = [];
                            }

                            if ($scope.sacado.telefones != undefined) {
                                $scope.telefones = $scope.sacado.telefones;
                            } else {
                                $scope.telefones = [];
                            }
                        } else {
                            $scope.enderecos = [];
                            $scope.telefones = [];
                        };
                        $rootScope.loading = false;
                        //Foi colocado pq depois que é feito a busca pelo sacado, estava limpando o campo do CPF
                        $scope.sacado.cgccic = cgc
                    });
            } else {
                $scope.sacado.cgccic = "";
                $scope.cpfInvalido = true;
                $scope.acionarFocoBotao = true;
            }
        }

    }
})();
(function () {
    'use strict'

    angular.module('DifactWeb.pages')
        .controller('newProrrogacaoController', newProrrogacao);

    /** @ngInject */
    function newProrrogacao($scope, $state, $rootScope, $uibModal, toastr, layoutPaths,
        storageService, $http, ajusteDatas, formatarValor, painelEmissaoBoletoFactory, FileUploader, $stateParams) {

        $rootScope.showDetails = true;

        $scope.pagination = {
            currentPage: 1,
            pageSize: 5,
            maxSize: 5
        };

        $scope.novaProrrogacao = {};
        $scope.email = {};
        $scope.email.observacao = '';
        $scope.buscarTitulos = function () {
            $http.post(layoutPaths.urlAPI.buscaDocumentos, '{"tipo": "P"}',
                { headers: { 'Authorization': storageService.getToken() } })
                .then(function (response) {
                    if (response.data.retornaDocumentos) {
                        
                        $scope.titulos = response.data.retornaDocumentos.retornaDocumentos;
                        $scope.titulosOrdena = $scope.titulos;
                        $scope.totalItens = response.data.retornaDocumentos.retornaDocumentos.length;
                        $scope.qtdPages = Math.ceil($scope.totalItens / $scope.pagination.pageSize);

                    } else {
                        $scope.mensagemVazio = "Nenhuma informação encontrada.";
                    }
                });
        }

        $scope.buscaProrragaNaoEnviadas = function () {
            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.buscarProrrogaNaoEnviadas, {}, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                        $scope.dataOperacao = response.data.retornaTitulosRemessa.dataOperacao;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;

                        if ($scope.remessasOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }
                    } else {
                        $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                        var novaData = new Date()
                        novaData = ajusteDatas.formatarData(novaData);
                        $scope.dataOperacao = novaData;
                        $scope.qtdTitulos = 0;
                        $scope.valorTitulos = "0,00";
                        $scope.mensagemVazio = response.data.retornaTitulosRemessa.mensagem;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;
                    }
                    
                    $rootScope.loading = false;
                }, function () {
                    toastr.error('Falha de conexão.', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });
        }

        $scope.carregarTitulo = function () {
            if (!$stateParams.item) {
                return $state.go('empresa.novaprorrogacao')
            }
            $scope.operacao = $stateParams.item.operacao
            $scope.vencimento =$stateParams.item.vencimento
            $scope.numeroDoc = $stateParams.item.numeroDoc
            $scope.nossoNumero = $stateParams.item.nossoNumero
            $scope.nomeSacado = $stateParams.item.nomeSacado
            $scope.docValor = $stateParams.item.docValor
            $scope.novaProrrogacao.vencimento = $stateParams.item.novoVenc
            $scope.novaProrrogacao.observacao = $stateParams.item.observacao
        }

        $scope.salvar = function () {
            $scope.novaProrrogacao.docsequen = $stateParams.item.docSequen
            $scope.novaProrrogacao.openumero = $scope.operacao
            if ($scope.novaProrrogacao.vencimento == null || $scope.novaProrrogacao.vencimento == undefined || $scope.novaProrrogacao.vencimento == '') {
                toastr.warning('Data da prorrogação deve ser informada.', {
                    timeOut: 1200
                });
                return
            } else {
                var dataProrroga = $scope.converterData($scope.novaProrrogacao.vencimento)
                var datavencimento = $scope.converterData($scope.vencimento)
                if (dataProrroga <= datavencimento) {
                    toastr.warning('Data da prorrogação deve ser maior que a data de vencimento.', {
                        timeOut: 1200
                    });
                    return
                } else {
                    var dataHoje = new Date()
                    dataHoje = ajusteDatas.formatarData(dataHoje);
                    dataHoje = $scope.converterData(dataHoje);
                    if (dataProrroga < dataHoje){
                        toastr.warning('Data da prorrogação deve ser maior ou igual a data de hoje.', {
                            timeOut: 1200
                        });
                        return
                    }else{
                        $http.post(layoutPaths.urlAPI.gravarProrrogacao, '{"titulo": ' + angular.toJson($scope.novaProrrogacao) + '}', {
                            headers: {
                                'Authorization': storageService.getToken()
                            }
                        }).then(function (response) {
                                if (response.data.retornaTitulosRemessa.status) {
                                    $scope.retornar();
                                } else {
                                    toastr.error(response.data.retornaTitulosRemessa.mensagem, {
                                        timeOut: 1200
                                    });
                                    $rootScope.loading = false;
                                }
                            }, function () {
                                toastr.error('Falha de conexão.', {
                                    timeOut: 1200
                                });
                                $rootScope.loading = false;
                            });
                    }
                }
            }
        };

        $scope.prorrogar = function (item, operacao) {
            item.operacao = operacao;
            $state.go('empresa.prorrogaTitulo', { item: item });
            $rootScope.loading = false;
        }

        $scope.editarTitulo = function (item, operacao) {
            item.operacao   = operacao;
            item.numeroDoc  = item.numdoc;
            item.nomeSacado = item.nome;
            item.docValor   = item.valor;
            item.docSequen  = item.docsequen;
            $state.go('empresa.prorrogaTitulo', { item: item });
            $rootScope.loading = false;
        }

        $scope.retornar = function () {
            $state.go('empresa.novaprorrogacao');
            $rootScope.loading = false;
        }

        $scope.verificaExclusao = function (item) {
            $scope.remessaItem = item;
            $scope.open('app/pages/remessas/painel_remessa/removemodal.html', 'vm', 'excluir');
        }

        $scope.excluirTituloRemessa = function () {
            $http.post(layoutPaths.urlAPI.removerProrrogacao, '{"sequencialDocumento": ' + angular.toJson($scope.remessaItem.docsequen) + '}', {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;

                        toastr.success(response.data.retornaTitulosRemessa.mensagem, {
                            timeOut: 1200
                        });
                        $rootScope.loading = false;

                        if ($scope.remessasOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            if ($scope.totalItens == 0) {
                                var novaData = new Date()
                                $scope.mensagemVazio = "Nenhuma informação encontrada.";
                                novaData = ajusteDatas.formatarData(novaData);
                                $scope.dataOperacao = novaData;
                                $scope.qtdTitulos = 0;
                                $scope.valorTitulos = "0,00";
                                $rootScope.operacao = '';
                            }
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }
                        $scope.buscarTitulos();
                    } else {
                        toastr.error('Título não pode ser excluído.', {
                            timeOut: 1200
                        });
                    }
                }, function () {
                    toastr.error('Falha de conexão.', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });
        };

        $scope.converterData = function (dataParm) {
            var dia = dataParm.substring(0, 2);
            var mes = dataParm.substring(3, 5);
            var ano = dataParm.substring(6, 10);

            var data = mes + '/' + dia + '/' + ano;
            var novoData = new Date(data);

            return novoData
        }

        $scope.open = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'excluir') {
                    $scope.excluirTituloRemessa($scope.remessaItem);
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };

        $scope.verificaEnvio = function () {
            $scope.identificaErro = false;
            $scope.identificaSucesso = false
            $scope.titulosRemessa.find(function (item) {
                if (item.docinderr === 'S') {
                    $scope.identificaErro = true;
                }
                if (item.docinderr === 'N') {
                    $scope.identificaSucesso = true;
                }
            });
            $scope.prorroga = true;
            //$scope.openVerificaEnvio('app/pages/remessas/painel_remessa/verifica.envio.modal.html', 'vm', 'enviar');
            $scope.openVerificaEnvio('app/pages/remessas/painel_remessa/observacao.html', 'vm', 'enviar');
        }

       $scope.openVerificaEnvio = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'enviar') {
                    //$scope.enviarRemessa();
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };

        $scope.enviarRemessa = function () {
            if ($scope.titulosRemessa) {
                var operacao = $scope.operacao
                $rootScope.loading = true;
                $rootScope.remessasEnviar = $scope.titulosRemessa;
                $rootScope.remessasEnviar.operacao = operacao;
                $rootScope.remessasEnviar.opeData = $scope.dataOperacao;
                var data = '';
                if ($scope.fileStrings.length > 0) {

                    $scope.filesSend = [];
                    angular.forEach($scope.fileStrings, function (fileUp, i) {
                        var fileReader = new FileReader();

                        fileReader.onload = function (event) {
                            var uri = event.target.result;

                            $scope.filesSend.push({
                                filename: fileUp.fileName,
                                filetype: fileUp.fileType,
                                filebase64: uri.split("base64,")[1]
                            });
                            setTimeout(function () {
                                if (i == ($scope.fileStrings.length - 1)) {
                                    data = '{"files": { "operacao":' + $scope.operacao + ',  "files": ' + angular.toJson($scope.filesSend) + '}}';
                                    $scope.atualizaStatusDoc(data);
                                }
                            }, 1000);
                        };

                        fileReader.readAsDataURL(fileUp.fileUpload);
                    })
                } else {
                   $scope.atualizaStatusDoc(data);
                }
                $rootScope.loading = false;

            } else {
                toastr.error('Não existe título no lote.', {
                    timeOut: 1200
                });
            };
        };

        $scope.uploadDocumento = function (data) {
            $http.post(layoutPaths.urlAPI.uploadDocumentoEmail, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.response) {
                        var data = '{"observacao": '+angular.toJson($scope.email.observacao)+',"files": { "operacao":' + $scope.operacao + ',  "files": []}}';
                        $scope.enviarEmail(data);
                    }
                })

        };

        $scope.atualizaStatusDoc = function (arquivos) {
            painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory()
                .then(function (response) {
                    $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel;

                    $rootScope.loading = true;
                    $http.post(layoutPaths.urlAPI.atualizaStatusDoc, '{"numeroOperacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}', {
                        headers: {
                            'Authorization': storageService.getToken()
                        }
                    })
                        .then(function (response) {
                            if (!$scope.servidorDisponivel) { //Se não estiver disponível
                                toastr.warning('Para que esta requisição seja processada o sistema da empresa ' + storageService.getNomeFactoring() + ' deve estar ativo.', {
                                    timeOut: 4000
                                });
                                $http.post(layoutPaths.urlAPI.atualizaStatusNaoEnviado, '{"numeroOperacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}', {
                                    headers: {
                                        'Authorization': storageService.getToken()
                                    }
                                })
                                $rootScope.loading = false;
                            } else {
                                if (response.data.retorno.status) {
                                    toastr.success(response.data.retorno.mensagem, {
                                        timeOut: 1200
                                    });
                                    if (arquivos.length > 1){
                                        $scope.uploadDocumento(arquivos);
                                    } else {
                                        var data = '{"observacao": '+angular.toJson($scope.email.observacao)+',"files": { "operacao":' + $scope.operacao + ',  "files": []}}';
                                        $scope.enviarEmail(data);
                                    }
                                    $state.go('empresa.prorrogacoes');
                                }
                            }
                        }, function () {
                            toastr.error('Falha de conexão.', {
                                timeOut: 1200
                            });
                            $rootScope.loading = false;
                        });
                }, function () {

                    toastr.error('Falha ao tentar enviar lote de títulos. Entre em contato com a empresa ' + storageService.getNomeFactoring() + '.', {
                        timeOut: 2500
                    });
                });
        };

        $scope.enviarEmail = function (data) {
            $http.post(layoutPaths.urlAPI.enviarComprovantesEmail, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
            .then(function (response) {
                if(response.data.response){
                    toastr.success('Email enviado com sucesso!', {
                        timeOut: 2400
                    });
                }else{
                    toastr.error('Ocorreu um erro no envio do email!', {
                        timeOut: 2400
                    });
                }
            })
        };
        /////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////Adicionar Anexo - Importação de arquivo//////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////
        var uploader = $scope.uploader = new FileUploader({
            url: layoutPaths.urlAPI.carregarArquivo,
            headers: {
                'Authorization': storageService.getToken()
            }
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function () {
                $scope.tamanho = this.queue.length;
                return this.queue.length < 50;
            }

        });

        $scope.remover = function () {
            $scope.desabilitarItem = false;
        }

        // CALLBACKS
        uploader.onCompleteItem = function (fileItem) {
            fileItem.isSucess = true;
        };

        uploader.onErrorItem = function (fileItem) {
            fileItem.isSucess = false;
            $scope.erroImportacao = true;
        };

        uploader.onCancelItem = function () {

        };

        $scope.uploaderAnexos = new FileUploader();

        $scope.fileStrings = [];
        $rootScope.fileStrings = [];

        $scope.removeAnexo = function (obj) {
            var remFile = $scope.fileStrings.findIndex(function (item) {
                return item.$$hashKey === obj.$$hashKey;
            });
            $scope.fileStrings.splice(remFile, 1);
            $rootScope.fileStrings.splice(remFile,1);
        }

        $scope.uploaderAnexos.onAfterAddingFile = function (fileItem) {
            var data = (/[.]/.exec(fileItem.file.name)) ? /[^.]+$/.exec(fileItem.file.name) : undefined
            
            if (fileItem.file.size <= 5242880) {
                if ($scope.fileStrings.length >= 500) {
                    toastr.error('Você atingiu o limite de 500 arquivos no envio.', {
                        timeOut: 2400
                    });
                } else {
                    $scope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                    $rootScope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                }
            } else {
                toastr.error('Arquivo muito grande, não é possível anexar!', {
                    timeOut: 2400
                });
            }
            
        };
    }
})();
(function () {
'use strict';

angular.module('DifactWeb.pages')
    .controller('painelProrrogacoesController', ProrrogacoesController);

    /** @ngInject */
    function ProrrogacoesController($scope, $uibModal, toastr, $http, $rootScope, layoutPaths, storageService) {

        $scope.myVar = setInterval(function () { myTimer() }, 10000);

        function myTimer() {
            $scope.buscarTitulos();
        }

        function myStopFunction() {
            clearInterval($scope.myVar);
        }

        //inicializando variáveis
        $scope.email = {};
        $rootScope.showDetails = true;
        $scope.remessas = [];
        $rootScope.dadosRemessa = "";
        $rootScope.dataEnvio = "";
        $rootScope.retornaTitulos = "";
        $rootScope.operacao = "";
        $scope.pagination = {
            currentPage: 1,
            pageSize: 10,
            maxSize: 5
        };
        $scope.fileUploadOptions = {
            notetext: "text",
            progress: 0
        };
        $scope.email = {};

        $scope.open = function (page, size) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size
            });

            modalInstance.result.then(function success() {
                $scope.excluirRemessa();
            }), function error() {

            }
        };

        $scope.$on('$destroy', function () {
            myStopFunction()
        });

        $scope.buscarTitulos = function () {
            $rootScope.loading = true;
            $rootScope.loading = true; //ativa Loading
            $http.post(layoutPaths.urlAPI.buscarTitulos, '{"numeroOperacao": ' + angular.toJson("0") + ',"LotTip": "P"}', { headers: { 'Authorization': storageService.getToken() } })
            .then(function (response) {
                //Populando o grid com o retorno dos dados do banco.
                $rootScope.dataEnvio = response.data.retornaTitulosRemessa.dataEnvio;
                $rootScope.dadosRemessa = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                $rootScope.titulosOrdena = $rootScope.dadosRemessa;
                if ($scope.dadosRemessa) {
                    //Paginação dos itens em grade
                    $scope.pageSize = 10;
                    $scope.totalItens = $scope.dadosRemessa.length;
                    $scope.qtdPages = Math.ceil($scope.dadosRemessa.length / $scope.pageSize);
                    $scope.currentPage = 1;
                    $scope.maxSize = 6;
                    $rootScope.loading = false;
                    $scope.mensagemVazio = "";
                }
                $rootScope.loading = false; //desativa Loading
            });
        }

        $scope.verificaParecer = function (item) {
            $scope.parecer = item.parecerProrrogacao;

            $scope.open('app/pages/prorrogacoes/painel_prorrogacoes/parecer.prorrogacoes.modal.html', 'vm', '');
        }

        $scope.open = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // // promise
            modalInstance.result.then(function success() {

            }, function error() {
                $scope.ocultar = false;
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

    /** @ngInject */
    function SelectpickerPanelCtrl($scope, $rootScope, $http, $state, toastr, layoutPaths, $stateParams, storageService) {
        var vm = this;
        vm.imprimirDuplicata = false;
        $scope.mostraImprimeDup = false;

        //rootScope iniciado no objeto TablesPageCtrl.js
        vm.standardSelectItems = $rootScope.bancosCadastrados;

        //Recebe JSOn do item selecionado para enviar os dados ao Backend para gerar arquivo
        $scope.remessasEnviar = $rootScope.remessasEnviar;
        var contador = 0;
        var existe = false;

        //Percorrer documentos cadastrados para identificar algum que seja "Duplicata"
        while (contador < $scope.remessasEnviar.length) {
            if ($scope.remessasEnviar[contador].tipodoc == 'DP') {
                existe = true;
                break;
            }
            contador++;
        }


        //Salvando anexos 
        $scope.fileStrings = $rootScope.fileStrings;

        $scope.enviarAnexos = function () {
            return new Promise(function (resolve, reject) {
                $scope.filesSend = [];

                var listaArquivosPromise = [];
                angular.forEach($scope.fileStrings, function (fileUp, i) {
                    listaArquivosPromise.push(preparaArquivos(fileUp));
                });

                Promise.all(listaArquivosPromise).then(function(arquivos) {
                    var data = '{"files": { "operacao":' + $scope.remessasEnviar.operacao + ',  "files": ' + angular.toJson(arquivos) + '}}';
                    $http.post(layoutPaths.urlAPI.uploadDocumentoEmail, data, {
                        headers: {
                            'Authorization': storageService.getToken()
                        }
                    }).then(function () {
                        return resolve();
                    });
                })
            });
        }

        //Mostra opção de imprimir duplicata somente se houver documento do tipo "Duplicata" cadastrado.        
        if (existe) {
            $scope.mostraImprimeDup = true;
        } else {
            $scope.mostraImprimeDup = false;
        }

        //Enviar remessa
        $scope.sendData = function () {
            return new Promise(function (resolve, reject) {

                var url = layoutPaths.urlAPI.enviarRemessa;

                var data = '{"remessa": {'
                if (vm.observacao != "") {
                    data += ' "observacao": ' + angular.toJson(vm.observacao) + ','
                } else {
                    data += ' "observacao": ' + ' "" ' + ','
                };
                data += ' "operacao": ' + angular.toJson($scope.remessasEnviar.operacao) + ','

                if (vm.multipleSelectedItems != undefined) {
                    data += ' "selecao": ' + angular.toJson(vm.multipleSelectedItems)
                } else {
                    data += ' "selecao": ' + "[]"
                };
                data += '}}';

                $rootScope.loading = true;
                $rootScope.bloquearTela = true;
                $rootScope.mensagemTela = 'Enviando lote de títulos para a Empresa. Aguarde...';
                setTimeout(function () {
                $http.post(layoutPaths.urlAPI.enviarRemessa, data, { headers: { 'Authorization': storageService.getToken() } })
                    .then(function (response) {
                        if (response.data.retornaRemessas.msgEmail != '') {
                            toastr.warning(response.data.retornaRemessas.msgEmail, { timeOut: 1200 });
                        } else {
                            toastr.success('Envio realizado com sucesso.', { timeOut: 1200 });
                            $rootScope.remessas = response.data.retornaRemessas;

                            //Imprimir Duplicata se opção estiver marcada
                            if (vm.imprimirDuplicata) {
                                var dadosOperacao = '{"dadosOperacao": {'
                                dadosOperacao += ' "operacao": ' + angular.toJson($scope.remessasEnviar.operacao) + ','
                                dadosOperacao += ' "opeData": ' + angular.toJson($scope.remessasEnviar.opeData)
                                dadosOperacao += '}}'
                                $http.post(layoutPaths.urlAPI.imprimeDuplicata, dadosOperacao, { headers: { 'Authorization': storageService.getToken() } })
                                    .then(function (response) {
                                        var cnpjEmpresa = response.data.retornoDadosDuplicata.clicod;
                                        if (response.data.retornoDadosDuplicata.status) {
                                            $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'duplicatas/' + 'Copia_de_Duplicatas' + $stateParams.empfaccod + $stateParams.empcod + cnpjEmpresa + '.pdf'
                                            window.open($scope.urlArquivo);
                                        }
                                    }, function (error) {
                                        toastr.error('Não foi possível gerar a Duplicata.', { timeOut: 1200 });
                                        $rootScope.loading = false;
                                        $rootScope.bloquearTela = false;
                                        $rootScope.mensagemTela = '';
                                    });
                            }
                            $state.go('empresa.remessas');
                        }
                        $rootScope.bloquearTela = false;
                        $rootScope.mensagemTela = '';
                        $rootScope.loading = false;
                        return resolve();
                    }, function (response) {
                        toastr.error('Falha de conexão.', { timeOut: 1200 });
                        $rootScope.loading = false;
                        $rootScope.bloquearTela = false;
                        $rootScope.mensagemTela = '';
                        return reject();
                    });
                },1000);
                });
        }

        $scope.enviarEmail = function () {
            $scope.enviarAnexos()
                .then(function () {
                    return $scope.sendData();
                })
                .then(function () {
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function preparaArquivos(fileUp) {
            return new Promise(function (resolve, reject) {
                var fileReader = new FileReader();

                fileReader.onload = function (event) {
                    var uri = event.target.result;

                    var arquivo = {
                        filename: fileUp.fileName,
                        filetype: fileUp.fileType,
                        filebase64: uri.split("base64,")[1]
                    };

                    return resolve(arquivo);
                };

                fileReader.readAsDataURL(fileUp.fileUpload);
            });
        }

        vm.observacao = [];
    }


})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.pages')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
(function() {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('titulosImportarController', ImportarTitulosController)

    function ImportarTitulosController($scope, FileUploader, $http, toastr, $state, $rootScope, layoutPaths, storageService) {
         $scope.desabilitarItem = false;
         var uploader = $scope.uploader = new FileUploader(
            {
                url: layoutPaths.urlAPI.carregarArquivo,
                headers: { 'Authorization': storageService.getToken() }
            });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function(item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        $scope.remover = function() {
            $scope.desabilitarItem = false;
        }

        // CALLBACKS
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            //console.info('onWhenAddingFileFailed', item, filter, options);
        };
        
        uploader.onAfterAddingFile = function(fileItem) {
            // console.info('Inclusão do arquivo', fileItem);
        };

        uploader.onBeforeUploadItem = function(item) {
            //console.info('onBeforeUploadItem', item);
        };

        uploader.onProgressItem = function(fileItem, progress) {
            //console.info('onProgressItem', fileItem, progress);
        };

        uploader.onProgressAll = function(fileItem, progress) {
        };

        uploader.onErrorItem = function(fileItem, response, status, headers) {
            //console.info('Erro de importação', fileItem, response, status, headers);
        };

        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            //console.info('sucesso: ', fileItem, response, status, headers);
            $scope.retorno = response.object_id;
            $scope.desabilitarItem = true;
            if ($rootScope.operacao) {
                var operacao = $rootScope.operacao;
            } else {
                var operacao = 0;
            }

            var data = ' {"dadosRemessa": ' + '{"caminho": ' + angular.toJson($scope.retorno.replace("gxupload:", "")) + ',' +
                ' "operacao": ' + operacao + '}}';

            $scope.ativaLoading = true;
            $http.post(layoutPaths.urlAPI.importarArquivo, data, { headers: { 'Authorization': storageService.getToken() }})
                .then(function(response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        uploader.onCompleteItem(fileItem, response, status, headers)
                        $rootScope.dadosRemessa = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;
                        toastr.success(response.data.retornaTitulosRemessa.mensagem, { timeOut: 1200 });
                    } else {
                        toastr.error(response.data.retornaTitulosRemessa.mensagem, { timeOut: 1200 });
                        uploader.onErrorItem(fileItem, response, status, headers);
                    };
                    $scope.ativaLoading = false;
                }, function(response) {
                    toastr.error('Falha de conexão', { timeOut: 1200 });
                    $rootScope.loading = false;
                });
        };

        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            fileItem.isSucess = true;
        };

        uploader.onErrorItem = function(fileItem, response, status, headers) {
            fileItem.isSucess = false;
        };

        uploader.onCancelItem = function(fileItem, response, status, headers) {
            // console.info('onCancelItem', fileItem, response, status, headers);
        };

        $scope.concluirImportacao = function() {
            // $state.go('novaremessa', 'recarregar', { reload: true });
            $state.go('empresa.novaremessa');
        }


    }
})();
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelAlteraRemessaController', alteraRemessaController);

    /** @ngInject */
    function alteraRemessaController($scope, $uibModal, formatarValor, paddingLeft, ngXml2json, $state, $http, painelEmissaoBoletoFactory, toastr, $rootScope, layoutPaths, storageService, FileUploader) {
        $scope.operacao = 0;
        $scope.docsequen = 0;
        $scope.email = {};

        $scope.parametrosIniciais = function () {
            $scope.ocultar = false;
            $scope.ocultaPanel = false;
            $rootScope.showDetails = true;
            $scope.tituloIcone = 'Cancelar alteração';
            $scope.novaRemessa = {}
            $scope.mostraCMC7NFe = false;
            $scope.ocultaImportacao = true;
            $rootScope.flagTelefone = 0;
            $rootScope.flagEndereco = 0;
            $scope.tipoDocumentos = [
                { id: "CH", nome: 'CHEQUE' },
                { id: "DP", nome: 'DUPLICATA' },
                { id: "DS", nome: 'DUPLICATA DE SERVIÇO' },
                { id: "NP", nome: 'NOTA PROMISSÓRIA' },
                { id: "NR", nome: 'NOTA PROMISSÓRIA RURAL' },
                { id: "O" , nome: 'OUTROS' }
            ];
            $scope.enderecos = [];
            $scope.tiposTelefones = [
                { id: 1, name: 'Celular' },
                { id: 2, name: 'Comercial' },
                { id: 3, name: 'Fax' },
                { id: 4, name: 'Residencial' },
            ];
        }

        $scope.alteraIcone = function () {
            if ($scope.ocultar == false) {
                $scope.ocultar = true;
                $scope.novaRemessa = {};
                $scope.enderecos = [];
                $scope.telefones = [];
                $scope.tituloIcone = 'Cancelar inclusão';
                $scope.mostraCMC7NFe = false;
                $scope.ocultarDadosFatura = false;
                $scope.ocultaImportacao = false;
            } else {
                $scope.tituloIcone = 'Incluir novo título';
                $scope.rest();
                $scope.ocultar = false;
                $scope.ocultaImportacao = true;
                $scope.ocultaPanel = false;
                $rootScope.flagEndereco = 0;
                $rootScope.flagTelefone = 0;
                $scope.cpfInvalido = false;
                $scope.dataInvalida = false;

                $scope.docCliErro = false;
                $scope.docSacErro = false;
            };
        };

        $scope.open = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'excluir') {
                    $scope.excluirTituloRemessa($scope.remessaItem);
                } else if (opcao.toLowerCase() == 'salvar') {
                    $scope.ocultar = true;
                }else{
                    console.log('ok')
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };


        $scope.validaTipo = function (tipo, chamada) {
            // $scope.novaRemessa.cmc7 = '';
            $scope.ocultarDadosFatura = false;
            $scope.labelDocumento = '';
            $scope.mostraCMC7NFe = false;   

            if (tipo == 'CH') {
                $scope.ocultarDadosFatura = false;
                $scope.labelDocumento = 'CMC7';
                $scope.mostraCMC7NFe = true;
                if (chamada == 'tela') {
                    $scope.novaRemessaForm.cmc7.$untouched = true;
                    $scope.novaRemessaForm.cmc7.$touched = false;
                }
                // $scope.novaRemessa.cmc7 = '';
            } else {
                if (chamada == 'tela') {
                    $scope.novaRemessaForm.cmc7.$untouched = true;
                    $scope.novaRemessaForm.cmc7.$touched = false;
                }
                if (tipo == 'DP' || tipo == 'DS') {                
                    // $scope.novaRemessa.cmc7 = '';
                    $scope.ocultarDadosFatura = true;
                    $scope.labelDocumento = 'Chave da NF-e';
                    $scope.mostraCMC7NFe = true;
                    } 
            };
        };

        //Caso for editar um titulo da remessa
        if ($rootScope.dadosRemessa) {
            $scope.remessasOrdena = $scope.dadosRemessa;
            $scope.titulosRemessa = $scope.remessasOrdena;
            $scope.pageSize = 10;
            $scope.totalItens = $scope.remessasOrdena.length;
            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
            $scope.currentPage = 1;
            $scope.maxSize = 6;
        };

        //Ocultar o Panel que permite incluir novos títulos, quando a remessa estiver sendo editada
        //Só poderá incluir novos titulos na remessa se a mesma não estiver sido enviada, caso contrário,
        //o usuário poderá somente alterar os documentos atuais da remessa
        if ($rootScope.dataEnvio) {
            if ($rootScope.dataEnvio != null) {
                $scope.ocultaPanel = false;
            }
        } else {
            $scope.ocultaPanel = true;
        }


        if ($rootScope.retornaTitulos) {
            $scope.envioLote = $rootScope.retornaTitulos.envioLote;
            $scope.dataOperacao = $rootScope.retornaTitulos.dataOperacao;
            $scope.qtdTitulos = $rootScope.retornaTitulos.qtdTitulos;
            $scope.valorTitulos = formatarValor.ajustarValor($rootScope.retornaTitulos.valorTitulos, 2, ',', '.');
            $scope.permiteReenvio = $rootScope.retornaTitulos.permiteReenvio;
        } else {
            $scope.ocultaPanel = true;
            $state.go('empresa.remessas');
        }

        $scope.validarTituloDuplicado = function () {
            $scope.numDocInvalido = false;
            $scope.docCliErro = false;
            $scope.docSacErro = false
            $scope.ErroCliImport = false;

            if (($scope.novaRemessa.numdoc != '' && $scope.novaRemessa.numdoc != undefined) &&
                $scope.novaRemessa.tipodoc != undefined) {

                var data = '{"dadosTitulo": {'
                data += ' "tipoDoc": ' + angular.toJson($scope.novaRemessa.tipodoc) + ','

                if ($scope.novaRemessa.cgccic != "" && $scope.novaRemessa.cgccic != undefined) {
                    data += ' "cgccic": ' + angular.toJson($scope.novaRemessa.cgccic) + ','
                } else {
                    data += ' "cgccic": ' + ' "" ' + ','
                };

                if ($scope.novaRemessa.docsequen != "" && $scope.novaRemessa.docsequen != undefined) {
                    data += ' "docsequen": ' + angular.toJson($scope.novaRemessa.docsequen) + ','
                } else {
                    data += ' "docsequen": ' + ' "" ' + ','
                }

                data += ' "numDoc": ' + angular.toJson($scope.novaRemessa.numdoc) + '}}'

                $rootScope.loading = true;
                $http.post(layoutPaths.urlAPI.validarTituloDuplicado, data, { headers: { 'Authorization': storageService.getToken() }})
                    .then(function (response) {

                        if (response.data.validacao.docCliErro) {
                            $scope.docCliErro = true;
                        } else {
                            $scope.docCliErro = false;
                        }

                        if (response.data.validacao.docSacErro) {
                            $scope.docSacErro = true;
                        } else {
                            $scope.docSacErro = false;
                        }

                        $rootScope.loading = false;
                    }, function (response) {
                        toastr.error('Falha de conexão.', { timeOut: 1200 });
                        $rootScope.loading = false;
                    });
            } else {
                $scope.numDocInvalido = true;
            }
        }

        $scope.buscaSacado = function (opcao) {
            if (opcao == 'cgccic') {
                $scope.cpfInvalido = false;
            }

            if (opcao == 'dtVenc') {
                $scope.dataInvalida = false;
                $scope.dtVencErro = false;
            }

            if ($scope.novaRemessa.cgccic != undefined && $scope.novaRemessa.cgccic != '') {
                var Cgc = $scope.novaRemessa.cgccic;
                var NumDoc = $scope.novaRemessa.numdoc;
                var tipoDoc = $scope.novaRemessa.tipodoc;
                var vencimento = $scope.novaRemessa.vencimento;
                var valor = $scope.novaRemessa.valor;
                var cmc7 = $scope.novaRemessa.cmc7;
                var numFat = $scope.novaRemessa.numfatura;
                var dataFat = $scope.novaRemessa.datafatura;
                var serieFat = $scope.novaRemessa.seriefatura;
                var valorFat = $scope.novaRemessa.valorfatura;

                if (opcao == 'cgccic') {
                    $rootScope.loading = true;
                    $http.post(layoutPaths.urlAPI.buscarDadosSacado, '{"cpfSacado": ' + angular.toJson($scope.novaRemessa.cgccic) + '}', { headers: { 'Authorization': storageService.getToken() }})
                        .then(function (response) {
                            //Populando o grid com o retorno dos dados do banco.

                            $scope.novaRemessa = response.data.dadosSacado;
                            if ($scope.novaRemessa.cgccic) {
                                if ($scope.novaRemessa.enderecos != undefined) {
                                    $scope.enderecos = $scope.novaRemessa.enderecos;
                                } else {
                                    $scope.enderecos = [];
                                }

                                if ($scope.novaRemessa.telefones != undefined) {
                                    $scope.telefones = $scope.novaRemessa.telefones;
                                } else {
                                    $scope.telefones = [];
                                }
                            } else {
                                $scope.enderecos = [];
                                $scope.telefones = [];
                            };
                            $rootScope.loading = false;
                            //Foi colocado pq depois que é feito a busca pelo sacado, estava limpando os demais campos
                            $scope.novaRemessa.cgccic = Cgc;
                            $scope.novaRemessa.numdoc = NumDoc;
                            $scope.novaRemessa.tipodoc = tipoDoc;
                            $scope.novaRemessa.vencimento = vencimento;
                            $scope.novaRemessa.valor = valor;
                            $scope.novaRemessa.cmc7 = cmc7;
                            $scope.novaRemessa.numfatura = numFat;
                            $scope.novaRemessa.datafatura = dataFat;
                            $scope.novaRemessa.seriefatura = serieFat;
                            $scope.novaRemessa.valorfatura = valorFat;

                            $scope.novaRemessa.enderecos = $scope.enderecos;
                            $scope.novaRemessa.telefones = $scope.telefones;

                            $scope.novoEnd = false;
                        });
                } else {
                    if (opcao == 'dtVenc') {
                        if ($scope.novaRemessa.vencimento == undefined) {
                            $scope.dataInvalida = true;
                        } else {
                            var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                            var novaDataOperacao = $scope.converterData($scope.dataOperacao);

                            if (novoVencimento < novaDataOperacao) {
                                $scope.dtVencErro = true;
                            } else {
                                $scope.dtVencErro = false;
                            }
                        }
                    }

                    if (opcao == 'cmc7') {
                        $scope.cmc7Erro = false;
                    }
                    if (opcao == 'documento') {
                        $scope.docSacErro = false;
                        $scope.docCliErro = false;
                    }
                    if (opcao == 'valorDoc') {
                        $scope.docValErro = false;
                    }

                    $rootScope.loading = false;
                    //Foi colocado pq depois que é feito a busca pelo sacado, estava limpando os demais campos
                    $scope.novaRemessa.cgccic = Cgc;
                    $scope.novaRemessa.numdoc = NumDoc;
                    $scope.novaRemessa.tipodoc = tipoDoc;
                    $scope.novaRemessa.vencimento = vencimento;
                    $scope.novaRemessa.valor = valor;
                    $scope.novaRemessa.cmc7 = cmc7;
                    $scope.novaRemessa.numfatura = numFat;
                    $scope.novaRemessa.datafatura = dataFat;
                    $scope.novaRemessa.seriefatura = serieFat;
                    $scope.novaRemessa.valorfatura = valorFat;

                    $scope.novaRemessa.enderecos = $scope.enderecos;
                    $scope.novaRemessa.telefones = $scope.telefones;

                    $scope.novoEnd = false;
                }
            } else {
                if (opcao == 'dtVenc') {
                    if ($scope.novaRemessa.vencimento == undefined) {
                        $scope.dataInvalida = true;
                    } else {
                        var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                        var novaDataOperacao = $scope.converterData($scope.dataOperacao);

                        if (novoVencimento < novaDataOperacao) {
                            $scope.dtVencErro = true;
                        } else {
                            $scope.dtVencErro = false;
                        }
                    }
                }

                $scope.novaRemessa.cgccic = "";
                $scope.cpfInvalido = true;
            }
        }

        $scope.converterData = function (dataParm) {
            var dia = dataParm.substring(0, 2);
            var mes = dataParm.substring(3, 5);
            var ano = dataParm.substring(6, 10);

            var data = mes + '/' + dia + '/' + ano;
            var novoData = new Date(data);

            return novoData
        }

        $scope.pegaCEP = function (value, index) {
            var cep = value.CepId;
            var res;
            res = cep.replace(".", "");
            res = res.replace("-", "");
            cep = res;

            //Armazenando URL para consulta do CEP
            if (cep.length <= 7) {
                toastr.error('CEP inválido.', { timeOut: 1200 });
                return
            } else
                if (cep.length == 8) {
                    $rootScope.loading = true;

                    var url = 'https://viacep.com.br/ws/' + cep + '/xml/'
                    $http.get(url).then(function (response) {
                        $rootScope.loading = false;
                        $scope.JsonOutput = ngXml2json.parser(response.data)
                        if ($scope.JsonOutput.xmlcep.erro) {
                            toastr.error('CEP não Encontrado.', { timeOut: 1200 });
                            $scope.enderecos[index].CepLog = "";
                            $scope.enderecos[index].CepBai = "";
                            $scope.enderecos[index].CepComp = "";
                            $scope.enderecos[index].CidUf = "";
                        } else {
                            $scope.enderecos[index] = {};

                            $scope.enderecos[index].CepId = $scope.JsonOutput.xmlcep.cep;
                            $scope.enderecos[index].CepUF = $scope.JsonOutput.xmlcep.uf;

                            if ($scope.JsonOutput.xmlcep.localidade) {
                                $scope.enderecos[index].CepCid = $scope.JsonOutput.xmlcep.localidade;
                            }

                            if ($scope.JsonOutput.xmlcep.bairro.length > 0) {
                                $scope.enderecos[index].CepBai = $scope.JsonOutput.xmlcep.bairro;
                            }

                            if ($scope.JsonOutput.xmlcep.logradouro.length > 0) {
                                $scope.enderecos[index].CepLog = $scope.JsonOutput.xmlcep.logradouro;
                            }
                            $scope.enderecos[index].CepIbge = $scope.JsonOutput.xmlcep.ibge;
                            $scope.enderecos[index].CepOrg = 0;
                            $scope.enderecos[index].CidUf = $scope.JsonOutput.xmlcep.localidade + '/' + $scope.JsonOutput.xmlcep.uf;
                        }


                    }, function (error) {
                        $rootScope.loading = false;
                        toastr.error('CEP não Encontrado.', { timeOut: 1200 });
                    });
                }
        };

        $scope.cancelarEndereco = function (index) {
            $scope.removeEnd(index);
            $rootScope.flagEndereco = 0;
        }

        //Tratamento campo Endereços
        $scope.addEnd = function () {
            var tamanho = $scope.enderecos.length;
            var contador = 0;
            while (contador < tamanho) {
                if ($scope.enderecos[contador].CepId != undefined) {
                    $rootScope.flagEndereco = 0;
                } else {
                    $rootScope.flagEndereco = 1;
                }
                contador++;
            };//fim do laço

            if ($rootScope.flagEndereco == 0) {
                $rootScope.flagEndereco = 1;
                $scope.inserted = {
                    CEP: '',
                    logradouro: '',
                    complemento: '',
                    bairro: '',
                    ciduf: ''
                };

                $scope.inactive = false;
                $scope.enderecos.push($scope.inserted);
            }
        };

        $scope.removeEnd = function (index) {
            $scope.enderecos.splice(index, 1);
        };

        $scope.cancelarTelefone = function (index) {
            $scope.removeTel(index);
            $rootScope.flagTelefone = 0;
        }

        $scope.addTel = function () {
            var tamanho = $scope.telefones.length;
            var contador = 0;
            while (contador < tamanho) {
                if ($scope.telefones[contador].tipo != '') {
                    $rootScope.flagTelefone = 0;
                } else {
                    $rootScope.flagTelefone = 1;
                }
                contador++;
            };//fim do laço

            if ($rootScope.flagTelefone == 0) {
                $rootScope.flagTelefone = 1;
                $scope.inserted = {
                    tipo: '',
                    numero: '',
                    obs: ''
                };
                $scope.telefones.push($scope.inserted);
            }
        };

        $scope.removeTel = function (index) {
            $scope.telefones.splice(index, 1);
        };

        $scope.gravarDadosTitulo = function () {
            if ($scope.novaRemessa.cgccic != undefined && $scope.novaRemessa.nome != undefined
                && $scope.novaRemessa.vencimento != undefined && $scope.novaRemessa.numdoc != undefined
                && $scope.novaRemessa.valor != undefined && $scope.novaRemessa.tipodoc != undefined) {
                if ($scope.novaRemessa.vencimento != undefined) {
                    // if ($scope.novaRemessa.nascimento != undefined) {
                    
                    if ($scope.novaRemessa.email != undefined) {
   
                        if (($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS') && ($scope.novaRemessa.datafatura != '' || $scope.novaRemessa.datafatura != undefined)){
                            $scope.novaRemessa.datafatura = '';
                            $scope.novaRemessa.numfatura = '';
                            $scope.novaRemessa.seriefatura = '';
                            $scope.novaRemessa.valorfatura = '';
                        }         
                                         
                        if ((($scope.novaRemessa.datafatura == undefined || $scope.novaRemessa.datafatura == '') && ($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS')) ||
                        ($scope.novaRemessa.datafatura == undefined && ($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS') && !$scope.novaRemessaForm.datafatura.$dirty) ||
                        ($scope.novaRemessa.datafatura != undefined && ($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS'))) {

                        if ((($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS') && $scope.enderecos.length > 0) || ($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS')) {
                            //Este if é para manter a operacao para continuar incluido novos titulos na remessa,
                                //quando não estiver editando a remessa(operação)
                                if ($scope.operacao != 0) {
                                    $scope.novaRemessa.openumero = $scope.operacao;
                                    $scope.novaRemessa.docsequen = $scope.docsequen;
                                } else {
                                    if ($rootScope.operacao != 0) {
                                        $scope.novaRemessa.openumero = $rootScope.operacao;
                                    } else { $scope.novaRemessa.openumero = 0; }

                                };

                                //Validação do campo endereço
                                var tamanho = $scope.enderecos.length;
                                var contador = 0;
                                while (contador < tamanho) {
                                    if ($scope.enderecos[contador].CepId == null) {
                                        //código comentado abaixo permite remover a linha
                                        toastr.warning('Existe campo de endereço em branco para ser preenchido.', { timeOut: 1200 });
                                        return
                                    } else {
                                        if ($scope.enderecos[contador].CEP == '') {
                                            toastr.warning('Existe campo de endereço em branco para ser preenchido.', { timeOut: 1200 });
                                            return
                                        }
                                    }
                                    contador++;
                                };//fim do laço          

                                //Validação do campo telefone
                                tamanho = 0;
                                contador = 0;
                                if ($scope.telefones.length > 0) {
                                    tamanho = $scope.telefones.length;
                                    var lengthTel = $scope.telefones[contador].numero.length;
                                }

                                while (contador < tamanho) {
                                    if ($scope.telefones[contador].tipo == "") {
                                        toastr.warning('Existe telefone se o tipo informado.', { timeOut: 1200 });
                                        return
                                    } else {
                                        if (lengthTel < 8) {
                                            toastr.warning('Existe telefone inválido informado.', { timeOut: 1200 });
                                            return
                                        } else {
                                            $scope.telInvalido = false;
                                            if ($scope.telefones[contador].numero == '') {
                                                //código comentado abaixo permite remover a linha
                                                toastr.warning('Existe campo de telefone em branco para ser preenchido.', { timeOut: 1200 });
                                                return
                                            }
                                        }
                                    }

                                    contador++;
                                };//fim do laço   

                                //inicializando identificador de erro ao gravar
                                $scope.cmc7Erro = false;
                                $scope.docSacErro = false;
                                $scope.docCliErro = false;
                                $scope.dtVencErro = false;
                                $scope.docValErro = false;
                                $scope.numDocInvalido = false;

                                $rootScope.loading = true;
                                $http.post(layoutPaths.urlAPI.gravarTitulo, '{"titulo": ' + angular.toJson($scope.novaRemessa) + '}', { headers: { 'Authorization': storageService.getToken() }})
                                    .then(function (response) {

                                        if (response.data.retornaTitulosRemessa.status) {
                                            //zerando identificador de erro quando tiver sucesso
                                            $scope.cmc7Erro = false;
                                            $scope.docSacErro = false;
                                            $scope.docCliErro = false;
                                            $scope.dtVencErro = false;
                                            $scope.docValErro = false;
                                            $scope.numDocInvalido = false;

                                            $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                                            $scope.titulosRemessa = $scope.remessasOrdena;
                                            toastr.success('Título alterado com sucesso.', { timeOut: 1200 });
                                            $scope.operacao = response.data.retornaTitulosRemessa.openumero;

                                            $scope.dataOperacao = response.data.retornaTitulosRemessa.dataOperacao;
                                            $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                                            $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');

                                            $scope.novaRemessa = {};
                                            $scope.enderecos = [];
                                            $scope.telefones = [];
                                            $rootScope.loading = false;

                                            if ($scope.remessasOrdena) {
                                                //Paginação dos itens em grade
                                                $scope.pageSize = 10;
                                                $scope.totalItens = $scope.remessasOrdena.length;
                                                $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                                                $scope.currentPage = 1;
                                                $scope.maxSize = 6;
                                                $rootScope.loading = false;
                                            }

                                            $scope.alteraIcone();
                                            $scope.rest();
                                            $scope.ocultaPanel = false;
                                        } else {
                                            //Tratamento de erros ao gravar documento
                                            if (response.data.retornaTitulosRemessa.cmc7Erro) {
                                                $scope.cmc7Erro = true;
                                            }

                                            if (response.data.retornaTitulosRemessa.docSacErro) {
                                                $scope.docSacErro = true;
                                            }

                                            if (response.data.retornaTitulosRemessa.docCliErro) {
                                                $scope.docCliErro = true;
                                            }

                                            if (response.data.retornaTitulosRemessa.dtVencErro) {
                                                $scope.dtVencErro = true;
                                            }

                                            if (response.data.retornaTitulosRemessa.docValErro) {
                                                $scope.docValErro = true;
                                            }

                                            toastr.error(response.data.retornaTitulosRemessa.mensagem, { timeOut: 1200 });
                                            $rootScope.loading = false;
                                        }
                                    }, function (response) {
                                        toastr.error('Falha de conexão.', { timeOut: 1200 });
                                        $rootScope.loading = false;
                                    });
                            } else {
                                toastr.error('Deve ser preenchido um endereço para o sacado.', { timeOut: 1200 });
                            }
                        } else {
                            toastr.error('A data da fatura informada é inválida.', { timeOut: 1200 });
                        }
                    } else {
                        toastr.error('O e-mail informado é inválidoo.', { timeOut: 1200 });
                    }
                    // } else {
                    //     toastr.error('A data de nascimento informada é inválida.', { timeOut: 1200 });
                    // }
                } else {
                    toastr.error('O vencimento informado é inválido.', { timeOut: 1200 });
                }
            } else {

                $scope.novaRemessaForm.numdoc.$touched = true;
                $scope.novaRemessaForm.vencimento.$touched = true;
                $scope.novaRemessaForm.valor.$touched = true;
                $scope.novaRemessaForm.cgccic.$touched = true;
                $scope.novaRemessaForm.nome.$touched = true;
                return;
            }
        }

        //Editar um titulo da remessa
        $scope.editarTitulo = function (item) {
            $scope.ocultaPanel = true;
            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.editarTitulo, '{"sequencialDocumento": ' + angular.toJson(item.docsequen) + '}', { headers: { 'Authorization': storageService.getToken() }})
                .then(function (response) {
                    $scope.ocultar = true;
                    $scope.novaRemessa = response.data.retornaTituloRemessa;

                    if ($scope.novaRemessa.tipoPessoa == 'F') {
                        $scope.novaRemessa.cgccic = paddingLeft.alinharEsquerda($scope.novaRemessa.cgccic, 0, 11)
                    } else {
                        if ($scope.novaRemessa.tipoPessoa == 'J') {
                            $scope.novaRemessa.cgccic = paddingLeft.alinharEsquerda($scope.novaRemessa.cgccic, 0, 14)
                        }
                    }

                    $scope.enderecos = $scope.novaRemessa.enderecos;
                    $scope.telefones = $scope.novaRemessa.telefones;

                    $scope.novaRemessa.valor = formatarValor.ajustarValor($scope.novaRemessa.valor, 2, ',', '.')
                    $scope.novaRemessa.valorfatura = formatarValor.ajustarValor($scope.novaRemessa.valorfatura, 2, ',', '.')
                    $rootScope.loading = false;

                    $scope.validaTipo($scope.novaRemessa.tipodoc, '')

                    //Necessário para editar o título selecionado
                    $scope.operacao = response.data.retornaTituloRemessa.openumero;
                    $scope.docsequen = response.data.retornaTituloRemessa.docsequen;
                }, function (response) {
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.loading = false;
                });
        };

        $scope.verificaExclusao = function (item) {
            if (item.statusLote == 'NE') {
                $scope.remessaItem = item;
                $scope.open('app/pages/remessas/painel_remessa/removemodal.html', 'vm', 'excluir');
            } else {
                toastr.warning('Lote já enviado, entre em contato com a empresa para solicitar a exclusão.', { timeOut: 2400 });
            }
        }

        $scope.excluirTituloRemessa = function () {
            $http.post(layoutPaths.urlAPI.removerTitulo, '{"sequencialDocumento": ' + angular.toJson($scope.remessaItem.docsequen) + '}', { headers: { 'Authorization': storageService.getToken() }})
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        toastr.success(response.data.retornaTitulosRemessa.mensagem, { timeOut: 1200 });
                        $rootScope.loading = false;

                        if ($scope.remessasOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            if ($scope.totalItens == 0) {
                                $scope.dataOperacao = "";
                                $scope.qtdTitulos = "";
                                $scope.valorTitulos = "";
                                $state.go('empresa.remessas');
                            }
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }

                        if ($scope.ocultar) {
                            $scope.alteraIcone();
                        }
                    } else {
                        toastr.error('Título não pode ser excluído.', { timeOut: 1200 });
                    }
                }, function (response) {
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.loading = false;
                });
        };

        $scope.atualizarTela = function () {
            if ($scope.ocultar && $scope.mostraTelaDados != 'importa') {
                $scope.alteraIcone();
            }
        }

        $scope.enviarRemessa = function () {
            if ($scope.titulosRemessa) {
                var operacao = $rootScope.remessasEnviar.operacao;
                $rootScope.loading = true;
                // $scope.validar = false;
                $http.post(layoutPaths.urlAPI.validaConsistencia, '{"numeroOperacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}', { headers: { 'Authorization': storageService.getToken() }})
                    .then(function (response) {
                        //Populando o grid com o retorno dos dados do banco.
                        if (response.data.retorno.status) {
                            $rootScope.remessasEnviar = $scope.titulosRemessa;
                            $rootScope.remessasEnviar.operacao = operacao;
                            $rootScope.remessasEnviar.opeData = $scope.dataOperacao;

                            if ($scope.envioLote == 'L' || $scope.envioLote == '') {
                                $scope.open('app/pages/remessas/enviar_remessas/remessa.enviar.html', '');
                            } else {
                                if ($scope.fileStrings.length > 0) {

                                    $scope.filesSend = [];
                                    angular.forEach($scope.fileStrings, function (fileUp, i) {
                                        var fileReader = new FileReader();
            
                                        fileReader.onload = function (event) {
                                            var uri = event.target.result;
            
                                            $scope.filesSend.push({
                                                filename: fileUp.fileName,
                                                filetype: fileUp.fileType,
                                                filebase64: uri.split("base64,")[1]
                                            });
                                            setTimeout(function () {
                                                if (i == ($scope.fileStrings.length - 1)) {
                                                    var data = '{"files": { "operacao":' + $rootScope.remessasEnviar.operacao + ',  "files": ' + angular.toJson($scope.filesSend) + '}}';
                                                    $scope.uploadDocumento(data);            
                                                }
                                            }, 1000);
                                        };
            
                                        fileReader.readAsDataURL(fileUp.fileUpload);
                                    })
                                }else{
                                    $scope.atualizaStatusDoc();
                                } 
                            }
                        } else {
                            toastr.error('Existe documento inconsistente no lote!', { timeOut: 1200 });
                        }
                        $rootScope.loading = false;
                    }, function (response) {
                        toastr.error('Falha de conexão.', { timeOut: 1200 });
                        $rootScope.loading = false;
                    });
            } else {
                toastr.error('Não existe título no lote.', { timeOut: 1200 });
            };
        };

        $scope.enviarEmailDireto = function(){

            var data = '{"remessa": {'
            if ($scope.email.observacao != "" && $scope.email.observacao != undefined) {
                data += ' "observacao": ' + angular.toJson($scope.email.observacao) + ','
            } else {
                data += ' "observacao": ' + ' "" ' + ','
            };
            data += ' "operacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}}'

            $http.post(layoutPaths.urlAPI.enviarEmailDireto, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
        });
    }

    $scope.uploadDocumento = function (data) {
        $http.post(layoutPaths.urlAPI.uploadDocumentoEmail, data, {
            headers: {
                'Authorization': storageService.getToken()
            }
        })
            .then(function (response) {

                if (response.data.response) {
                    $scope.atualizaStatusDoc();
                }
            })

    }

    $scope.atualizaStatusDoc = function(){
        painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory()
        .then(function (response) {
            $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel;

            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.atualizaStatusDoc, '{"numeroOperacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}', { headers: { 'Authorization': storageService.getToken() }})
                .then(function (response) {
                    if (!$scope.servidorDisponivel) { //Se não estiver disponível
                        toastr.warning('Para que esta requisição seja processada o sistema da empresa ' + storageService.getNomeFactoring() + ' deve estar ativo.', { timeOut: 4000 });
                        $state.go('empresa.remessas');
                        $scope.enviarEmailDireto();
                    } else {
                        if (response.data.retorno.status) {
                            toastr.success(response.data.retorno.mensagem, { timeOut: 1200 });
                            $state.go('empresa.remessas');
                            $scope.enviarEmailDireto();
                        }
                    }
                }, function (error) {
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.loading = false;
                });
        }, function (response) {
            toastr.error('Falha ao reenviar lote de títulos. Entre em contato com a empresa ' + storageService.getNomeFactoring() + '.', { timeOut: 2500 });
        });
    }

        $scope.rest = function () {
            if ($scope.novaRemessaForm) {
                // $scope.novaRemessa.cgccic = "";
                $scope.novaRemessaForm.numdoc.$untouched = true;
                $scope.novaRemessaForm.numdoc.$touched = false;

                $scope.novaRemessaForm.vencimento.$untouched = true;
                $scope.novaRemessaForm.vencimento.$touched = false;

                $scope.novaRemessaForm.valor.$untouched = true;
                $scope.novaRemessaForm.valor.$touched = false;

                $scope.novaRemessaForm.cgccic.$untouched = true;
                $scope.novaRemessaForm.cgccic.$touched = false;

                $scope.novaRemessaForm.nome.$untouched = true;
                $scope.novaRemessaForm.nome.$touched = false;

                $scope.cpfInvalido = false;
                $scope.dataInvalida = false;
                $scope.novaRemessaForm.$setPristine();
            }
        }

        $scope.uploaderAnexos = new FileUploader();

        $scope.fileStrings = [];
        $rootScope.fileStrings = [];

        $scope.removeAnexo = function (obj) {
            var remFile = $scope.fileStrings.findIndex(function (item) {
                return item.$$hashKey === obj.$$hashKey;
            });
            $scope.fileStrings.splice(remFile, 1);
            $rootScope.fileStrings.splice(remFile,1);
        }

        $scope.uploaderAnexos.onAfterAddingFile = function (fileItem) {
            var data = (/[.]/.exec(fileItem.file.name)) ? /[^.]+$/.exec(fileItem.file.name) : undefined
            
            if (fileItem.file.size <= 5242880) {
                if ($scope.fileStrings.length >= 500) {
                    toastr.error('Você atingiu o limite de 500 arquivos no envio.', {
                        timeOut: 2400
                    });
                } else {
                    $scope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                    $rootScope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                }
            } else {
                toastr.error('Arquivo muito grande, não é possível anexar!', {
                    timeOut: 2400
                });
            }
            
        };
        $scope.email.observacao = ''; 
    }
})();
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .controller('painelRemessaController', remessaController);

    /** @ngInject */
    function remessaController($scope, FileUploader, ajusteDatas, ngXml2json, formatarValor, $uibModal, $state, $http, paddingLeft, toastr, $rootScope, layoutPaths, storageService, painelEmissaoBoletoFactory, painelFactoringFactory) {
        $scope.operacao = 0;
        $scope.docsequen = 0;
        $rootScope.dadosRemessa = "";
        $scope.titulosRemessa = "";
        $scope.mostraDtNasc = true;   
        $scope.email = {}    
        var permissoes = storageService.getPerFuncional();
        $scope.parametrosIniciais = function () {
            $rootScope.bancosCadastrados = "";
            $rootScope.cmc7Obr;
            $rootScope.chaveNfeObr;        

            //Buscando banco cadastrados
            $http.post(layoutPaths.urlAPI.carregarBancos, {}, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    $rootScope.loading = false;
                    $rootScope.bancosCadastrados = response.data.bancos.sdtBancosItem;
                }, function () {
                    toastr.error('Falha de conexão', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });                

            $rootScope.flagTelefone = 0;
            $rootScope.flagEndereco = 0;
            $scope.mostraCMC7NFe = false;

            $scope.ocultar = false;
            if (permissoes.substr(12,1) != '0'){
                $scope.ocultaImportacao = true;
            };
            if (permissoes.substr(13,1) != '0'){
                $scope.ocultaInclusao = true;
            };
            $scope.trocaBotao = true;
            $scope.tituloImportacao = 'Importar arquivos';

            $rootScope.showDetails = true;
            $scope.tituloIcone = 'Incluir novo título';
            $scope.novaRemessa = {}

            $scope.tipoDocumentos = [];
            if (permissoes.substr(6,1) != '0'){
                $scope.tipoDocumentos.push({id: "DP",nome: "DUPLICATA"})
            };
            if (permissoes.substr(7,1) != '0'){
                $scope.tipoDocumentos.push({id: "CH",nome: "CHEQUE"})
            };
            if (permissoes.substr(8,1) != '0'){
                $scope.tipoDocumentos.push({id: "DS",nome: "DUPLICATA DE SERVIÇO"})
            };
            if (permissoes.substr(9,1) != '0'){
                $scope.tipoDocumentos.push({id: "NP",nome: "NOTA PROMISSÓRIA"})
            };
            if (permissoes.substr(10,1) != '0'){
                $scope.tipoDocumentos.push({id: "NR",nome: "NOTA PROMISSÓRIA RURAL"})
            };
            if (permissoes.substr(11,1) != '0'){
                $scope.tipoDocumentos.push({id: "O",nome: "OUTROS"})
            };
            // $scope.tipoDocumentos = [{
            //     id: "CH",
            //     nome: 'CHEQUE'
            // },
            // {
            //     id: "DP",
            //     nome: 'DUPLICATA'
            // },
            // {
            //     id: "DS",
            //     nome: 'DUPLICATA DE SERVIÇO'
            // },
            // {
            //     id: "NP",
            //     nome: 'NOTA PROMISSÓRIA'
            // },
            // {
            //     id: "NR",
            //     nome: 'NOTA PROMISSÓRIA RURAL'
            // },
            // {
            //     id: "O",
            //     nome: 'OUTROS'
            // }
            // ];
            $scope.enderecos = [];
            $scope.tiposTelefones = [{
                id: 1,
                name: 'Celular'
            },
            {
                id: 2,
                name: 'Comercial'
            },
            {
                id: 3,
                name: 'Fax'
            },
            {
                id: 4,
                name: 'Residencial'
            },
            ];
        }

        $scope.alteraIcone = function () {
            $scope.mostraTelaDados = 'dados';
            if ($scope.ocultar == false) {
                $scope.mostraCMC7NFe = false;
                $scope.ocultarDadosFatura = false;
                $scope.ocultaImportacao = false;

                $scope.ocultar = true;
                $scope.novaRemessa = {};
                $scope.enderecos = [];
                $scope.telefones = [];
                $scope.docsequen = "";
                $scope.tituloIcone = 'Cancelar inclusão';
            } else {
                $scope.tituloIcone = 'Incluir novo título';
                $scope.rest();

                $scope.ocultar = false;
                if (permissoes.substr(12,1) != '0'){
                    $scope.ocultaImportacao = true;
                };
                //$scope.ocultaImportacao = true;
                $scope.ErroVencImport = false;
                $scope.ErroCliImport = false;
                $scope.ErroCnpjImport = false;
                $scope.dtVencErro = false;
                $scope.dataInvalida = false;

                $scope.cpfInvalido = false;
                $scope.tipoDocInvalido = false;
                $scope.numDocInvalido = false;

                $scope.docCliErro = false;
                $scope.docSacErro = false;
                $scope.numDocInvalido = false;

                $rootScope.flagTelefone = 0;
                $rootScope.flagEndereco = 0;

                $scope.mostraDtNasc = true;
            };
        };

        $scope.alteraIcone2 = function () {
            $scope.mostraTelaDados = 'importa';
            if ($scope.ocultar == false) {
                $scope.ocultar = true;
                $scope.ocultaInclusao = false;
                $scope.tituloIcone = 'Cancelar inclusão';
                $scope.trocaBotao = false;
                $scope.tituloImportacao = 'Fecha tela de importação';
            } else {
                $scope.tituloIcone = 'Incluir novo título';
                $scope.ocultar = false;
                if (permissoes.substr(13,1) != '0'){
                    $scope.ocultaInclusao = true;
                };
                //$scope.ocultaInclusao = true;
                $scope.trocaBotao = true;
                $scope.tituloImportacao = 'Importar arquivos';
                uploader.clearQueue();
            };
        };


        $scope.open = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'excluir') {
                    $scope.excluirTituloRemessa($scope.remessaItem);
                } else if (opcao.toLowerCase() == 'salvar') {
                    $scope.ocultar = true;
                } 
            }, function error() {
                $scope.ocultar = false;
            });
        };

        $scope.openVerificaEnvio = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'enviar') {
                    if($scope.envioLote == 'T'){
                        $scope.openEnvioDireto('app/pages/remessas/painel_remessa/observacao.html', 'vm', 'enviar');
                    }else{
                        $scope.enviarRemessa();
                    }
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };

        $scope.openEnvioDireto = function (page, size, opcao) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                scope: $scope
            });

            // promise
            modalInstance.result.then(function success() {
                if (opcao.toLowerCase() == 'enviar') {
                }
            }, function error() {
                $scope.ocultar = false;
            });
        };        

        $scope.validaTipo = function (tipo, chamada) {
            $scope.tipoDocInvalido = false;
            $scope.ocultarDadosFatura = false;
            $scope.labelDocumento = '';
            $scope.mostraCMC7NFe = false;
            $scope.cmc7Erro = false;
            $scope.cmc7NfeObr = false;

            if (tipo == 'CH') {
                $scope.ocultarDadosFatura = false;
                $scope.labelDocumento = 'CMC7';
                $scope.mostraCMC7NFe = true;
                if (chamada == 'tela') {
                    $scope.novaRemessaForm.cmc7.$untouched = true;
                    $scope.novaRemessaForm.cmc7.$touched = false;
                }
                //$scope.novaRemessa.cmc7 = '';
            } else {
                if (chamada == 'tela') {
                    $scope.novaRemessaForm.cmc7.$untouched = true;
                    $scope.novaRemessaForm.cmc7.$touched = false;
                }
                if (tipo == 'DP' || tipo == 'DS') {
                    $scope.ocultarDadosFatura = true;
                    if (tipo == 'DP') {
                        $scope.labelDocumento = 'Chave da NF-e';
                    } else {
                        $scope.labelDocumento = 'Código de Verificação da NFS-e';
                    }
                    $scope.mostraCMC7NFe = true;
                }

            };
        };

        //Caso for editar um titulo da remessa
        if ($rootScope.dadosRemessa) {
            $scope.titulosRemessa = $scope.dadosRemessa;
            $scope.pageSize = 10;
            $scope.totalItens = $scope.titulosRemessa.length;
            $scope.qtdPages = Math.ceil($scope.titulosRemessa.length / $scope.pageSize);
            $scope.currentPage = 1;
            $scope.maxSize = 6;
        };

        $scope.buscaTitulosNaoEnviados = function () {
            $rootScope.loading = true;
            $http.post(layoutPaths.urlAPI.buscarTitulosNaoEnviados, {}, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                        $scope.dataOperacao = response.data.retornaTitulosRemessa.dataOperacao;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;

                        if ($scope.remessasOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }
                    } else {
                        $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                        var novaData = new Date()
                        novaData = ajusteDatas.formatarData(novaData);
                        $scope.dataOperacao = novaData;
                        $scope.qtdTitulos = 0;
                        $scope.valorTitulos = "0,00";
                        $scope.mensagemVazio = response.data.retornaTitulosRemessa.mensagem;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;
                    }
                    $rootScope.loading = false;
                }, function () {
                    toastr.error('Falha de conexão.', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });
        }

        $scope.validarTituloDuplicado = function () {
            $scope.numDocInvalido = false;
            $scope.docCliErro = false;
            $scope.docSacErro = false
            $scope.ErroCliImport = false;

            if (($scope.novaRemessa.numdoc != '' && $scope.novaRemessa.numdoc != undefined) &&
                $scope.novaRemessa.tipodoc != undefined) {

                var data = '{"dadosTitulo": {'
                data += ' "tipoDoc": ' + angular.toJson($scope.novaRemessa.tipodoc) + ','

                if ($scope.novaRemessa.cgccic != "" && $scope.novaRemessa.cgccic != undefined) {
                    data += ' "cgccic": ' + angular.toJson($scope.novaRemessa.cgccic) + ','
                } else {
                    data += ' "cgccic": ' + ' "" ' + ','
                };

                if ($scope.novaRemessa.docsequen != "" && $scope.novaRemessa.docsequen != undefined) {
                    data += ' "docsequen": ' + angular.toJson($scope.novaRemessa.docsequen) + ','
                } else {
                    data += ' "docsequen": ' + ' "" ' + ','
                }

                data += ' "numDoc": ' + angular.toJson($scope.novaRemessa.numdoc) + '}}'

                $rootScope.loading = true;
                $http.post(layoutPaths.urlAPI.validarTituloDuplicado, data, {
                    headers: {
                        'Authorization': storageService.getToken()
                    }
                })
                    .then(function (response) {

                        if (response.data.validacao.docCliErro) {
                            $scope.docCliErro = true;
                        } else {
                            $scope.docCliErro = false;
                        }

                        if (response.data.validacao.docSacErro) {
                            $scope.docSacErro = true;
                        } else {
                            $scope.docSacErro = false;
                        }

                        $rootScope.loading = false;
                    }, function () {
                        toastr.error('Falha de conexão.', {
                            timeOut: 1200
                        });
                        $rootScope.loading = false;
                    });
            } else {
                $scope.numDocInvalido = true;
            }
        }

        $scope.buscaSacado = function (opcao) {
            if (opcao == 'cgccic') {
                $scope.cpfInvalido = false;
            }

            if (opcao == 'dtVenc') {
                $scope.dataInvalida = false;
                $scope.dtVencErro = false;
            }

            if (opcao == 'cmc7') {
                if($rootScope.cmc7Obr == true && ($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && $scope.novaRemessa.tipodoc == 'CH'){
                    $scope.cmc7NfeObr = true;
                }else if ($rootScope.chaveNfeObr == true && ($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && ($scope.novaRemessa.tipodoc == 'DP'|| $scope.novaRemessa.tipodoc == 'DS')){
                        $scope.cmc7NfeObr = true;
                    }else{
                        $scope.cmc7Erro = false;
                        $scope.cmc7NfeObr = false;
                    }
                }

            if ($scope.novaRemessa.cgccic != undefined && $scope.novaRemessa.cgccic != '') {
                var Cgc = $scope.novaRemessa.cgccic;
                var NumDoc = $scope.novaRemessa.numdoc;
                var tipoDoc = $scope.novaRemessa.tipodoc;
                var vencimento = $scope.novaRemessa.vencimento;
                var valor = $scope.novaRemessa.valor;
                var cmc7 = $scope.novaRemessa.cmc7;
                var numFat = $scope.novaRemessa.numfatura;
                var dataFat = $scope.novaRemessa.datafatura;
                var serieFat = $scope.novaRemessa.seriefatura;
                var valorFat = $scope.novaRemessa.valorfatura;

                if (opcao == 'cgccic') {
                    $rootScope.loading = true;
                    $http.post(layoutPaths.urlAPI.buscarDadosSacado, '{"cpfSacado": ' + angular.toJson($scope.novaRemessa.cgccic) + '}', {
                        headers: {
                            'Authorization': storageService.getToken()
                        }
                    })
                        .then(function (response) {
                            //Populando o grid com o retorno dos dados do banco.                        
                            $scope.novaRemessa = response.data.dadosSacado;
                            if ($scope.novaRemessa.tipopessoa == "F") {
                                $scope.mostraDtNasc = true;
                            } else {
                                $scope.mostraDtNasc = false;
                            }


                            if ($scope.novaRemessa.cgccic) {
                                $scope.ErroCnpjImport = false;
                                if ($scope.novaRemessa.enderecos != undefined) {
                                    $scope.enderecos = $scope.novaRemessa.enderecos;
                                } else {
                                    $scope.enderecos = [];
                                }

                                if ($scope.novaRemessa.telefones != undefined) {
                                    $scope.novaRemessa.telefones.forEach(function(opcao){
                                        if(opcao.numero != "0--------------"){
                                            opcao.numero = opcao.numero.replace(/\D/g, '');
                                            $scope.telefones.push(opcao);
                                        }
                                    })                         
                                } else {
                                    $scope.telefones = [];
                                }
                            } else {
                                $scope.enderecos = [];
                                $scope.telefones = [];
                            };
                            $rootScope.loading = false;
                            //Foi colocado pq depois que é feito a busca pelo sacado, estava limpando os demais campos
                            $scope.novaRemessa.cgccic = Cgc;
                            $scope.novaRemessa.numdoc = NumDoc;
                            $scope.novaRemessa.tipodoc = tipoDoc;
                            $scope.novaRemessa.vencimento = vencimento;
                            $scope.novaRemessa.valor = valor;
                            $scope.novaRemessa.cmc7 = cmc7;
                            $scope.novaRemessa.numfatura = numFat;
                            $scope.novaRemessa.datafatura = dataFat;
                            $scope.novaRemessa.seriefatura = serieFat;
                            $scope.novaRemessa.valorfatura = valorFat;

                            $scope.novaRemessa.enderecos = $scope.enderecos;
                            $scope.novaRemessa.telefones = $scope.telefones;

                            $scope.novoEnd = false;

                            $scope.validarTituloDuplicado();
                        });
                } else {
                    $rootScope.loading = false;
                    if (opcao == 'cmc7') {
                        if($rootScope.cmc7Obr == true && ($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && $scope.novaRemessa.tipodoc == 'CH'){
                            $scope.cmc7NfeObr = true;
                        }else if ($rootScope.chaveNfeObr == true && ($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && ($scope.novaRemessa.tipodoc == 'DP'|| $scope.novaRemessa.tipodoc == 'DS')){
                                $scope.cmc7NfeObr = true;
                        }else{
                            $scope.cmc7Erro = false;
                            $scope.cmc7NfeObr = false;
                        }
                    }
                    if (opcao == 'dtVenc') {
                        if ($scope.novaRemessa.vencimento == undefined) {
                            $scope.dataInvalida = true;
                        }

                        if ($scope.dataOperacao != undefined && $scope.novaRemessa.vencimento) {
                            var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                            var novaDataOperacao = $scope.converterData($scope.dataOperacao);

                            if (novoVencimento < novaDataOperacao) {
                                $scope.dtVencErro = true;
                            } else {
                                $scope.dtVencErro = false;
                            }
                        } else {
                            var dataDia = new Date();
                            dataDia = ajusteDatas.formatarData(dataDia);
                            if ($scope.novaRemessa.vencimento < dataDia) {
                                $scope.dtVencErro = true;
                            } else {
                                $scope.dtVencErro = false;
                            }
                        }

                        $scope.dtInfErro = false;
                        $scope.ErroVencImport = false;
                    }
                    if (opcao == 'documento') {
                        $scope.docSacErro = false;
                        $scope.docCliErro = false;
                        $scope.ErroCliImport = false;

                    }

                    if (opcao == 'valorDoc') {
                        $scope.docValErro = false;
                        if ($scope.novaRemessa.valor == '0,00') {
                            $scope.docValErro = true;
                        }
                    }

                    //Foi colocado pq depois que é feito a busca pelo sacado, estava limpando os demais campos
                    $scope.novaRemessa.cgccic = Cgc;
                    $scope.novaRemessa.numdoc = NumDoc;
                    $scope.novaRemessa.tipodoc = tipoDoc;
                    $scope.novaRemessa.vencimento = vencimento;
                    $scope.novaRemessa.valor = valor;
                    $scope.novaRemessa.cmc7 = cmc7;
                    $scope.novaRemessa.numfatura = numFat;
                    $scope.novaRemessa.datafatura = dataFat;
                    $scope.novaRemessa.seriefatura = serieFat;
                    $scope.novaRemessa.valorfatura = valorFat;

                    $scope.novaRemessa.enderecos = $scope.enderecos;
                    $scope.novaRemessa.telefones = $scope.telefones;

                    $scope.novoEnd = false;
                }
            } else {
                if (opcao == 'dtVenc') {
                    $scope.dataInvalida = false;
                    if ($scope.novaRemessa.vencimento == undefined) {
                        $scope.dataInvalida = true;
                    }
                    if ($scope.dataOperacao != undefined && ($scope.novaRemessa.vencimento != undefined && $scope.novaRemessa.vencimento != '')) {
                        //Foi necessário converter a data para fazer a comparação
                        var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                        var novaDataOperacao = $scope.converterData($scope.dataOperacao);

                        if (novoVencimento < novaDataOperacao) {
                            $scope.dtVencErro = true;
                        } else {
                            $scope.dtVencErro = false;
                        }
                    } else {
                        if (($scope.novaRemessa.vencimento != undefined && $scope.novaRemessa.vencimento != '')) {
                            var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                            var dataDia = new Date();
                            if (novoVencimento < dataDia) {
                                $scope.dtVencErro = true;
                            } else {
                                $scope.dtVencErro = false;
                            }
                        }
                    }
                }

                if (opcao == 'cgccic') {
                    $scope.novaRemessa.cgccic = "";
                    $scope.cpfInvalido = true;
                }

                if (opcao == 'valorDoc') {
                    if ($scope.novaRemessa.valor == '0,00') {
                        $scope.docValErro = true;
                    } else {
                        $scope.docValErro = false;
                    }
                }

            }
        }

        $scope.converterData = function (dataParm) {
            var dia = dataParm.substring(0, 2);
            var mes = dataParm.substring(3, 5);
            var ano = dataParm.substring(6, 10);

            var data = mes + '/' + dia + '/' + ano;
            var novoData = new Date(data);

            return novoData
        }

        $scope.pegaCEP = function (value, index) {
            var cep = value.CepId;
            var res;
            var logradouro;
            var bairro;
            res = cep.replace(".", "");
            res = res.replace("-", "");
            cep = res;


            //Armazenando URL para consulta do CEP
            if (cep.length <= 7) {
                toastr.error('CEP inválido', {
                    timeOut: 1200
                });
                return
            } else
                if (cep.length == 8) {
                    $rootScope.loading = true;
                    var url = 'https://viacep.com.br/ws/' + cep + '/xml/'
                    $http.get(url).then(function (response) {
                        $rootScope.loading = false;
                        $scope.JsonOutput = ngXml2json.parser(response.data)
                        if ($scope.JsonOutput.xmlcep.erro) {
                            toastr.error('CEP não Encontrado.', {
                                timeOut: 1200
                            });
                            $scope.enderecos[index].CepLog = "";
                            $scope.enderecos[index].CepBai = "";
                            $scope.enderecos[index].CepComp = "";
                            $scope.enderecos[index].CidUf = "";
                            $scope.enderecos[index].cepInvalido = 'S';
                        } else {
                            bairro = $scope.enderecos[index].CepBai;
                            logradouro = $scope.enderecos[index].CepLog;
                            $scope.enderecos[index] = {};
                            $scope.enderecos[index].cepInvalido = 'N';
                            $scope.enderecos[index].CepId = $scope.JsonOutput.xmlcep.cep;
                            $scope.enderecos[index].CepUF = $scope.JsonOutput.xmlcep.uf;

                            if ($scope.JsonOutput.xmlcep.localidade) {
                                $scope.enderecos[index].CepCid = $scope.JsonOutput.xmlcep.localidade;
                            }

                            if ($scope.JsonOutput.xmlcep.bairro.length > 0) {
                                $scope.enderecos[index].CepBai = $scope.JsonOutput.xmlcep.bairro;
                            }
                            else {
                                $scope.enderecos[index].CepBai = bairro;
                            }

                            if ($scope.JsonOutput.xmlcep.logradouro.length > 0) {
                                $scope.enderecos[index].CepLog = $scope.JsonOutput.xmlcep.logradouro;
                            }
                            else {
                                $scope.enderecos[index].CepLog = logradouro;
                            }


                            $scope.enderecos[index].CepIbge = $scope.JsonOutput.xmlcep.ibge;
                            $scope.enderecos[index].CepOrg = 0;
                            $scope.enderecos[index].CidUf = $scope.JsonOutput.xmlcep.localidade + '/' + $scope.JsonOutput.xmlcep.uf;
                        }

                    }, function () {
                        $rootScope.loading = false;
                        toastr.error('CEP não Encontrado.', {
                            timeOut: 1200
                        });
                    });

                }
        };

        $scope.cancelarEndereco = function (index) {
            $scope.removeEnd(index);
            $rootScope.flagEndereco = 0;
        }

        //Tratamento campo Endereços
        $scope.addEnd = function () {
            var tamanho = $scope.enderecos.length;
            var contador = 0;
            while (contador < tamanho) {
                if ($scope.enderecos[contador].CepId != undefined) {
                    $rootScope.flagEndereco = 0;
                } else {
                    $rootScope.flagEndereco = 1;
                }
                contador++;
            }; //fim do laço

            if ($rootScope.flagEndereco == 0) {
                $rootScope.flagEndereco = 1;
                $scope.inserted = {
                    CEP: '',
                    logradouro: '',
                    complemento: '',
                    bairro: '',
                    ciduf: ''
                };

                $scope.inactive = false;
                $scope.enderecos.push($scope.inserted);
            }
        };

        $scope.removeEnd = function (index) {
            $scope.enderecos.splice(index, 1);
        };

        $scope.cancelarTelefone = function (index) {
            $scope.removeTel(index);
            $rootScope.flagTelefone = 0;
        }

        $scope.addTel = function () {
            var tamanho = $scope.telefones.length;
            var contador = 0;
            while (contador < tamanho) {
                if ($scope.telefones[contador].tipo != '') {
                    $rootScope.flagTelefone = 0;
                } else {
                    $rootScope.flagTelefone = 1;
                }
                contador++;
            }; //fim do laço

            if ($rootScope.flagTelefone == 0) {
                $rootScope.flagTelefone = 1;
                $scope.inserted = {
                    tipo: '',
                    numero: '',
                    obs: ''
                };
                $scope.telefones.push($scope.inserted);
            }
        };

        $scope.removeTel = function (index) {
            $scope.telefones.splice(index, 1);
        };

        painelFactoringFactory.getPainelFactoringFactory()
            .then(function(response){
                $rootScope.cmc7Obr = response.sdtRetornaEmpresa.cmc7Obrigatorio;
                $rootScope.chaveNfeObr = response.sdtRetornaEmpresa.chaNfeObrigatorio;
            });

        $scope.gravarDadosTitulo = function () {
            if ($scope.novaRemessa.cgccic != undefined && $scope.novaRemessa.nome != undefined &&
                $scope.novaRemessa.vencimento != undefined && $scope.novaRemessa.numdoc != undefined &&
                $scope.novaRemessa.valor != undefined && $scope.novaRemessa.tipodoc != undefined) {

                if ($scope.novaRemessa.vencimento != undefined) {
                    // if ($scope.novaRemessa.nascimento != undefined) {
                    if ($scope.novaRemessa.email != undefined) {

                        if (($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS') && ($scope.novaRemessa.datafatura != '' || $scope.novaRemessa.datafatura != undefined)) {
                            $scope.novaRemessa.datafatura = '';
                            $scope.novaRemessa.numfatura = '';
                            $scope.novaRemessa.seriefatura = '';
                            $scope.novaRemessa.valorfatura = '';
                        }
                            if($scope.novaRemessa.cgccic.length <= 11){
                                $scope.novaRemessa.tipoPessoa = "F"
                            }else{
                                $scope.novaRemessa.tipoPessoa = "J"
                            }

                            if ((($scope.novaRemessa.datafatura == undefined || $scope.novaRemessa.datafatura == '') && ($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS')) ||
                                ($scope.novaRemessa.datafatura == undefined && ($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS') && !$scope.novaRemessaForm.datafatura.$dirty) ||
                                ($scope.novaRemessa.datafatura != undefined && ($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS'))) {

                                if((($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && $scope.novaRemessa.tipodoc == 'CH' && $rootScope.cmc7Obr == false) 
                                || (($scope.novaRemessa.cmc7 == undefined || $scope.novaRemessa.cmc7 == '') && ($scope.novaRemessa.tipodoc == 'DP'||$scope.novaRemessa.tipodoc == 'DS') && $rootScope.chaveNfeObr == false)
                                || ($scope.novaRemessa.cmc7 != undefined && $scope.novaRemessa.cmc7 != '')
                                || ($scope.novaRemessa.tipodoc != 'CH' && $scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS')){

                                    if ((($scope.novaRemessa.tipodoc == 'DP' || $scope.novaRemessa.tipodoc == 'DS') && $scope.enderecos.length > 0) || ($scope.novaRemessa.tipodoc != 'DP' && $scope.novaRemessa.tipodoc != 'DS')) {
                                        //Este if é para manter a operacao para continuar incluido novos titulos na remessa,
                                        //quando não estiver editando a remessa(operação)
                                        if ($scope.operacao != 0) {
                                            $scope.novaRemessa.openumero = $scope.operacao;
                                            $scope.novaRemessa.docsequen = $scope.docsequen;
                                        };

                                        //Validação do campo de endereço
                                        var tamanho = $scope.enderecos.length;
                                        var contador = 0;
                                        while (contador < tamanho) {
                                            if ($scope.enderecos[contador].CepId == null || $scope.enderecos[contador].CepId == 0) {
                                                //código comentado abaixo permite remover a linha
                                                toastr.warning('Existe campo de endereço em branco para ser preenchido.', {
                                                    timeOut: 1200
                                                });
                                                return
                                            } else {
                                                if ($scope.enderecos[contador].CEP == '') {
                                                    toastr.warning('Existe campo de endereço em branco para ser preenchido.', {
                                                        timeOut: 1200
                                                    });
                                                    return
                                                }
                                                if (!$scope.enderecos[contador].CepLog != false) {
                                                    toastr.warning('Campo logradouro em branco para ser preenchido.', {
                                                        timeOut: 1200
                                                    });
                                                    return
                                                }
                                                if (!$scope.enderecos[contador].CepBai != false) {
                                                    toastr.warning('Campo bairro em branco para ser preenchido.', {
                                                        timeOut: 1200
                                                    });
                                                    return
                                                }
                                                if (!$scope.enderecos[contador].CidUf != false) {
                                                    toastr.warning('CEP inválido, não possui Cidade/UF.', {
                                                        timeOut: 1200
                                                    });
                                                    return
                                                }
                                            }

                                            if ($scope.enderecos[contador].cepInvalido == 'S' && $scope.novaRemessa.validaCep == false) {
                                                toastr.warning('Existe endereço com CEP inválido.', {
                                                    timeOut: 1200
                                                });
                                                return
                                            }
                                            contador++;
                                        }; //fim do laço

                                        //Validação do campo telefone
                                        tamanho = 0;
                                        contador = 0;
                                        if ($scope.telefones.length > 0) {
                                            tamanho = $scope.telefones.length;
                                            var lengthTel = $scope.telefones[contador].numero.length;
                                        }

                                        while (contador < tamanho) {
                                            if ($scope.telefones[contador].tipo == "") {
                                                toastr.warning('Existe telefone se o tipo informado.', {
                                                    timeOut: 1200
                                                });
                                                return
                                            } else {
                                                if (lengthTel < 8) {
                                                    toastr.warning('Existe telefone inválido informado.', {
                                                        timeOut: 1200
                                                    });
                                                    return
                                                } else {
                                                    $scope.telInvalido = false;
                                                    if ($scope.telefones[contador].numero == '') {
                                                        //código comentado abaixo permite remover a linha
                                                        toastr.warning('Existe campo de telefone em branco para ser preenchido.', {
                                                            timeOut: 1200
                                                        });
                                                        return
                                                    }
                                                }
                                            }

                                            contador++;
                                        }; //fim do laço

                                        //inicializando identificador de erro ao gravar
                                        $scope.cmc7Erro = false;
                                        $scope.docSacErro = false;
                                        $scope.docCliErro = false;
                                        $scope.dtVencErro = false;
                                        $scope.docValErro = false;
                                        $scope.dtInfErro = false;
                                        $scope.ErroCliImport = false;
                                        $scope.ErroCnpjImport = false;
                                        $scope.ErroVencImport = false;
                                        $scope.dataInvalida = false;
                                        $scope.numDocInvalido = false;

                                        $rootScope.loading = true;

                                        $scope.novaRemessa.openumero = $scope.operacao;
                                        $http.post(layoutPaths.urlAPI.gravarTitulo, '{"titulo": ' + angular.toJson($scope.novaRemessa) + '}', {
                                            headers: {
                                                'Authorization': storageService.getToken()
                                            }
                                        })
                                            .then(function (response) {

                                                if (response.data.retornaTitulosRemessa.status) {
                                                    //zerando identificador de erro quando tiver sucesso
                                                    $scope.cmc7Erro = false;
                                                    $scope.docSacErro = false;
                                                    $scope.docCliErro = false;
                                                    $scope.dtVencErro = false;
                                                    $scope.docValErro = false;
                                                    $scope.dtInfErro = false;
                                                    $scope.ErroCliImport = false;
                                                    $scope.ErroCnpjImport = false;
                                                    $scope.ErroVencImport = false;
                                                    $scope.dataInvalida = false;
                                                    $scope.numDocInvalido = false;

                                                    $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                                                    $scope.titulosRemessa = $scope.remessasOrdena
                                                    toastr.success(response.data.retornaTitulosRemessa.mensagem, {
                                                        timeOut: 1200
                                                    });
                                                    $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                                                    $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;
                                                    $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;
                                                    $scope.dataOperacao = response.data.retornaTitulosRemessa.dataOperacao;
                                                    $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                                                    $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                                                    $scope.novaRemessa = {};
                                                    $scope.enderecos = [];
                                                    $scope.telefones = [];
                                                    $rootScope.loading = false;

                                                    if ($scope.remessasOrdena) {
                                                        //Paginação dos itens em grade
                                                        $scope.pageSize = 10;
                                                        $scope.totalItens = $scope.remessasOrdena.length;
                                                        $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                                                        $scope.currentPage = 1;
                                                        $scope.maxSize = 6;
                                                        $rootScope.loading = false;
                                                        $scope.mensagemVazio = "";
                                                    }

                                                    $scope.rest();

                                                    if ($scope.docsequen != 0) {
                                                        $scope.docsequen = '';
                                                        $scope.alteraIcone();
                                                    }

                                                    //$scope.open('app/pages/remessas/painel_remessa/painel.remessa.sucesso.html', 'vm', 'salvar');
                                                } else {
                                                    //Tratamento de erros ao gravar documento
                                                    if (response.data.retornaTitulosRemessa.cmc7Erro) {
                                                        $scope.cmc7Erro = true;
                                                    }

                                                    if (response.data.retornaTitulosRemessa.docSacErro) {
                                                        $scope.docSacErro = true;
                                                    }

                                                    if (response.data.retornaTitulosRemessa.docCliErro) {
                                                        $scope.docCliErro = true;
                                                    }

                                                    if (response.data.retornaTitulosRemessa.dtVencErro) {
                                                        $scope.dtVencErro = true;
                                                    }

                                                    if (response.data.retornaTitulosRemessa.docValErro) {
                                                        $scope.docValErro = true;
                                                    }

                                                    toastr.error(response.data.retornaTitulosRemessa.mensagem, {
                                                        timeOut: 1200
                                                    });
                                                    $rootScope.loading = false;
                                                }
                                            }, function () {
                                                toastr.error('Falha de conexão.', {
                                                    timeOut: 1200
                                                });
                                                $rootScope.loading = false;
                                            });
                                    } else {
                                        toastr.error('Deve ser preenchido um endereço para o sacado.', {
                                            timeOut: 1200
                                        });
                                    }
                                } else {
                                    if($scope.novaRemessa.tipodoc == 'CH'){
                                    toastr.error('O CMC7 é obrigatório.', {
                                        timeOut: 1200
                                    });
                                }else{
                                    toastr.error('A Chave da NF-e é obrigatória.', {
                                        timeOut: 1200
                                    });
                                }
                                    $scope.cmc7NfeObr = true;
                                }
                            } else {
                                toastr.error('A data da fatura informada é inválida.', {
                                    timeOut: 1200
                                });
                            }
                        } else {
                            toastr.error('O e-mail informado é inválido.', {
                                timeOut: 1200
                            });
                        }

                    // } else {
                    //     toastr.error('A data de nascimento informada é inválida.', { timeOut: 1200 });
                    // }
                } else {
                    toastr.error('O vencimento informado é inválido.', {
                        timeOut: 1200
                    });
                }
            } else {
                if ($scope.novaRemessa.tipodoc == undefined) {
                    $scope.tipoDocInvalido = true;
                }
                if ($scope.novaRemessa.cgccic == undefined) {
                    $scope.cpfInvalido = true;
                }

                if ($scope.novaRemessa.numdoc == undefined) {
                    $scope.numDocInvalido = true;
                }

                if ($scope.novaRemessa.vencimento == undefined) {
                    $scope.dataInvalida = true;
                } else {
                    var novoVencimento = $scope.converterData($scope.novaRemessa.vencimento);
                    var novaDataOperacao = $scope.converterData($scope.dataOperacao);

                    if (novoVencimento < novaDataOperacao) {
                        $scope.dtVencErro = true;
                    }
                }

                $scope.novaRemessaForm.numdoc.$touched = true;
                $scope.novaRemessaForm.vencimento.$touched = true;
                $scope.novaRemessaForm.valor.$touched = true;
                $scope.novaRemessaForm.cgccic.$touched = true;
                $scope.novaRemessaForm.nome.$touched = true;
                return;
            }

            $rootScope.flagTelefone = 0;
            $rootScope.flagEndereco = 0;
        }

        //Editar um titulo da remessa
        $scope.editarTitulo = function (item) {
            $rootScope.loading = true;

            $http.post(layoutPaths.urlAPI.editarTitulo, '{"sequencialDocumento": ' + angular.toJson(item.docsequen) + '}', {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {

                    $scope.ocultar = true;

                    if ($scope.mostraTelaDados == 'importa') {
                        $scope.ocultaInclusao = true;
                        $scope.tituloIcone = 'Cancelar inclusão';
                        $scope.trocaBotao = true;
                    }

                    $scope.mostraTelaDados = 'dados';
                    $scope.novaRemessa = response.data.retornaTituloRemessa;
                    if ($scope.novaRemessa.tipoPessoa == 'F') {
                        $scope.novaRemessa.cgccic = paddingLeft.alinharEsquerda($scope.novaRemessa.cgccic, 0, 11)
                    } else {
                        if ($scope.novaRemessa.tipoPessoa == 'J') {
                            $scope.novaRemessa.cgccic = paddingLeft.alinharEsquerda($scope.novaRemessa.cgccic, 0, 14)
                        }
                    }

                    $scope.enderecos = $scope.novaRemessa.enderecos;
                    $scope.telefones = $scope.novaRemessa.telefones;
                    //Apresentar mensagem de inconsistência no título
                    if (item.vencErro) {
                        $scope.ErroVencImport = true;
                    } else {
                        $scope.ErroVencImport = false;
                    }

                    if (item.cliErro) {
                        $scope.ErroCliImport = true;
                    } else {
                        $scope.ErroCliImport = false;
                    }

                    if (item.cnpjErro) {
                        $scope.ErroCnpjImport = true;
                    } else {
                        $scope.ErroCnpjImport = false;
                    }

                    $scope.novaRemessa.valor = formatarValor.ajustarValor($scope.novaRemessa.valor, 2, ',', '.')
                    $scope.novaRemessa.valorfatura = formatarValor.ajustarValor($scope.novaRemessa.valorfatura, 2, ',', '.')
                    $rootScope.loading = false;

                    $scope.validaTipo($scope.novaRemessa.tipodoc, '')
                    $scope.ocultaImportacao = false;

                    //Necessário para editar o título selecionado
                    $scope.operacao = response.data.retornaTituloRemessa.openumero;
                    $scope.docsequen = response.data.retornaTituloRemessa.docsequen;
                }, function () {
                    toastr.error('Falha de conexão', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });
        };

        $scope.verificaExclusao = function (item) {
            $scope.remessaItem = item;
            $scope.open('app/pages/remessas/painel_remessa/removemodal.html', 'vm', 'excluir');
        }

        $scope.verificaEnvio = function () {
            $scope.identificaErro = false;
            $scope.identificaSucesso = false
            $scope.titulosRemessa.find(function (item) {
                if (item.docinderr === 'S') {
                    $scope.identificaErro = true;
                }
                if (item.docinderr === 'N') {
                    $scope.identificaSucesso = true;
                }
            });

            $scope.openVerificaEnvio('app/pages/remessas/painel_remessa/verifica.envio.modal.html', 'vm', 'enviar');
        }

        $scope.excluirTituloRemessa = function () {
            $http.post(layoutPaths.urlAPI.removerTitulo, '{"sequencialDocumento": ' + angular.toJson($scope.remessaItem.docsequen) + '}', {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;

                        toastr.success(response.data.retornaTitulosRemessa.mensagem, {
                            timeOut: 1200
                        });
                        $rootScope.loading = false;

                        if ($scope.remessasOrdena) {
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            if ($scope.totalItens == 0) {
                                var novaData = new Date()
                                $scope.mensagemVazio = "Nenhuma informação encontrada.";
                                novaData = ajusteDatas.formatarData(novaData);
                                $scope.dataOperacao = novaData;
                                $scope.qtdTitulos = 0;
                                $scope.valorTitulos = "0,00";
                                $rootScope.operacao = '';
                            }
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }

                        if ($scope.ocultar && $scope.mostraTelaDados != 'importa') {
                            $scope.alteraIcone();
                        } else {
                            if ($scope.ocultar && $scope.mostraTelaDados == 'importa') {
                                $scope.alteraIcone2();
                            }
                        }

                    } else {
                        toastr.error('Título não pode ser excluído.', {
                            timeOut: 1200
                        });
                    }
                }, function () {
                    toastr.error('Falha de conexão.', {
                        timeOut: 1200
                    });
                    $rootScope.loading = false;
                });
        };

        $scope.enviarRemessa = function () {

            if ($scope.titulosRemessa) {
                var operacao = $scope.operacao
                $rootScope.loading = true;
                $rootScope.remessasEnviar = $scope.titulosRemessa;
                $rootScope.remessasEnviar.operacao = operacao;
                $rootScope.remessasEnviar.opeData = $scope.dataOperacao;

                if ($scope.envioLote == 'L' || $scope.envioLote == '') {

                    $scope.open('app/pages/remessas/enviar_remessas/remessa.enviar.html', '');

                    if ($scope.mostraTelaDados == 'importa') {
                        $scope.alteraIcone2();
                    } else {
                        if ($scope.ocultar) {
                            $scope.alteraIcone();
                        }
                    }
                } else {
                    
                    if ($scope.fileStrings.length > 0) {

                        $scope.filesSend = [];
                        angular.forEach($scope.fileStrings, function (fileUp, i) {
                            var fileReader = new FileReader();

                            fileReader.onload = function (event) {
                                var uri = event.target.result;
                                //console.log(uri)

                                $scope.filesSend.push({
                                    filename: fileUp.fileName,
                                    filetype: fileUp.fileType,
                                    filebase64: uri.split("base64,")[1]
                                });
                                //console.log($scope.filesSend)
                                setTimeout(function () {
                                    if (i == ($scope.fileStrings.length - 1)) {
                                        var data = '{"files": { "operacao":' + $scope.operacao + ',  "files": ' + angular.toJson($scope.filesSend) + '}}';
                                        $scope.uploadDocumento(data);

                                    }
                                }, 1000);
                            };

                            fileReader.readAsDataURL(fileUp.fileUpload);
                        })
                    } else {
                        $scope.atualizaStatusDoc();
                    }

                }

                $rootScope.loading = false;

            } else {
                toastr.error('Não existe título no lote.', {
                    timeOut: 1200
                });
            };
        };

        $scope.uploadDocumento = function (data) {
            $http.post(layoutPaths.urlAPI.uploadDocumentoEmail, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {

                    if (response.data.response) {
                        $scope.atualizaStatusDoc();
                    }
                })

        }


        $scope.atualizaStatusDoc = function () {
            painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory()
                .then(function (response) {
                    $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel;

                    $rootScope.loading = true;
                    $http.post(layoutPaths.urlAPI.atualizaStatusDoc, '{"numeroOperacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}', {
                        headers: {
                            'Authorization': storageService.getToken()
                        }
                    })
                        .then(function (response) {
                            if (!$scope.servidorDisponivel) { //Se não estiver disponível
                                toastr.warning('Para que esta requisição seja processada o sistema da empresa ' + storageService.getNomeFactoring() + ' deve estar ativo.', {
                                    timeOut: 4000
                                });
                                $scope.enviarEmailDireto();
                                $state.go('empresa.remessas');
                            } else {
                                if (response.data.retorno.status) {
                                    toastr.success(response.data.retorno.mensagem, {
                                        timeOut: 1200
                                    });
                                    $scope.enviarEmailDireto();
                                    $state.go('empresa.remessas');
                                }
                            }
                        }, function () {
                            toastr.error('Falha de conexão.', {
                                timeOut: 1200
                            });
                            $rootScope.loading = false;
                        });
                }, function () {

                    toastr.error('Falha ao tentar enviar lote de títulos. Entre em contato com a empresa ' + storageService.getNomeFactoring() + '.', {
                        timeOut: 2500
                    });
                });
        }

        $scope.enviarEmailDireto = function(){

            var data = '{"remessa": {'
            if ($scope.email.observacao != "") {
                data += ' "observacao": ' + angular.toJson($scope.email.observacao) + ','
            } else {
                data += ' "observacao": ' + ' "" ' + ','
            };
            data += ' "operacao": ' + angular.toJson($rootScope.remessasEnviar.operacao) + '}}'

            $http.post(layoutPaths.urlAPI.enviarEmailDireto, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            });
        }

        $scope.rest = function () {
            if ($scope.novaRemessaForm) {

                // $scope.novaRemessa.cgccic = "";
                $scope.novaRemessaForm.numdoc.$untouched = true;
                $scope.novaRemessaForm.numdoc.$touched = false;

                $scope.novaRemessaForm.vencimento.$untouched = true;
                $scope.novaRemessaForm.vencimento.$touched = false;

                $scope.novaRemessaForm.valor.$untouched = true;
                $scope.novaRemessaForm.valor.$touched = false;

                $scope.novaRemessaForm.cgccic.$untouched = true;
                $scope.novaRemessaForm.cgccic.$touched = false;

                $scope.novaRemessaForm.nome.$untouched = true;
                $scope.novaRemessaForm.nome.$touched = false;

                $scope.cpfInvalido = false;
                $scope.tipoDocInvalido = false;
                $scope.novaRemessaForm.$setPristine();
            }
        }

        //********************************************************************************
        //*************************** IMPORTAÇÃO DE ARQUIVO *****************************
        //********************************************************************************
        $scope.desabilitarItem = false;

        var uploader = $scope.uploader = new FileUploader({
            url: layoutPaths.urlAPI.carregarArquivo,
            headers: {
                'Authorization': storageService.getToken()
            }
        });

        // FILTERS
        uploader.filters.push({
            name: 'customFilter',
            fn: function () {
                $scope.tamanho = this.queue.length;
                return this.queue.length < 50;
            }

        });

        $scope.remover = function () {
            $scope.desabilitarItem = false;
        }

        // CALLBACKS
        uploader.onWhenAddingFileFailed = function () { };

        uploader.onAfterAddingFile = function () { };

        uploader.onBeforeUploadItem = function () { };

        uploader.onProgressItem = function () { };

        uploader.onProgressAll = function () { };

        uploader.onErrorItem = function () { };

        uploader.onSuccessItem = function (fileItem, response, status, headers) {
            $scope.retorno = response.object_id;
            $scope.desabilitarItem = true;
            if ($rootScope.operacao) {
                var operacao = $rootScope.operacao;
            } else {
                var operacao = 0;
            }

            var data = ' {"dadosRemessa": ' + '{"caminho": ' + angular.toJson($scope.retorno.replace("gxupload:", "")) + ',' +
                ' "operacao": ' + operacao + '}}';

            $scope.ativaLoading = true;
            $scope.contaImporta = 0;
            $scope.erroImportacao = false;
            $http.post(layoutPaths.urlAPI.importarArquivo, data, {
                headers: {
                    'Authorization': storageService.getToken()
                }
            })
                .then(function (response) {
                    if (response.data.retornaTitulosRemessa.status) {
                        $scope.contaImporta += 1;
                        uploader.onCompleteItem(fileItem, response, status, headers)
                        $scope.remessasOrdena = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
                        $scope.titulosRemessa = $scope.remessasOrdena;
                        $rootScope.operacao = response.data.retornaTitulosRemessa.openumero;
                        $scope.operacao = response.data.retornaTitulosRemessa.openumero;
                        $scope.dataOperacao = response.data.retornaTitulosRemessa.dataOperacao;
                        $scope.qtdTitulos = response.data.retornaTitulosRemessa.qtdTitulos;
                        $scope.valorTitulos = formatarValor.ajustarValor(response.data.retornaTitulosRemessa.valorTitulos, 2, ',', '.');
                        $scope.envioLote = response.data.retornaTitulosRemessa.envioLote;


                        if ($scope.remessasOrdena) {
                            $scope.mensagemVazio = '';
                            //Paginação dos itens em grade
                            $scope.pageSize = 10;
                            $scope.totalItens = $scope.remessasOrdena.length;
                            $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
                            $scope.currentPage = 1;
                            $scope.maxSize = 6;
                            $rootScope.loading = false;
                        }

                        toastr.success(response.data.retornaTitulosRemessa.mensagem, {
                            timeOut: 2000
                        });
                        //Para fechar o panel de importação somente após importar o último arquivo
                        if (($scope.contaImporta == $scope.tamanho || $scope.tamanho == 0) && !$scope.erroImportacao) {
                            $scope.alteraIcone2();
                        }

                    } else {
                        toastr.error(response.data.retornaTitulosRemessa.mensagem, {
                            timeOut: 2000
                        });
                        uploader.onErrorItem(fileItem, response, status, headers);
                    };
                    $scope.ativaLoading = false;
                }, function () {
                    toastr.error('Houve falha ao tentar importar o arquivo.', {
                        timeOut: 4200
                    });
                    $rootScope.loading = false;
                });
        };

        uploader.onCompleteItem = function (fileItem) {
            fileItem.isSucess = true;
        };

        uploader.onErrorItem = function (fileItem) {
            fileItem.isSucess = false;
            $scope.erroImportacao = true;
        };

        uploader.onCancelItem = function () {

        };

        $scope.uploaderAnexos = new FileUploader();

        $scope.fileStrings = [];
        $rootScope.fileStrings = [];

        $scope.removeAnexo = function (obj) {
            var remFile = $scope.fileStrings.findIndex(function (item) {
                return item.$$hashKey === obj.$$hashKey;
            });
            $scope.fileStrings.splice(remFile, 1);
            $rootScope.fileStrings.splice(remFile,1);
        }

        $scope.uploaderAnexos.onAfterAddingFile = function (fileItem) {
            var data = (/[.]/.exec(fileItem.file.name)) ? /[^.]+$/.exec(fileItem.file.name) : undefined
            
            if (fileItem.file.size <= 5242880) {
                if ($scope.fileStrings.length >= 500) {
                    toastr.error('Você atingiu o limite de 500 arquivos no envio.', {
                        timeOut: 2400
                    });
                } else {
                    $scope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                    $rootScope.fileStrings.push({
                        name: fileItem.file.name,
                        size: fileItem.file.size,
                        fileUpload: fileItem._file,
                        fileType: data[0],
                        fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
                    });
                    //console.log($rootScope.fileStrings)
                }
            } else {
                toastr.error('Arquivo muito grande, não é possível anexar!', {
                    timeOut: 2400
                });
            }
            
        };

        $scope.email.observacao = ''; 
    }
})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

angular.module('DifactWeb.pages')
.service("buscaInstService", function ($http, $q, layoutPaths, $rootScope, storageService) {
 
    var deferred = $q.defer();
    this.getAccount = function () {
        return $http.post(layoutPaths.urlAPI.carregarBancos, {}, { headers: { 'Authorization': storageService.getToken() } })
            .then(function (response) {
                // promise is fulfilled
                deferred.resolve(response.data.bancos.sdtBancosItem);
                // promise is returned
                return deferred.promise;
            }, function (response) {
                // the following line rejects the promise 
                deferred.reject(response);
                // promise is returned
                return deferred.promise;
            })
        ;
    };
});

(function () {
  'use strict';

  angular.module('DifactWeb.pages')
    .controller('painelRemessasController', RemessasController);

  /** @ngInject */
  function RemessasController($scope, $uibModal, $interval, $window, toastr, $state, buscaInstService, $http, painelEmissaoBoletoFactory, $rootScope, layoutPaths, storageService, $stateParams, FileUploader) {

    $scope.myVar = setInterval(function () { myTimer() }, 10000);

    function myTimer() {
      $scope.buscarRemessasCadastradas();
    }

    function myStopFunction() {
      clearInterval($scope.myVar);
    }

    //Buscando instituições financeiras para possibilitar preencher o combo de seleção ao enviar a remessa para a Factoring
    buscaInstService.getAccount()
      .then(
        function (result) {
          //rootScope utilizado no objeto SelectpicherPanelCtrl.js
          $rootScope.bancosCadastrados = result;
        },
        function (error) {
          // handle errors here
          console.log(error.statusText);
        }
      );

    //inicializando variáveis
    $scope.email = {};
    $rootScope.showDetails = true;
    $scope.remessas = [];
    $rootScope.dadosRemessa = "";
    $rootScope.dataEnvio = "";
    $rootScope.retornaTitulos = "";
    $rootScope.operacao = "";
    $scope.pagination = {
      currentPage: 1,
      pageSize: 10,
      maxSize: 5
    };
    $scope.fileUploadOptions = {
      notetext: "text",
      progress: 0
    };
    $scope.email = {};

    $scope.open = function (page, size) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size
      });

      modalInstance.result.then(function success() {
        $scope.excluirRemessa();
      }), function error() {

      }
    };

    $scope.$on('$destroy', function () {
      myStopFunction()
    });

    $scope.buscarRemessasCadastradas = function () {
      $rootScope.loading = true;
      $http.post(layoutPaths.urlAPI.buscarRemessas, '{"currentPage": ' + $scope.pagination.currentPage + '}', { headers: { 'Authorization': storageService.getToken() } })
        .then(function (response) {
          //Populando o grid com o retorno dos dados do banco.
          if (response.data.retornaRemessas.status) {
            $scope.remessasOrdena = response.data.retornaRemessas.sdtRemessasItem;
            $scope.remessas = $scope.remessasOrdena
            $scope.permiteBoleto = response.data.retornaRemessas.permiteBoleto;
            $scope.permiteDuplicata = response.data.retornaRemessas.permiteDuplicata;
            $scope.envioLote = response.data.retornaRemessas.envioLote;

            $scope.totalItens = response.data.retornaRemessas.totalItens;
            $scope.qtdPages = Math.ceil($scope.totalItens / $scope.pagination.pageSize);


            // if ($scope.remessasOrdena) {
            //   //Paginação dos itens em grade
            //   $scope.pageSize = 10;
            //   $scope.totalItens = $scope.remessasOrdena.length;
            //   $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
            //   $scope.currentPage = 1;
            //   $scope.maxSize = 6;
            // }

            //Verifica se tem lote em aguarde. Caso não tenha, parar o procedimento de monitoramento.
            var tamanho = $scope.remessas.length;
            var contador = 0;
            var existe = false;
            while (contador < tamanho) {

              if ($scope.remessas[contador].statusLote == 'AP' || $scope.remessas[contador].statusLote == 'AR') {
                existe = true;
                break;
              }
              contador++;
            }

            if (!existe) {
              myStopFunction();
            }
          } else {
            $scope.mensagemVazio = response.data.retornaRemessas.mensagem;
          }
          $rootScope.loading = false;
        }, function (response) {
          toastr.error('Falha de conexão.', { timeOut: 1200 });
          $rootScope.loading = false;
        });
    }

    $scope.editarRemessa = function (item) {
      $rootScope.remessasEnviar = item;
      $rootScope.operacao = item.operacao;

      $rootScope.loading = true; //ativa Loading
      $http.post(layoutPaths.urlAPI.buscarTitulos, '{"numeroOperacao": ' + angular.toJson(item.operacao) + ',"LotTip": ""}', { headers: { 'Authorization': storageService.getToken() } })
        .then(function (response) {
          //Populando o grid com o retorno dos dados do banco.
          $rootScope.dataEnvio = response.data.retornaTitulosRemessa.dataEnvio;
          $rootScope.dadosRemessa = response.data.retornaTitulosRemessa.sdtRetornaTitulosRemessaItem;
          $rootScope.retornaTitulos = response.data.retornaTitulosRemessa;
          //Redirecionando para página de inclusão de novos títulos na remessa
          $state.go('empresa.alteraremessa');
          $rootScope.loading = false; //desativa Loading
        });
    };

    $scope.imprimeBoleto = function (item) {
      //window.open(item.boleto);
      var dlnk = document.getElementById('dwnldLnk');
      dlnk.href = item.boleto;
      dlnk.click();
    }

    $scope.imprimeDuplicata = function (item) {

      var dadosOperacao = '{"dadosOperacao": {';
      dadosOperacao += ' "operacao": ' + angular.toJson(item.operacao) + ',';
      dadosOperacao += ' "opeData": ' + angular.toJson(item.data);
      dadosOperacao += '}}';

      $http.post(layoutPaths.urlAPI.imprimeDuplicata, dadosOperacao, { headers: { 'Authorization': storageService.getToken() } })
        .then(function (response) {
          var cnpjEmpresa = response.data.retornoDadosDuplicata.clicod;
          if (response.data.retornoDadosDuplicata.status) {

            $scope.urlArquivo = layoutPaths.urlAPI.abrirArquivo + 'duplicatas/' + 'Copia_de_Duplicatas' + $stateParams.empfaccod + $stateParams.empcod.padStart(3,'0')  + cnpjEmpresa + '.pdf'
            //window.open($scope.urlArquivo);
            var dlnk = document.getElementById('dwnldDup');
            dlnk.href = $scope.urlArquivo;
            dlnk.target = '_blank';
            dlnk.click();
          }

        }, function (error) {
          toastr.error('Não foi possível gerar a Duplicata.', { timeOut: 1200 });
          $rootScope.loading = false;
          $rootScope.bloquearTela = false;
        });
    }

    $scope.enviarLote = function (item) {
      var operacao = item.operacao
      //$rootScope.loading = true;

      painelEmissaoBoletoFactory.getPainelMonitoraDisponivelFactory()
        .then(function (response) {
          $scope.servidorDisponivel = response.monitoraDisponivel.monitoraDisponivel;
          $rootScope.loading = true;
          // $scope.validar = false;
          $http.post(layoutPaths.urlAPI.validaConsistencia, '{"numeroOperacao": ' + angular.toJson(operacao) + '}', { headers: { 'Authorization': storageService.getToken() } })
            .then(function (response) {
              //Populando o grid com o retorno dos dados do banco.
              if (response.data.retorno.status) {
                $rootScope.loading = true;
                $http.post(layoutPaths.urlAPI.atualizaStatusDoc, '{"numeroOperacao": ' + angular.toJson(operacao) + '}', { headers: { 'Authorization': storageService.getToken() } })
                  .then(function (response) {
                    if ($scope.servidorDisponivel) {
                      if (response.data.retorno.status) {
                        $scope.myVar = setInterval(function () { myTimer() }, 5000);
                        toastr.success(response.data.retorno.mensagem, { timeOut: 1200 });
                        $scope.buscarRemessasCadastradas();
                        $scope.Observacao(operacao);
                      }
                      $rootScope.loading = false;
                    } else {
                      $scope.myVar = setInterval(function () { myTimer() }, 5000);
                      toastr.warning('Para que esta requisição seja processada o sistema da empresa ' + storageService.getNomeFactoring() + ' deve estar ativo.', { timeOut: 4000 });
                      $scope.buscarRemessasCadastradas();
                      $scope.Observacao(operacao);
                    }

                  }, function (error) {
                    toastr.error('Falha de conexão.', { timeOut: 1200 });
                    $rootScope.loading = false;
                  });
              } else {
                toastr.error('Existe título inconsistente no lote.', { timeOut: 1500 });
              }

              $rootScope.loading = false;
            }, function (error) {
              toastr.error('Falha de conexão.', { timeOut: 1200 });
              $rootScope.loading = false;
            });
        });
    }

    //Campo de observação para ser enviado para factoring
    //Tomás Machado

    $scope.Observacao = function (operacao) {
      $scope.email.numeroOperacao = operacao;
      $scope.openVerificaEnvio('app/pages/remessas/painel_remessas/observacao.html', 'vm', 'enviar');
    }

    $scope.enviarEmail = function (lote) {
      var data = '{"remessa": {'
      if ($scope.email.observacao != "") {
        data += ' "observacao": ' + angular.toJson($scope.email.observacao) + ','
      } else {
        data += ' "observacao": ' + ' "" ' + ','
      };
      data += ' "operacao": ' + angular.toJson(lote) + '}}'


      $http.post(layoutPaths.urlAPI.enviarEmailDireto, data, {
        headers: {
          'Authorization': storageService.getToken()
        }
      }).then(function () {
        $scope.email.observacao = '';
      })
    }

    $scope.openVerificaEnvio = function (page, size, opcao) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope
      });

      // promise
      modalInstance.result.then(function success() {
        if (opcao.toLowerCase() == 'enviar') {
          toastr.success('E-mail enviado com sucesso', { timeOut: 1200 });
        }
      }, function () {
        $scope.email.observacao = '';
      });
    };

    //*********************************************************************** */
    $scope.verificaExclusao = function (item) {
      if (item.statusLote == 'NE') {
        $scope.remessaItem = item;
        $scope.open('app/pages/remessas/painel_remessas/removemodal.html', 'vm');
      } else {
        toastr.warning('Lote já enviado, entre em contato com a empresa para solicitar a exclusão.', { timeOut: 2400 });
      }
    }

    $scope.excluirRemessa = function () {
      $rootScope.loading = true;
      $http.post(layoutPaths.urlAPI.removerRemessa, '{"numeroRemessa": ' + angular.toJson($scope.remessaItem.operacao) + '}', { headers: { 'Authorization': storageService.getToken() } })
        .then(function (response) {

          if (response.data.retornaRemessas.status) {
            $scope.buscarRemessasCadastradas()
            // $scope.remessas = [];
            // $scope.remessas = response.data.retornaRemessas.sdtRemessasItem;
            // $scope.remessasOrdena = $scope.remessas
            toastr.success(response.data.retornaRemessas.mensagem, { timeOut: 1200 });
            $rootScope.loading = false;
          } else {
            toastr.error('Lote de Títulos não pode ser excluído.', { timeOut: 1200 });
          }
          //Paginação dos itens em grade
          // $scope.pageSize = 10;
          // $scope.totalItens = $scope.remessasOrdena.length;
          // $scope.qtdPages = Math.ceil($scope.remessasOrdena.length / $scope.pageSize);
          // $scope.currentPage = 1;
          // $scope.maxSize = 6;

          if ($scope.totalItens == 0) {
            $scope.mensagemVazio = "Nenhuma informação encontrada.";
          }
        }, function (response) {
          toastr.error('Falha de conexão.', { timeOut: 1200 });
          $rootScope.loading = false;
        });
    };

    //Passando item selecionado para envio dos dados
    $scope.param = function (item) {
      $rootScope.remessasEnviar = item;
    }

    var uploader = $scope.uploader = new FileUploader({
      url: layoutPaths.urlAPI.carregarArquivo,
      headers: {
        'Authorization': storageService.getToken()
      }
    });

    // FILTERS
    uploader.filters.push({
      name: 'customFilter',
      fn: function () {
        $scope.tamanho = this.queue.length;
        return this.queue.length < 50;
      }

    });

    $scope.uploaderAnexos = new FileUploader();

    $scope.fileStrings = [];
    $rootScope.fileStrings = [];

    $scope.removeAnexo = function (obj) {
      var remFile = $scope.fileStrings.findIndex(function (item) {
        return item.$$hashKey === obj.$$hashKey;
      });
      $scope.fileStrings.splice(remFile, 1);
      $rootScope.fileStrings.splice(remFile, 1);
    }

    $scope.uploaderAnexos.onAfterAddingFile = function (fileItem) {
      var data = (/[.]/.exec(fileItem.file.name)) ? /[^.]+$/.exec(fileItem.file.name) : undefined

      if (fileItem.file.size <= 5242880) {
        if ($scope.fileStrings.length >= 500) {
          toastr.error('Você atingiu o limite de 500 arquivos no envio.', {
            timeOut: 2400
          });
        } else {
          $scope.fileStrings.push({
            name: fileItem.file.name,
            size: fileItem.file.size,
            fileUpload: fileItem._file,
            fileType: data[0],
            fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
          });
          $rootScope.fileStrings.push({
            name: fileItem.file.name,
            size: fileItem.file.size,
            fileUpload: fileItem._file,
            fileType: data[0],
            fileName: fileItem.file.name.substring(0, (fileItem.file.name.length - data[0].length - 1)),
          });
        }
      } else {
        toastr.error('Arquivo muito grande, não é possível anexar!', {
          timeOut: 2400
        });
      }

    };
    $scope.email.observacao = '';
  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.pages')
        .filter('capitalize', capitalize);

    /** @ngInject */
    function capitalize() {
        return function (input) {
            input = input || ''
            if (input.indexOf(' ') !== -1) {
                var inputPieces,
                    i;

                input = input.toLowerCase();
                inputPieces = input.split(' ');

                for (i = 0; i < inputPieces.length; i++) {
                    inputPieces[i] = capitalizeString(inputPieces[i]);
                }

                return inputPieces.toString().replace(/,/g, ' ');
            }
            else {
                input = input.toLowerCase();
                return capitalizeString(input);
            }

            function capitalizeString(inputString) {
                return inputString.substring(0, 1).toUpperCase() + inputString.substring(1);
            }
        };
    };
})(); 
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .filter('moedaFilter', moedaFilter);

  /** @ngInject */
  function moedaFilter(formatarMoeda) {
    return function(input) {
      return formatarMoeda.moedaReal(input, 2, ',', '.');
    };
  }

})();  
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .filter('nomeTipoDocumento', nomeTipoDocumento);

    /** @ngInject */
    function nomeTipoDocumento() {
        return function (input) {
            var nomeDocumento;

            switch (input) {

                case input = 'CH':
                    nomeDocumento = 'CHEQUE';
                    break;

                case input = 'DP':
                    nomeDocumento = 'DUPLICATA';
                    break;     

                case input = 'DS':
                    nomeDocumento = 'DUPLICATA DE SERVIÇO';
                    break;      
                    
                case input = 'NP':
                    nomeDocumento = 'NOTA PROMISSÓRIA';
                    break;     
                    
                case input = 'NR':
                    nomeDocumento = 'NOTA PROMISSÓRIA RURAL';
                    break; 

                case input = 'O':
                    nomeDocumento = 'OUTROS';
                    break;      
                                   
            }
            return nomeDocumento;
        }
    }
})();  

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .filter('startFrom', startFrom);

  /** @ngInject */
  function startFrom() {
    return function(input, start) {
      if (input === undefined || input === null || input.length === 0) return [];
        start = +start; //parse to int
        return input.slice(start);
    };
  }

})();  

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive('botaoLink', botaoLink);

    /** @ngInject */
    function botaoLink() {
        return {
            restrict: 'A',
            scope: {
                enabled: '=botaoLink'
            },
            link: function (scope, element, attrs) {
                element.bind('click', function (event) {
                    if (!scope.enabled) {
                        event.preventDefault();
                    }
                });
            }
        };
    }
})();  
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive('focusMe', focusMe);

    /** @ngInject */
    function focusMe($timeout) {
        return {
            scope: { trigger: '@focusMe' },
            link: function (scope, element) {
                scope.$watch('trigger', function (value) {
                    if (value === "true") {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    }
})();  

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive('format', format);

    /** @ngInject */
    function format() {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) return;

                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue.length <= 3) {
                        viewValue = '00' + viewValue;
                    }
                    var value = viewValue;
                    value = value.replace(/\D/g, "");
                    value = value.replace(/(\d{2})$/, ",$1");
                    value = value.replace(/(\d+)(\d{3},\d{2})$/g, "$1.$2");
                    var qtdLoop = (value.length - 3) / 3;
                    var count = 0;
                    while (qtdLoop > count) {
                        count++;
                        value = value.replace(/(\d+)(\d{3}.*)/, "$1.$2");
                    }
                    var plainNumber = value.replace(/^(0)(\d)/g, "$2");

                    elem.val(plainNumber);
                    return plainNumber;
                });

                elem.bind('blur', function () {
                    var valueFilter = elem.val();
                    valueFilter = valueFilter.replace(/\D/g, "");
                    if (attrs.zeroFilter == 'true') {
                        if (valueFilter == 0) {
                            elem.val('');
                        }
                    }
                });
            }
        };
    }
})();  

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive("limitTo", [function () {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    var limit = parseInt(attrs.limitTo);
                    angular.element(elem).on("keypress", function (e) {
                        if (this.value.length == limit) e.preventDefault();
                    });
                }
            }
        }]);
})();  

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive('mdDatepickerCustom', datePickerDirective);

    /** @ngInject */
    function datePickerDirective() {
        return {
            template:
            '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
            'tabindex="-1" aria-hidden="true" ' +
            'ng-click="ctrl.openCalendarPane($event)">' +
            '<md-icon class="md-datepicker-calendar-icon" md-svg-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg=="></md-icon>' +
            '</md-button>' +
            '<div class="md-datepicker-input-container" ' +
            'ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
            '<input class="md-datepicker-input" aria-haspopup="true" ' +
            'ng-focus="ctrl.setFocused(true)" ng-blur="ctrl.setFocused(false)" ng-model="ctrl.defaultDate" mask="{{::ctrl.mask}}" mask-clean="{{::ctrl.cleanMask}}" mask-restrict="{{::ctrl.restrict}}">' +
            '<md-button type="button" md-no-ink ' +
            'class="md-datepicker-triangle-button md-icon-button" ' +
            'ng-click="ctrl.openCalendarPane($event)" ' +
            'aria-label="{{::ctrl.dateLocale.msgOpenCalendar}}">' +
            '<div class="md-datepicker-expand-triangle"></div>' +
            '</md-button>' +
            '</div>' +
            '<div class="md-datepicker-calendar-pane md-whiteframe-z1">' +
            '<div class="md-datepicker-input-mask">' +
            '<div class="md-datepicker-input-mask-opaque"></div>' +
            '</div>' +
            '<div class="md-datepicker-calendar">' +
            '<md-calendar role="dialog" aria-label="{{::ctrl.dateLocale.msgCalendar}}" ' +
            'md-min-date="ctrl.minDate" md-max-date="ctrl.maxDate"' +
            'md-date-filter="ctrl.dateFilter"' +
            'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
            '</md-calendar>' +
            '</div>' +
            '</div>' ,
            require: ['ngModel', 'mdDatepickerCustom', '?^mdInputContainer'],
            scope: {
                minDate: '=mdMinDate',
                maxDate: '=mdMaxDate',
                placeholder: '@mdPlaceholder',
                dateFilter: '=mdDateFilter',
                //  Custom attributes added
                defaultDate: '@mdCustomDefaultDate',
                mask: '@mdCustomMask',
                cleanMask: '@mdCustomCleanMask',
                restrict: '@mdCustomRestrict',
                required: '@mdCustomRequired'
            },
            controller: DatePickerCtrl,
            controllerAs: 'ctrl',
            bindToController: true,
            link: function (scope, element, attr, controllers) {
                var ngModelCtrl = controllers[0];
                var mdDatePickerCtrl = controllers[1];

                var mdInputContainer = controllers[2];
                if (mdInputContainer) {
                    throw Error('md-datepicker should not be placed inside md-input-container.');
                }

                mdDatePickerCtrl.configureNgModel(ngModelCtrl);
            }
        };
    }

    /** Additional offset for the input's `size` attribute, which is updated based on its content. */
    var EXTRA_INPUT_SIZE = 3;

    /** Class applied to the container if the date is invalid. */
    var INVALID_CLASS = 'md-datepicker-invalid';

    /** Default time in ms to debounce input event by. */
    var DEFAULT_DEBOUNCE_INTERVAL = 500;
    var CALENDAR_PANE_HEIGHT = 368;
    var CALENDAR_PANE_WIDTH = 360;

    function DatePickerCtrl($scope, $element, $attrs, $compile, $timeout, $window,
        $mdConstant, $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF) {
        /** @final */
        this.$compile = $compile;

        /** @final */
        this.$timeout = $timeout;

        /** @final */
        this.$window = $window;

        /** @final */
        this.dateLocale = $mdDateLocale;

        /** @final */
        this.dateUtil = $$mdDateUtil;

        /** @final */
        this.$mdConstant = $mdConstant;

        /* @final */
        this.$mdUtil = $mdUtil;

        /** @final */
        this.$$rAF = $$rAF;

        this.documentElement = angular.element(document.documentElement);

        /** @type {!angular.NgModelController} */
        this.ngModelCtrl = null;

        /** @type {HTMLInputElement} */
        this.inputElement = $element[0].querySelector('input');

        /** @final {!angular.JQLite} */
        this.ngInputElement = angular.element(this.inputElement);

        /** @type {HTMLElement} */
        this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

        /** @type {HTMLElement} Floating calendar pane. */
        this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

        /** @type {HTMLElement} Calendar icon button. */
        this.calendarButton = $element[0].querySelector('.md-datepicker-button');

        this.inputMask = $element[0].querySelector('.md-datepicker-input-mask-opaque');

        /** @final {!angular.JQLite} */
        this.$element = $element;

        /** @final {!angular.Attributes} */
        this.$attrs = $attrs;

        /** @final {!angular.Scope} */
        this.$scope = $scope;

        /** @type {Date} */
        this.date = null;

        /** @type {boolean} */
        this.isFocused = false;

        /** @type {boolean} */
        this.isDisabled;
        this.setDisabled($element[0].disabled || angular.isString($attrs['disabled']));

        /** @type {boolean} Whether the date-picker's calendar pane is open. */
        this.isCalendarOpen = false;

        this.calendarPaneOpenedFrom = null;

        this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();

        $mdTheming($element);

        /** Pre-bound click handler is saved so that the event listener can be removed. */
        this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

        /** Pre-bound resize handler so that the event listener can be removed. */
        this.windowResizeHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

        // Unless the user specifies so, the datepicker should not be a tab stop.
        // This is necessary because ngAria might add a tabindex to anything with an ng-model
        // (based on whether or not the user has turned that particular feature on/off).
        if (!$attrs['tabindex']) {
            $element.attr('tabindex', '-1');
        }

        this.installPropertyInterceptors();
        this.attachChangeListeners();
        this.attachInteractionListeners();

        var self = this;
        $scope.$on('$destroy', function () {
            self.detachCalendarPane();
        });
    }

    /**
     * Sets up the controller's reference to ngModelController.
     * @param {!angular.NgModelController} ngModelCtrl
     */
    DatePickerCtrl.prototype.configureNgModel = function (ngModelCtrl) {
        this.ngModelCtrl = ngModelCtrl;

        var self = this;
        ngModelCtrl.$render = function () {
            var value = self.ngModelCtrl.$viewValue;

            if (value && !(value instanceof Date)) {
                throw Error('The ng-model for md-datepicker must be a Date instance. ' +
                    'Currently the model is a: ' + (typeof value));
            }

            self.date = value;
            self.inputElement.value = self.dateLocale.formatDate(value);
            self.resizeInputElement();
            self.updateErrorState();
        };
    };

    /**
     * Attach event listeners for both the text input and the md-calendar.
     * Events are used instead of ng-model so that updates don't infinitely update the other
     * on a change. This should also be more performant than using a $watch.
     */
    DatePickerCtrl.prototype.attachChangeListeners = function () {
        var self = this;

        self.$scope.$on('md-calendar-change', function (event, date) {
            self.ngModelCtrl.$setViewValue(date);
            self.date = date;
            self.inputElement.value = self.dateLocale.formatDate(date);
            self.closeCalendarPane();
            self.resizeInputElement();
            self.updateErrorState();
        });

        self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
        // TODO(chenmike): Add ability for users to specify this interval.
        self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
            DEFAULT_DEBOUNCE_INTERVAL, self));
    };

    /** Attach event listeners for user interaction. */
    DatePickerCtrl.prototype.attachInteractionListeners = function () {
        var self = this;
        var $scope = this.$scope;
        var keyCodes = this.$mdConstant.KEY_CODE;

        // Add event listener through angular so that we can triggerHandler in unit tests.
        self.ngInputElement.on('keydown', function (event) {
            if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
                self.openCalendarPane(event);
                $scope.$digest();
            }
        });

        $scope.$on('md-calendar-close', function () {
            self.closeCalendarPane();
        });
    };

    /**
     * Capture properties set to the date-picker and imperitively handle internal changes.
     * This is done to avoid setting up additional $watches.
     */
    DatePickerCtrl.prototype.installPropertyInterceptors = function () {
        var self = this;

        if (this.$attrs['ngDisabled']) {
            // The expression is to be evaluated against the directive element's scope and not
            // the directive's isolate scope.
            var scope = this.$scope.$parent;

            if (scope) {
                scope.$watch(this.$attrs['ngDisabled'], function (isDisabled) {
                    self.setDisabled(isDisabled);
                });
            }
        }

        Object.defineProperty(this, 'placeholder', {
            get: function () { return self.inputElement.placeholder; },
            set: function (value) { self.inputElement.placeholder = value || ''; }
        });
    };

    /**
     * Sets whether the date-picker is disabled.
     * @param {boolean} isDisabled
     */
    DatePickerCtrl.prototype.setDisabled = function (isDisabled) {
        this.isDisabled = isDisabled;
        this.inputElement.disabled = isDisabled;
        this.calendarButton.disabled = isDisabled;
    };

    /**
     * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
     *   - mindate: whether the selected date is before the minimum date.
     *   - maxdate: whether the selected flag is after the maximum date.
     *   - filtered: whether the selected date is allowed by the custom filtering function.
     *   - valid: whether the entered text input is a valid date
     *
     * The 'required' flag is handled automatically by ngModel.
     *
     * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
     */
    DatePickerCtrl.prototype.updateErrorState = function (opt_date) {
        var date = opt_date || this.date;

        // Clear any existing errors to get rid of anything that's no longer relevant.
        this.clearErrorState();

        if (this.dateUtil.isValidDate(date)) {
            // Force all dates to midnight in order to ignore the time portion.
            date = this.dateUtil.createDateAtMidnight(date);

            if (this.dateUtil.isValidDate(this.minDate)) {
                var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
                this.ngModelCtrl.$setValidity('mindate', date >= minDate);
            }

            if (this.dateUtil.isValidDate(this.maxDate)) {
                var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
                this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
            }

            if (angular.isFunction(this.dateFilter)) {
                this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
            }
        } else {
            // The date is seen as "not a valid date" if there is *something* set
            // (i.e.., not null or undefined), but that something isn't a valid date.
            //  this.ngModelCtrl.$setValidity('valid', date == null);
            this.ngModelCtrl.$setValidity('valid', !isNaN(date));
            this.ngModelCtrl.$setValidity('required', this.required !== "true" || date !== null);
        }

        // TODO(jelbourn): Change this to classList.toggle when we stop using PhantomJS in unit tests
        // because it doesn't conform to the DOMTokenList spec.
        // See https://github.com/ariya/phantomjs/issues/12782.
        if (!this.ngModelCtrl.$valid) {
            this.inputContainer.classList.add(INVALID_CLASS);
        }
    };

    /** Clears any error flags set by `updateErrorState`. */
    DatePickerCtrl.prototype.clearErrorState = function () {
        this.inputContainer.classList.remove(INVALID_CLASS);
        ['mindate', 'maxdate', 'filtered', 'valid', 'required'].forEach(function (field) {
            this.ngModelCtrl.$setValidity(field, true);
        }, this);
    };

    /** Resizes the input element based on the size of its content. */
    DatePickerCtrl.prototype.resizeInputElement = function () {
        this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
    };

    /**
     * Sets the model value if the user input is a valid date.
     * Adds an invalid class to the input element if not.
     */
    DatePickerCtrl.prototype.handleInputEvent = function () {
        var inputString = this.inputElement.value;
        var parsedDate = inputString ? this.dateLocale.parseDate(inputString) : null;
        this.dateUtil.setDateTimeToMidnight(parsedDate);

        // An input string is valid if it is either empty (representing no date)
        // or if it parses to a valid date that the user is allowed to select.
        var isValidInput = inputString == '' || (
            this.dateUtil.isValidDate(parsedDate) &&
            this.dateLocale.isDateComplete(inputString) &&
            this.isDateEnabled(parsedDate)
        );

        // The datepicker's model is only updated when there is a valid input.
        if (isValidInput) {
            this.ngModelCtrl.$setViewValue(parsedDate);
            this.date = parsedDate;
        }

        this.updateErrorState(parsedDate);
    };

    /**
     * Check whether date is in range and enabled
     * @param {Date=} opt_date
     * @return {boolean} Whether the date is enabled.
     */
    DatePickerCtrl.prototype.isDateEnabled = function (opt_date) {
        return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
            (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
    };

    /** Position and attach the floating calendar to the document. */
    DatePickerCtrl.prototype.attachCalendarPane = function () {
        var calendarPane = this.calendarPane;
        calendarPane.style.transform = '';
        this.$element.addClass('md-datepicker-open');

        var elementRect = this.inputContainer.getBoundingClientRect();
        var bodyRect = document.body.getBoundingClientRect();

        // Check to see if the calendar pane would go off the screen. If so, adjust position
        // accordingly to keep it within the viewport.
        var paneTop = elementRect.top - bodyRect.top;
        var paneLeft = elementRect.left - bodyRect.left;

        // If ng-material has disabled body scrolling (for example, if a dialog is open),
        // then it's possible that the already-scrolled body has a negative top/left. In this case,
        // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
        // though, the top of the viewport should just be the body's scroll position.
        var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
            -bodyRect.top :
            document.body.scrollTop;

        var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
            -bodyRect.left :
            document.body.scrollLeft;

        var viewportBottom = viewportTop + this.$window.innerHeight;
        var viewportRight = viewportLeft + this.$window.innerWidth;

        // If the right edge of the pane would be off the screen and shifting it left by the
        // difference would not go past the left edge of the screen. If the calendar pane is too
        // big to fit on the screen at all, move it to the left of the screen and scale the entire
        // element down to fit.
        if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
            if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
                paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
            } else {
                paneLeft = viewportLeft;
                var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
                calendarPane.style.transform = 'scale(' + scale + ')';
            }

            calendarPane.classList.add('md-datepicker-pos-adjusted');
        }

        // If the bottom edge of the pane would be off the screen and shifting it up by the
        // difference would not go past the top edge of the screen.
        if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
            viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
            paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
            calendarPane.classList.add('md-datepicker-pos-adjusted');
        }

        calendarPane.style.left = paneLeft + 'px';
        calendarPane.style.top = paneTop + 'px';
        document.body.appendChild(calendarPane);

        // The top of the calendar pane is a transparent box that shows the text input underneath.
        // Since the pane is floating, though, the page underneath the pane *adjacent* to the input is
        // also shown unless we cover it up. The inputMask does this by filling up the remaining space
        // based on the width of the input.
        this.inputMask.style.left = elementRect.width + 'px';

        // Add CSS class after one frame to trigger open animation.
        this.$$rAF(function () {
            calendarPane.classList.add('md-pane-open');
        });
    };

    /** Detach the floating calendar pane from the document. */
    DatePickerCtrl.prototype.detachCalendarPane = function () {
        this.$element.removeClass('md-datepicker-open');
        this.calendarPane.classList.remove('md-pane-open');
        this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

        if (this.isCalendarOpen) {
            this.$mdUtil.enableScrolling();
        }

        if (this.calendarPane.parentNode) {
            // Use native DOM removal because we do not want any of the angular state of this element
            // to be disposed.
            this.calendarPane.parentNode.removeChild(this.calendarPane);
        }
    };

    /**
     * Open the floating calendar pane.
     * @param {Event} event
     */
    DatePickerCtrl.prototype.openCalendarPane = function (event) {
        if (!this.isCalendarOpen && !this.isDisabled) {
            this.isCalendarOpen = true;
            this.calendarPaneOpenedFrom = event.target;

            // Because the calendar pane is attached directly to the body, it is possible that the
            // rest of the component (input, etc) is in a different scrolling container, such as
            // an md-content. This means that, if the container is scrolled, the pane would remain
            // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
            // also matches the native behavior for things like `<select>` on Mac and Windows.
            this.$mdUtil.disableScrollAround(this.calendarPane);

            this.attachCalendarPane();
            this.focusCalendar();

            // Attach click listener inside of a timeout because, if this open call was triggered by a
            // click, we don't want it to be immediately propogated up to the body and handled.
            var self = this;
            this.$mdUtil.nextTick(function () {
                // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
                // events aren't propogated under most circumstances.
                // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                self.documentElement.on('click touchstart', self.bodyClickHandler);
            }, false);

            window.addEventListener('resize', this.windowResizeHandler);
        }
    };

    /** Close the floating calendar pane. */
    DatePickerCtrl.prototype.closeCalendarPane = function () {
        if (this.isCalendarOpen) {
            this.detachCalendarPane();
            this.isCalendarOpen = false;
            this.calendarPaneOpenedFrom.focus();
            this.calendarPaneOpenedFrom = null;

            this.ngModelCtrl.$setTouched();

            this.documentElement.off('click touchstart', this.bodyClickHandler);
            window.removeEventListener('resize', this.windowResizeHandler);
        }
    };

    /** Gets the controller instance for the calendar in the floating pane. */
    DatePickerCtrl.prototype.getCalendarCtrl = function () {
        return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
    };

    /** Focus the calendar in the floating pane. */
    DatePickerCtrl.prototype.focusCalendar = function () {
        // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
        var self = this;
        this.$mdUtil.nextTick(function () {
            self.getCalendarCtrl().focus();
        }, false);
    };

    /**
     * Sets whether the input is currently focused.
     * @param {boolean} isFocused
     */
    DatePickerCtrl.prototype.setFocused = function (isFocused) {
        if (!isFocused) {
            this.ngModelCtrl.$setTouched();
        }
        this.isFocused = isFocused;
    };

    /**
     * Handles a click on the document body when the floating calendar pane is open.
     * Closes the floating calendar pane if the click is not inside of it.
     * @param {MouseEvent} event
     */
    DatePickerCtrl.prototype.handleBodyClick = function (event) {
        if (this.isCalendarOpen) {
            // TODO(jelbourn): way want to also include the md-datepicker itself in this check.
            var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
            if (!isInCalendar) {
                this.closeCalendarPane();
            }

            this.$scope.$digest();
        }
    };




})();  
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('DifactWeb.theme')
        .directive('scrollOnClick', scrollOnClick);

    /** @ngInject */
    function scrollOnClick() {
        return {
            restrict: 'A',
            link: function (scope, $elm) {
                $elm.on('click', function () {
                    $("html, body").animate({ scrollTop: 0 }, { duration: 100 })
                });
            }
        }
    }

})();     

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('DifactWeb.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('DifactWeb.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, storageService, $stateParams) {
    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.papelUsuario = atob(storageService.getPapelUsuario());
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    $scope.empcod = $stateParams.empcod;
    $scope.empfaccod = $stateParams.empfaccod;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
        if (baSidebarService.canSidebarBeHidden()) {
          baSidebarService.setMenuCollapsed(true);
        }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function () {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function ($state, layoutSizes, $uibModal, storageService) {

      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function () {
          var states = defineMenuItemStates();                
          var menuItems = states.filter(function (item) {
            //função atob() - descriptografa
            //função btob() - criptografa            
            var decodedString = atob(storageService.getPapelUsuario());
            var permissao = atob(storageService.getPermissao()); 

            //Capturando informação de funcionalidades permitidas
            var perFunc = storageService.getPerFuncional(); 
            
            //organizando cada uma delas
            var perTitulo = perFunc.substr(0,1); 
            var perOperacao = perFunc.substr(1,1);
            var perExtrato = perFunc.substr(2,1);
            var perSegBoleto = perFunc.substr(3,1);
            var perProrrogacao = perFunc.substr(4,1);
            var perAnexoTitulo = perFunc.substr(5,1);
              
            //condição para adicionar funcionalidades permitidas pela factoring
            if(((item.name == 'empresa.novaremessa'|| item.name == 'empresa.remessas') && perTitulo == '1') 
            ||(item.name == 'empresa.operacao' && perOperacao == '1' )
            ||(item.name == 'empresa.relatorio' && perExtrato == '1' )
            ||(item.name == 'empresa.emitirBoleto' && perSegBoleto == '1' )
            ||(item.name == 'empresa.inicio') || (item.name == 'empresa.novaprorrogacao' && perProrrogacao == '1') || (item.name == 'empresa.prorrogacoes' && perProrrogacao == '1') ||
            (item.name == 'empresa.anexos' && perAnexoTitulo == '1') ||
             item.papel == 'factoring' || item.papel == 'administrador'){         
            if (permissao == 'true') {
              return item.level == 0 && item.papel == decodedString
            } else {
              return item.level == 0 && item.papel == decodedString && (item.stateRef != 'emitirBoleto')
            }
          }
            //return item.level == 0 && item.papel == decodedString;
          });

          menuItems.forEach(function (item) {
            var children = states.filter(function (child) {

              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });
          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function (isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function () {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function () {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function (item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function (s) {                      
              return s.sidebarMeta;
            })
            .map(function (s) {              
              var meta = s.sidebarMeta;              
              return {
                name: s.name,
                title: s.title,
                level: 0,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                papel: meta.papel
              };
            })
            .sort(function (a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService, $rootScope) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
            $rootScope.animacaoMenu = !$rootScope.animacaoMenu;
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');        
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');        
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
    .directive('backTop', backTop)

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
    .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: function pageTopController($window, $uibModal, $scope, $rootScope, $state, loginService, storageService, $stateParams) {

        $scope.open = function (page, size, opcao) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            scope: $scope
          })
        }

        $scope.empcodUrl = $stateParams.empcod
        $scope.empfaccodUrl = $stateParams.empfaccod
        $scope.empresas = storageService.getEmpresas();


        $scope.urlEmpresa = function (empcod, empfaccod) {
          var url;
          if (storageService.verificaExistencia(empcod, empfaccod)) {
            url = $state.href('empresa.inicio', { empcod: empcod, empfaccod: empfaccod })
          } else {
            url = $state.href('empresa.login', { empcod: empcod, empfaccod: empfaccod })

          }
          return url;
        }

        //função atob() - descriptografa
        //função btob() - criptografa
        var decodedString = atob(storageService.getPapelUsuario());
        $scope.papel = decodedString;

        $scope.sair = function () {
          $scope.open('app/theme/components/pageTop/efetuarLogof.html', 'vm');
          //loginService.logout();
        }

        $scope.finalizarSessao = function () {
          loginService.logout();
        }

        if ($scope.papel == 'cliente') {
          $scope.nomeHeader = storageService.getNomeFactoring();
          var pos = storageService.getNomeEmpresa().indexOf(' ');
          $scope.nomeHeaderSimplif = storageService.getNomeFactoring().substring(0, pos);
        } else {
          $scope.nomeHeader = storageService.getNomeEmpresa();
          var pos = storageService.getNomeEmpresa().indexOf(' ');
          $scope.nomeHeaderSimplif = storageService.getNomeEmpresa().substring(0, pos);
        }

      }

    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('DifactWeb.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module("DifactWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/login/login.html","<style>\r\n    * {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .container {\r\n        max-width: none !important;\r\n        width: 100%;\r\n        padding-left: 50px;\r\n    }\r\n\r\n    .login-footer {\r\n        bottom: 0;\r\n        position: absolute;\r\n        color: #fff;\r\n        width: 100%;\r\n        height: 35px;\r\n        line-height: 35px;\r\n    }\r\n\r\n    .login-footer,\r\n    .submenu-complementos-itens:hover,\r\n    .submenu-itens:hover,\r\n    .submenu-projetos-itens:hover {\r\n        background-color: #1C2B36;\r\n    }\r\n\r\n    body.mobile .body-bg {\r\n        background-color: inherit !important;\r\n    }\r\n\r\n    main {\r\n        background: url(./assets/img/login2.jpg) center center no-repeat;\r\n        background-blend-mode: soft-light;\r\n        background-size: cover;\r\n        height: 100%;\r\n    }\r\n\r\n    body {\r\n        font-family: Helvetica;\r\n        -webkit-font-smoothing: antialiased;\r\n        margin: 0;\r\n        overflow-x: auto;\r\n        overflow-y: hidden;\r\n        padding: 0 !important;\r\n        cursor: default;\r\n    }\r\n\r\n    .login-formulario {\r\n        position: absolute;\r\n        background-color: rgba(255, 255, 255, 255);\r\n        border-radius: 20px;\r\n        box-shadow: 0 0 10px #777;\r\n        margin-top: 175px;\r\n    }\r\n\r\n    @media screen and (max-width: 375px) {\r\n        .login-formulario {\r\n            margin-top: 70px;\r\n        }\r\n    }\r\n\r\n    .btn-color {\r\n        color: #fff;\r\n        background-color: #209e91;\r\n        border-color: #209e91;\r\n    }\r\n\r\n    .hr-login {\r\n        margin-top: 0;\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n\r\n\r\n    .button {\r\n        position: relative;\r\n        display: inline-block;\r\n        padding: 12px 24px;\r\n        width: 100%;\r\n        vertical-align: middle;\r\n        color: #fff;\r\n        font-size: 16px;\r\n        -webkit-font-smoothing: antialiased;\r\n        text-align: center;\r\n        letter-spacing: 1px;\r\n        background: transparent;\r\n        border: 0;\r\n        cursor: pointer;\r\n        transition: all 0.15s ease;\r\n    }\r\n\r\n    .button:focus {\r\n        outline: 0;\r\n    }\r\n\r\n    .buttonBlue {\r\n        background: #209e91;\r\n        text-shadow: 1px 1px 0 rgba(39, 110, 204, .5);\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .buttonBlue:hover {\r\n        background: #209e91;\r\n    }\r\n\r\n\r\n    .navbar-brand {\r\n        font-weight: 700;\r\n        margin-top: 6px;\r\n        margin-bottom: 6px;\r\n    }\r\n\r\n    .span_primario {\r\n        color: white;\r\n        font-size: 22px;\r\n        font-family: \'Roboto\', sans-serif;\r\n    }\r\n\r\n    .span_secundario {\r\n        color: #209e91;\r\n        font-size: 22px;\r\n        font-family: \'Roboto\', sans-serif;\r\n    }\r\n</style><nav class=\"navbar navbar-default navbar-fixed-top\" style=\"background-color: #1C2B36!important\"><div class=\"container\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"#\"><span class=\"span_primario\">Difact</span><span class=\"span_secundario\">Web</span></a></div></div></nav><main class=\"auth-main\"><div class=\"auth-block\"><div class=\"col-xs-10 col-xs-offset-1 col-sm-3 col-md-3 col-md-offset-8 login-formulario\"><form name=\"loginForm\" ng-submit=\"validarUsuario()\"><h4 style=\"color: #209e91; padding-top: 16px;\" class=\"ng-binding\"><span style=\"color: rgba(32, 158, 145, 0.7);\">Acesse o</span> <b>DifactWeb</b></h4><hr class=\"hr-login\"><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Usuário</label> <input required=\"\" type=\"usuario\" name=\"usuario\" autocomplete=\"off\" ng-maxlength=\"20\" ng-model=\"login.usuario\"><div ng-messages=\"loginForm.usuario.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'pattern\']\">Informe o nome de usuário.</div></div></md-input-container></div><div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Senha</label> <input required=\"\" type=\"password\" name=\"senha\" autocomplete=\"off\" ng-maxlength=\"64\" ng-model=\"login.senha\"><div ng-messages=\"loginForm.senha.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'pattern\']\">Informe a senha de usuário.</div></div></md-input-container></div><a ng-click=\"validarUsuario()\"><button type=\"submit\" class=\"button buttonBlue\">Entrar</button></a></form></div></div></main><footer class=\"login-footer ng-scope\"><center class=\"ng-binding\"><h6 style=\"margin-top: 8px;\">Decisão Sistemas Ltda. Goiânia - (62) 4013-9300. E-mail: contato@decisaosistemas.com.br</h6></center></footer>");
$templateCache.put("app/pages/painel_anexos/painel.anexos.html","<style>\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value.md-select-placeholder {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n    md-select:not([disabled]):focus .md-select-value {\r\n        border-bottom-color: #1B867B;\r\n        color: rgba(0, 0, 0, 0.87);\r\n    }\r\n\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n    md-select-menu md-content md-option:not([disabled]):focus,\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n    md-select-menu md-content md-option:not([disabled]):hover {\r\n        background: rgb(238, 238, 238);\r\n        color: #1B867B;\r\n    }\r\n\r\n    .switchdemoBasicUsage .inset {\r\n        padding-left: 25px;\r\n        padding-top: 25px;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-thumb,\r\n    md-switch.md-checked .md-thumb {\r\n        background-color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-ink-ripple,\r\n    md-switch.md-checked .md-ink-ripple {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-bar,\r\n    md-switch.md-checked .md-bar {\r\n        background-color: #8fc5c0;\r\n    }\r\n\r\n    md-input-container {\r\n        margin: 14px 0;\r\n    }\r\n\r\n    md-switch {\r\n        margin: 10px 0px;\r\n        height: 19px;\r\n    }\r\n\r\n    h3.with-line {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    h5.with-line {\r\n        padding-top: 0px;\r\n    }\r\n</style><script language=\"JavaScript\">\r\n    function somenteNumero(e) {\r\n        var tecla = (window.event) ? event.keyCode : e.which;\r\n        if ((tecla > 47 && tecla < 58)) return true;\r\n        else {\r\n            if (tecla == 8 || tecla == 0) return true;\r\n            else return false;\r\n        }\r\n    }\r\n</script><div class=\"widgets\" ng-init=\"buscarTitulos()\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><form name=\"novaRemessaForm\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><h3 class=\"with-line-same\">Títulos para Envio de Comprovantes</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulos\" st-safe-src=\"titulosOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th st-sort=\"numeroDoc\"><strong>Número</strong></th><td st-sort=\"nossoNumero\"><strong>Nosso Número</strong></td><th st-sort=\"nomeSacado\"><strong>Sacado</strong></th><th style=\"text-align: right;\" st-sort=\"docValor\"><strong>Valor</strong></th><th><strong>Anexar</strong></th></tr><tr><th><input st-search=\"vencimento\" placeholder=\"Vencimento\" class=\"input-sm form-control search-input\" type=\"search\" mask=\"99/99/9999\" ng-model=\"Vencimento\"></th><th><input st-search=\"numeroDoc\" placeholder=\"Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nossoNumero\" placeholder=\"Nosso Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nomeSacado\" placeholder=\"Sacado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"docValor\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in titulos|filter:search |startFrom:(pagination.currentPage - 1) * pagination.pageSize|limitTo: pagination.pageSize\"><td style=\"width: 10%;\">{{item.vencimento}}</td><td style=\"width: 15%;\">{{item.numeroDoc}}</td><td style=\"width: 15%;\">{{item.nossoNumero}}</td><td style=\"width: 40%;\" title=\"{{item.nomeSacado}}\">{{item.nomeSacado | limitTo: 45 }} {{item.nomeSacado.length > 45 ? \'...\' : \'\'}}</td><td align=\"right\" style=\"padding-right: 22px; width: 10%;\" \"=\"\">{{item.docValor}}</td><td style=\"width: 10%;\"><div class=\"col-sm-1\" style=\"width: 3.333333% !important;\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" nv-file-select=\"\" uploader=\"uploaderAnexos\" multiple=\"\"> <a align=\"left\" style=\"font-size: 24px;\" for=\"fileInput\"><i style=\"cursor: pointer; color: #209e91\" title=\"Comprovantes\" class=\"ion-android-attach\" ng-click=\"addAnexo(item)\"></i></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulos.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" items-per-page=\"pagination.pageSize\" num-pages=\"qtdPages\" ng-model=\"pagination.currentPage\" max-size=\"pagination.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"true\"></ul></div></td></tr></tfoot></div></table></div></div></form></div></div></div>");
$templateCache.put("app/pages/painel_anexos/painel.anexos.modal.html","<div class=\"modal-content\"><div class=\"modal-header cabecalho-instrucao\"><i></i><span>Anexos e Instruções a serem enviadas para a factoring</span></div><div class=\"modal-body\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea ng-model=\"observacao\" class=\"form-control tamanho-instrucaoArea\" placeholder=\"Digite aqui observações para o corpo do email...\"></textarea></div></div></div><div class=\"row tamanho-instrucaoArea\"><div class=\"col-md-10\"><md-chips style=\"outline: none !important;\" ng-model=\"fileStrings\" name=\"Anexos\" readonly=\"true\" md-max-chips=\"4\" placeholder=\"Anexos\"><md-chip-template><span>{{$chip.name | limitTo: 10 }} {{$chip.name.length > 10 ? \'...\' : \'\'}}</span><md-icon style=\"width: 10px !important; min-width: 10px !important;\" ng-click=\"removeAnexo($chip)\" md-font-icon=\"ion-android-close\" class=\"s16\"></md-icon></md-chip-template></md-chips></div><div class=\"col-md-2\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" nv-file-select=\"\" uploader=\"uploaderAnexos\" multiple=\"\"><div><label align=\"right\" style=\"font-size: 24px; padding-left: 40px;\" for=\"fileInput\"><i style=\"cursor: pointer; color: #209e91\" title=\"Adicionar\" class=\"ion-android-attach\"></i></label></div></div></div></div></div><div class=\"modal-footer\"><a><button ng-click=\"$close()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Enviar</button></a> <button ng-click=\"$dismiss()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-ios-close-outline\"></i>Cancelar</button></div></div>");
$templateCache.put("app/pages/painel_boleto/painel.boletoTitulos.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll\"><h3 class=\"with-line-same\">2ª Via do Boleto</h3><div class=\"row\"><div class=\"col-xs-12 col-md-12\">Mostrar<select name=\"registro\" ng-model=\"pageSize\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select>registros por página</div></div><div class=\"table-responsive\" ng-init=\"buscarTitulosBoletos()\"><table class=\"table\" st-table=\"boletoTitulos\" st-safe-src=\"boletoTitulosOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"titVenc\"><strong>Vencimento</strong></th><th st-sort=\"titNumDoc\"><strong>Número</strong></th><td st-sort=\"titNsoNum\"><strong>Nosso Número</strong></td><th st-sort=\"titSacado\"><strong>Sacado</strong></th><th style=\"text-align: right;\" st-sort=\"titVlr\"><strong>Valor</strong></th><th><strong>Solicitar</strong></th></tr><tr><th><input st-search=\"titVenc\" placeholder=\"Vencimento\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titNumDoc\" placeholder=\"Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titNsoNum\" placeholder=\"Nosso Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titSacado\" placeholder=\"Sacado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titVlr\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in boletoTitulos|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{item.titVenc}}</td><td>{{item.titNumDoc}}</td><td>{{item.titNsoNum}}</td><td>{{item.titSacado}}</td><td align=\"right\" style=\"padding-right: 22px;\">{{item.titVlr | moedaFilter}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-info btn-xs\" ng-disabled=\"{{!item.titNsoNum}}\" title=\"Solicitar 2ª via do boleto\" ng-style=\"{{!item.titNsoNum}} && ({\'background\': \'#6a706f\'}) || {\'background\': \'#209e91\'}\" ng-click=\"emitirBoleto(item)\">2ª via Boleto</button> <a id=\"dwnldLnk\" download=\"2ª via boleto.pdf\" style=\"display:none;\"></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"boletoTitulos.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" items-per-page=\"pageSize\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></div></table></div><br><span ng-if=\"mensagemVazio\">{{mensagemVazio}}</span></div>");
$templateCache.put("app/pages/painel_decisao/painel.administrador.grid.html","<style>\r\n  a {\r\n    cursor: pointer;\r\n  }\r\n</style><div ng-init=\"buscaFactoringCadastradas()\" class=\"horizontal-scroll\"><h3 class=\"with-line-same\">Empresas</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"factorings\" st-safe-src=\"factoringOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"codigo\">Código</th><th st-sort=\"nome\" style=\"width: 35%;\">Nome</th><th st-sort=\"situacao\">Situação</th><th st-sort=\"dataCriacao\">Data de criação</th><th st-sort=\"dataAtualizacao\">Data de atualização</th><th st-sort=\"action\">Ação</th></tr><tr><th style=\"width: 9%;\"><input st-search=\"codigo\" placeholder=\"Código\" class=\"input-sm form-control search-input\" type=\"search\"></th><th style=\"width: 35%;\"><input st-search=\"nome\" placeholder=\"Nome\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><select class=\"input-sm form-control search-input\" st-search=\"situacao\" name=\"select\"><option type=\"search\" value=\"\" selected=\"\">Todos</option><option type=\"search\" value=\"B\">Bloqueado</option><option type=\"search\" value=\"C\">Cancelado</option><option type=\"search\" value=\"L\">Liberado</option></select></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in factorings |filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{::item.codigo}}</td><td>{{::item.nome}}</td><td>{{item.situacao | ajustaSituacao}}</td><td>{{::item.dataCriacao | date:\'dd/MM/yyyy\'}}</td><td>{{::item.dataAtualizacao}}</td><td style=\"width: 10%;\"><div class=\"buttons\" ng-show=\"!rowform.$visible\" style=\"display:inline-block;\"><a ng-click=\"editarFactoring(item)\" scroll-on-click=\"\"><i class=\"ion-android-create\" title=\"Editar cadastro\" style=\"font-size: 26px;padding-right:10px;\"></i></a> <a ng-click=\"excluirBaseClientesFactoring(item);\" scroll-on-click=\"\"><i class=\"glyphicon glyphicon-wrench\" title=\"Limpar base do cliente\" style=\"font-size: 20px;padding-right:10px;\"></i></a></div></td></tr><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"factorings.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></tbody></table></div></div>");
$templateCache.put("app/pages/painel_decisao/painel.administrador.html","<script language=\"JavaScript\">\r\n	function somenteNumero(e) {\r\n		var tecla = (window.event) ? event.keyCode : e.which;\r\n		if ((tecla > 47 && tecla < 58)) return true;\r\n		else {\r\n			if (tecla == 8 || tecla == 0) return true;\r\n			else return false;\r\n		}\r\n	}\r\n</script><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"factoringForm\"><div ba-panel=\"\" ba-panel-button=\"adicionar\" ba-panel-class=\"with-scroll\"><a type=\"button\" data-toggle=\"modal\" title=\"{{tituloIcone}}\" ng-click=\"alteraIcone()\" style=\"cursor:pointer;\"><i ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a><div ng-init=\"parametrosIniciais()\" ng-show=\"ocultar\" layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><h3 class=\"with-line-same\">Empresa</h3><div class=\"row\"><div class=\"col-sm-4\"><input type=\"nome\" name=\"nome\" ng-model=\"factoring.nome\" autocomplete=\"off\" style=\"display:none\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nome</label> <input required=\"\" type=\"nome\" limit-to=\"50\" name=\"nome\" ng-model=\"factoring.nome\" autocomplete=\"off\" md-maxlength=\"50\" rows=\"5\" ng-blur=\"mudarSituacao()\"><div ng-messages=\"factoringForm.nome.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"factoringForm.nome.$touched\">O nome deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Situação</label><md-select aria-label=\"factoring.situacao\" ng-model=\"factoring.situacao\"><md-optgroup label=\"Situação\"><md-option ng-repeat=\"situacao in situacoes\" value=\"{{situacao.id}}\">{{situacao.nome}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Senha</label> <input required=\"\" type=\"password\" name=\"senha\" ng-model=\"factoring.senha\"><div ng-messages=\"factoringForm.senha.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"factoringForm.senha.$touched\">A senha deve ser informada.</div></div></md-input-container></div><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Agrupador</label> <input onkeypress=\"return somenteNumero(event)\" restrict=\"reject\" maxlength=\"3\" name=\"identificador\" ng-model=\"factoring.identificador\" autocomplete=\"off\"></md-input-container></div><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nuvem</label> <input onkeypress=\"return somenteNumero(event)\" restrict=\"reject\" maxlength=\"3\" name=\"baseNuvem\" ng-model=\"factoring.baseNuvem\" autocomplete=\"off\"></md-input-container></div></div><div align=\"right\"><button ng-click=\"salvarDadosFactoring()\" title=\"Salvar Dados\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i> Salvar</button></div></div></div></form><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/painel_decisao/painel.administrador.grid.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/painel_decisao/painel.administrador.log.grid.html","<style>\r\n  a {\r\n    cursor: pointer;\r\n  }\r\n</style><div ng-if=\"!ocultar\" class=\"horizontal-scroll\"><h3 class=\"with-line-same\">Empresas</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"logs\" st-safe-src=\"logOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"LogEmpCgcCic\" style=\"width: 15%;\">CNPJ/CPF</th><th st-sort=\"LogEmpNom\" style=\"width: 35%;\">Nome</th><th st-sort=\"LogQtdAce\" style=\"width: 15%;\">Acessos</th><th st-sort=\"LogQtdLog\" style=\"width: 15%;\">Logados</th><th st-sort=\"LogDif\" style=\"width: 15%;\">Diferença</th><th>Detalhes</th></tr><tr><th style=\"width: 15%;\"><input st-search=\"LogEmpCgcCic\" placeholder=\"Código\" class=\"input-sm form-control search-input\" type=\"search\"></th><th style=\"width: 35%;\"><input st-search=\"LogEmpNom\" placeholder=\"Nome\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in logs |filter:search\"><td>{{::item.LogEmpCgcCic}}</td><td>{{::item.LogEmpNom}}</td><td>{{item.LogQtdAce}}</td><td>{{::item.LogQtdLog}}</td><td ng-if=\"diferenca(item.LogDif) == \'R\'\" style=\"color:#e02f2f\">{{item.LogDif}}</td><td ng-if=\"diferenca(item.LogDif) == \'G\'\" style=\"color:#209e91\">{{item.LogDif}}</td><td style=\"width: 10%;\"><div class=\"buttons\" ng-show=\"!rowform.$visible\" style=\"display:inline-block;\"><a ng-click=\"detalharCli(item)\" scroll-on-click=\"\"><i class=\"icon ion-android-list\" title=\"Detalhar Cliente\" style=\"font-size: 26px;padding-right:10px;\"></i></a></div></td></tr><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div></div></td></tr></tfoot></tbody></table></div></div><div ng-if=\"ocultar\" class=\"horizontal-scroll\"><a type=\"button\" data-toggle=\"modal\" ng-click=\"detalharCli(item)\" style=\"cursor:pointer;\"><i ng-class=\"{\'ion-android-cancel\': ocultar}\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'}\"></i></a><div><br><h3 class=\"with-line-same\" style=\"color:#209e91\">{{empNom}}</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"detalhes\" st-safe-src=\"detalhesOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"LogCliCod\" style=\"width: 15%;\">CNPJ/CPF</th><th st-sort=\"LogCliNom\" style=\"width: 35%;\">Nome</th><th st-sort=\"LogQtdMen\" style=\"width: 10%;\">Logs Mensais</th></tr><tr><th style=\"width: 15%;\"><input st-search=\"LogCliCod\" placeholder=\"Código\" class=\"input-sm form-control search-input\" type=\"search\"></th><th style=\"width: 35%;\"><input st-search=\"LogCliNom\" placeholder=\"Nome\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in detalhes |filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{::item.LogCliCod}}</td><td>{{::item.LogCliNom}}</td><td style=\"color:#209e91;\">{{::item.LogQtdMen}}</td><td style=\"width: 100%;\"></td></tr><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"detalhes.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></tbody></table></div></div></div>");
$templateCache.put("app/pages/painel_decisao/painel.administrador.log.html","<script language=\"JavaScript\">\r\n	function somenteNumero(e) {\r\n		var tecla = (window.event) ? event.keyCode : e.which;\r\n		if ((tecla > 47 && tecla < 58)) return true;\r\n		else {\r\n			if (tecla == 8 || tecla == 0) return true;\r\n			else return false;\r\n		}\r\n	}\r\n</script><div ba-panel=\"\" ba-panel-class=\"with-scroll\" ng-init=\"parametrosIniciaisLog()\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"label-cor\">Mês de Referência</label><md-select aria-label=\"log.mesReferencia\" ng-model=\"log.mesReferencia\" placeholder=\"Selecione o mês de referência...\" ng-change=\"montarData(log.mesReferencia, log.anoReferencia)\"><md-option ng-repeat=\"meses in log.mes\" ng-value=\"{{meses.id}}\">{{ meses.nome }}</md-option></md-select></div><div class=\"col-sm-2\"><label class=\"label-cor\">Ano de Referência</label><md-select aria-label=\"log.anoReferencia\" ng-model=\"log.anoReferencia\" placeholder=\"Selecione o ano de referência...\" ng-change=\"montarData(log.mesReferencia, log.anoReferencia)\"><md-option ng-repeat=\"ano in log.ano\" ng-value=\"{{ano}}\">{{ ano }}</md-option></md-select></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/painel_decisao/painel.administrador.log.grid.html\"></div></div>");
$templateCache.put("app/pages/painel_decisao/painel.administrador.validarExclusaoBase.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-delete modal-icon\"></i><span>Limpeza de base do cliente.</span></div><div class=\"modal-body text-center\">Existe dados vinculados a Empresa. Deseja continuar?</div><div class=\"modal-footer\" ng-controller=\"painelAdministradorController\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"excluirBase(true); $dismiss()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"excluirBase(false); $dismiss()\">Não</button></div></div>");
$templateCache.put("app/pages/painel_factoring/painel.factoring.arquivo.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"factoringForm\"><uib-accordion><legend class=\"legend-topo\">Carregar Arquivo do Difact</legend><div class=\"modal-body\" ng-controller=\"painelFactoringController\" nv-file-drop=\"\" uploader=\"uploader\" filters=\"queueLimit, customFilter\"><div class=\"col-md-3\"><div ng-show=\"uploader.isHTML5\"><div class=\"well my-drop-zone\" nv-file-over=\"\" uploader=\"uploader\"><p class=\"p-margem-topo\" align=\"center\">Arraste arquivo para esta área</p></div></div><input type=\"file\" name=\"file\" id=\"file\" class=\"inputfile\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\"> <label for=\"file\" class=\"labeltext\">Selecionar Arquivo</label></div><div class=\"col-md-9\"><table class=\"table\"><thead><tr><th width=\"70%\">Nome</th><th ng-show=\"uploader.isHTML5\">Tamanho</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024|number:2 }} KB</td><td><div ng-if=\"item.isSucess == false\"><i class=\"ion-close item-erro-cor\" title=\"Erro\"></i></div><div ng-if=\"item.isSucess == true\"><i class=\"ion-checkmark item-sucesso-cor\" title=\"Sucesso\"></i></div></td><td class=\"text-center\"><span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span></td><td nowrap=\"\"><div ng-if=\"desabilitarItem == false\"><a title=\"Excluir Arquivo\" ng-click=\"item.remove(); remover();\"><i class=\"ion-android-delete tamanho-botao-progresso\"></i></a></div><div ng-if=\"desabilitarItem == true\"><a title=\"Excluir Arquivo\" ng-click=\"item.remove(); remover();\"><i class=\"ion-android-delete tamanho-botao-progresso\"></i></a></div></td></tr></tbody></table><div><br><div>Progresso:<div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': uploader.progress + \'%\' }\"></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\" title=\"Carregar todos os arquivos selecionados\"><i class=\"ion-android-upload\"></i>Carregar</button> <button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"uploader.clearQueue(); remover();\" ng-disabled=\"!uploader.queue.length\" title=\"Remover todos os arquivos selecionados\"><i class=\"ion-android-delete\"></i>Remover</button></div></div></div></uib-accordion></form></div></div></div>");
$templateCache.put("app/pages/painel_factoring/painel.factoring.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"factoringForm\"><br><fieldset class=\"form-group\" flex-gt-xs=\"\"><div layout-gt-xs=\"row\"><div class=\"col-md-6\"><legend>Tipo de Impressão dos Documentos</legend><md-radio-group ng-model=\"factoring.modeloImpressao\" ng-change=\"pegarValor(factoring.modeloImpressao)\"><md-radio-button ng-repeat=\"item in tipoImpressao\" ng-value=\"item.value\" aria-label=\"{{item.title}}\">{{item.nome}}</md-radio-button></md-radio-group></div><div class=\"col-md-6\"><legend>Opção</legend><md-checkbox ng-model=\"factoring.cepInvalido\" aria-label=\"factoring.cepInvalido\">Permitir importar CEP inválido?</md-checkbox><br><md-checkbox ng-model=\"factoring.cmc7Obrigatorio\" aria-label=\"factoring.cmc7Obrigatorio\">CMC7 obrigátorio no envio de títulos?</md-checkbox><br><md-checkbox ng-model=\"factoring.chaNfeObrigatorio\" aria-label=\"factoring.chaNfeObrigatorio\">Chave da NF-e obrigátorio no envio de títulos?</md-checkbox></div></div></fieldset><fieldset class=\"form-group\" flex-gt-xs=\"\"><legend>Configuração de Visualização dos Documentos</legend><md-tabs class=\"md-accent tabs-fundo\"><md-tab id=\"tab1\"><md-tab-label>Termo Aditivo</md-tab-label><md-tab-body><div><div class=\"row format-checkbox-tabs\"><div class=\"col-md-6\"><md-checkbox ng-model=\"factoring.termoAditivo\" aria-label=\"factoring.termoAditivo\">Permitir cliente emitir o termo aditivo através do Difactweb?</md-checkbox><br><div ng-hide=\"esconderTermo\"><md-checkbox ng-model=\"factoring.termoImprimirDocPagos\" aria-label=\"factoring.termoImprimirDocPagos\">Imprimir documentos que pagaram a operação?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoLinhaAssinatura\" aria-label=\"factoring.termoLinhaAssinatura\">Imprimir linha de assinatura para testemunhas?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoNomeTestemunhas\" aria-label=\"factoring.termoNomeTestemunhas\">Imprimir nome das testemunhas?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoPrazoMedio\" aria-label=\"factoring.termoPrazoMedio\">Imprimir prazo médio?</md-checkbox><br></div></div><div class=\"col-md-6\"><div ng-hide=\"esconderTermo\"><md-checkbox ng-model=\"factoring.termoValorRetencao\" aria-label=\"factoring.termoValorRetencao\">Imprimir valores de retenções?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoLiquidoLiberado\" aria-label=\"factoring.termoLiquidoLiberado\">Imprimir líquido liberado por extenso?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoDemonstrativo\" aria-label=\"factoring.termoDemonstrativo\">Imprimir demonstrativo de recompras/amortizações?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoResumido\" aria-label=\"factoring.termoResumido\">Imprimir termo aditivo resumido?</md-checkbox><br><md-checkbox ng-model=\"factoring.termoRespSolidario\" aria-label=\"factoring.termoRespSolidario\">Imprimir responsável solidário?</md-checkbox></div></div></div></div></md-tab-body></md-tab><md-tab id=\"tab2\" ng-disabled=\"bloqueiaBordero\"><md-tab-label>Borderô do Aditivo</md-tab-label><md-tab-body><div><div class=\"row format-checkbox-tabs\"><div class=\"col-md-6\"><md-checkbox ng-model=\"factoring.borderoAditivo\" aria-label=\"factoring.borderoAditivo\">Permitir cliente emitir borderô do aditivo através do Difactweb?</md-checkbox><br><div ng-hide=\"esconderBordero\"><md-checkbox ng-model=\"factoring.borderoResumoOperacao\" aria-label=\"factoring.borderoResumoOperacao\">Imprimir resumo da operação?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoLiquidoDocumento\" aria-label=\"factoring.borderoLiquidoDocumento\">Imprimir líquido do documento no borderô?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoDiferencialOpe\" aria-label=\"factoring.borderoDiferencialOpe\">Ratear o diferencial da operação no líquido dos documentos?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoFatorNominal\" aria-label=\"factoring.borderoFatorNominal\">Imprimir Fator Nominal?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoPrazoMedio\" aria-label=\"factoring.borderoPrazoMedio\">Imprimir prazo médio?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoLiquidoOperacao\" aria-label=\"factoring.borderoLiquidoOperacao\">Imprimir líquido da operação?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoLiquidoLiberado\" aria-label=\"factoring.borderoLiquidoLiberado\">Imprimir líquido liberado?</md-checkbox><br></div></div><div class=\"col-md-6\"><div ng-hide=\"esconderBordero\"><md-checkbox ng-model=\"factoring.borderoAssContratante\" aria-label=\"factoring.borderoAssContratante\">Imprimir linha de assinatura para a contratante?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoAssContratada\" aria-label=\"factoring.borderoAssContratada\">Imprimir linha de assinatura para a contratada?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoAssTestemunhas\" aria-label=\"factoring.borderoAssTestemunhas\">Imprimir linha de assinatura para testemunhas?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoNomeTestemunhas\" aria-label=\"factoring.borderoNomeTestemunhas\">Imprimir nome das testemunhas?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoTextoDeclaracao\" aria-label=\"factoring.borderoTextoDeclaracao\">Imprimir texto de declaração?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoPendencias\" aria-label=\"factoring.borderoPendencias\">Imprimir borderô de pendências?</md-checkbox><br><md-checkbox ng-model=\"factoring.borderoDemonstrativo\" aria-label=\"factoring.borderoDemonstrativo\">Imprimir demonstrativo de recompras/amortizações?</md-checkbox></div></div></div></div></md-tab-body></md-tab><md-tab id=\"tab3\"><md-tab-label>Recibo de Quitação</md-tab-label><md-tab-body><div class=\"format-checkbox-tabs\"><md-checkbox ng-model=\"factoring.recibo\" aria-label=\"factoring.recibo\">Permitir cliente emitir recibo de quitação através do Difactweb?</md-checkbox><br><div ng-hide=\"esconderRecibo\"><md-checkbox ng-model=\"factoring.reciboAssTestemunhas\" aria-label=\"factoring.reciboAssTestemunhas\">Imprimir linha de assinatura para testemunhas?</md-checkbox></div></div></md-tab-body></md-tab><md-tab id=\"tab4\" ng-disabled=\"bloqueiaDuplicata\"><md-tab-label>Duplicata</md-tab-label><md-tab-body><div class=\"format-checkbox-tabs\"><md-checkbox ng-model=\"factoring.duplicata\" aria-label=\"factoring.duplicata\">Permitir cliente emitir duplicata através do Difactweb?</md-checkbox></div></md-tab-body></md-tab><md-tab id=\"tab5\"><md-tab-label>Carta ao Sacado</md-tab-label><md-tab-body><div class=\"format-checkbox-tabs\"><md-checkbox ng-model=\"factoring.cartaSacado\" aria-label=\"factoring.cartasacado\">Permitir cliente emitir carta ao sacado através do Difactweb?</md-checkbox></div></md-tab-body></md-tab></md-tabs></fieldset><div align=\"right\"><button type=\"button\" title=\"Salvar Configuração\" ng-click=\"salvarConfiguracoes()\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i> Salvar Configurações</button></div></form></div></div></div>");
$templateCache.put("app/pages/painel_inicio/painel.inicio.grafico.html","<div class=\"channels-block\"><div class=\"chart-bg\"></div><div class=\"traffic-chart traffic-alturaMinima\" id=\"trafficChart\"><div align=\"center\"><canvas id=\"chart-area\" width=\"210\" height=\"210\" class=\"tamanho-canvas\"></canvas><div class=\"traffic-text traffic-total\">Total <span>{{totalAberto | moedaFilter}}</span></div></div></div><div class=\"channels-info\"><div><div class=\"channels-info-item\" ng-repeat=\"item in doughnutData | orderBy:\'order\'\"><div ng-if=\"item.label == \'Vencidos\'\"><div class=\"legend-color\" ng-style=\"{\'background-color\': \'{{color.white}}\'}\"></div></div><div ng-if=\"item.label == \'A Vencer\'\"><div class=\"legend-color\" ng-style=\"{\'background-color\': \'{{color.blueStone}}\'}\"></div></div><p>{{::item.label}}<span class=\"channel-number\">+{{item.percentual}}%</span></p><div class=\"progress progress-sm channel-progress\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{item.percentual}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': \'{{item.percentual}}%\'}\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/painel_inicio/painel.inicio.html","<style>\r\n  .p-dadosLimites-neg{\r\n    margin-bottom: 4px;\r\n    color: #ff0000;\r\n    font-weight:bold\r\n  }\r\n  .p-dadosLimites-pos{\r\n    margin-bottom: 4px;\r\n    color: #209e91;\r\n    font-weight:bold\r\n  }\r\n  .progress-bar{\r\n    background-color: #209E91;\r\n  }\r\n  .chart-area{\r\n    color: #209e91;\r\n  }\r\n</style><div class=\"row\" ng-init=\"buscaOperacoesUltimosAnos()\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><br><div class=\"col-md-6 preenchimento-panelNome\"><p class=\"p-tamanho-nome\">{{nomeFactoring | capitalize}}</p></div><div class=\"col-md-6 preenchimento-panelNome\"><p hide-xs=\"\" class=\"p-xs-dadosAtualizados\">Dados atualizados em: {{dataUltAtu}} - {{horaUltAtu}}</p><p hide-gt-xs=\"\" class=\"p-gt-dadosAtualizados\">Dados atualizados em: {{dataUltAtu}} - {{horaUltAtu}}</p></div></div></div></div><div class=\"row\"><div ng-if=\"liquidez == \'1\'\" class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\" ba-panel-title=\"Liquidez\"><div class=\"progress\" style=\"margin-bottom: 0px\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': valorLiquidez + \'%\' }\">{{valorLiquidez}}%</div></div></div></div><div><div ng-if=\"limite == \'1\'\" class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Limite disponivel para operar\"><p class=\"p-dadosLimites-neg\" ng-if=\"limNegativo == true\">R$ -{{limiteDisponivel}}</p><p class=\"p-dadosLimites-pos\" ng-if=\"limNegativo == false\">R$ {{limiteDisponivel}}</p></div></div></div><div class=\"row\"><div ng-if=\"titAberto == \'1\'\" class=\"col-xs-12 col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Títulos em Aberto\" ba-panel-class=\"col-eq-height\"><traffic-chart></traffic-chart></div></div><div ng-if=\"titMeses == \'1\'\" class=\"col-xs-12 col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Títulos a vencer nos próximos 12 meses\" ba-panel-class=\"col-eq-height\"><canvas id=\"waveBars\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\"></canvas></div></div></div>");
$templateCache.put("app/pages/painel_inicio/painel.titulosOperacao.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll\"><h3 class=\"with-line-same\">{{tituloCarteira}}</h3><div class=\"row\"><div class=\"col-xs-12 col-md-12\">Mostrar<select name=\"registro\" ng-model=\"pageSize\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select>registros por página</div></div><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulosOperacao\" st-safe-src=\"titulosOperacaoOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"titVenc\"><strong>Vencimento</strong></th><th st-sort=\"titNumDoc\"><strong>Número</strong></th><td st-sort=\"titTipDoc\"><strong>Tipo</strong></td><td st-sort=\"titNsoNum\"><strong>Nosso Número</strong></td><th st-sort=\"titSacado\"><strong>Sacado</strong></th><th style=\"text-align: right;\" st-sort=\"titVlr\"><strong>Valor</strong></th></tr><tr><th><input st-search=\"titVenc\" placeholder=\"Vencimento\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titNumDoc\" placeholder=\"Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titTipDoc\" placeholder=\"Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titNsoNum\" placeholder=\"Nosso Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titSacado\" placeholder=\"Sacado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"titVlr\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in titulosOperacao|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{item.titVenc}}</td><td>{{item.titNumDoc}}</td><td>{{item.titTipDoc}}</td><td>{{item.titNsoNum}}</td><td>{{item.titSacado}}</td><td align=\"right\" style=\"padding-right: 22px;\">{{item.titVlr | moedaFilter}}</td><td></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulosOperacao.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" items-per-page=\"pageSize\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/painel_comoUsar/painel.usandoSistema.html","<div><div class=\"widgets\" ng-controller=\"painelUsandoSistemaController\"><div class=\"row\"><br><br><div class=\"col-md-12\" style=\"text-align: center;\"><youtube-video video-id=\"theBestVideo\" player-width=\"\'90%\'\" player-height=\"\'500px\'\"></youtube-video></div></div></div></div>");
$templateCache.put("app/pages/painel_relatorio/painel.relatorio.form.html","<style>\r\n	.demo-header-searchbox {\r\n		border: none;\r\n		outline: none;\r\n		height: 100%;\r\n		width: 100%;\r\n		padding: 0;\r\n		font-size: 18px;\r\n\r\n	}\r\n\r\n	.demo-select-header {\r\n		box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12);\r\n		padding-left: 10.667px;\r\n		height: 48px;\r\n		cursor: pointer;\r\n		position: relative;\r\n		display: flex;\r\n		align-items: center;\r\n		width: auto;\r\n	}\r\n\r\n	.fixed {\r\n		display: grid;\r\n	}\r\n</style><div class=\"panel-content\" ng-init=\"parametrosIniciais()\"><form name=\"relatorioForm\"><div class=\"row\"><div class=\"col-sm-6\"><h3 class=\"with-line-same\">Extrato de Títulos</h3></div><div class=\"col-sm-6\"><h3 class=\"with-line-same\" style=\"font-size: 12px; color: red; text-align:right;\">*Serão exibidos documentos quitados apenas dos últimos 30 dias</h3></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\"><label>Data Inicial</label><md-datepicker name=\"dataInicio\" ng-model=\"relatorio.dataInicio\"></md-datepicker></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block\"><label>Data Final</label><md-datepicker name=\"dataFinal\" ng-model=\"relatorio.dataFinal\" ng-click=\"dataFinal()\"></md-datepicker></md-input-container></div></div></div><div class=\"col-sm-3\"><div class=\"row\"><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Operação Inicial</label> <input type=\"number\" name=\"operacaoInicio\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"relatorio.operacaoInicio\"></md-input-container></div><div class=\"col-sm-6\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Operação Final</label> <input type=\"number\" name=\"operacaoFinal\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"relatorio.operacaoFinal\"></md-input-container></div></div></div><div class=\"col-sm-3\"><div class=\"row\"><div class=\"col-sm-12\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Tipo de Documento</label><md-select aria-label=\"relatorio.tipoDocumento\" ng-model=\"relatorio.tipoDocumento\" placeholder=\"Tipo de Documento...\"><md-option ng-repeat=\"documento in opcaoDocumentos\" ng-value=\"{{documento.id}}\">{{ documento.nome }}</md-option></md-select></md-input-container></div></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>CNPJ/CPF do Sacado</label> <input ui-br-cpfcnpj-mask=\"\" name=\"cgccic\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"relatorio.cgccic\" ng-pattern=\"/^([0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}|[0-9]{2}\\.?[0-9]{3}\\.?[0-9]{3}\\/?[0-9]{4}\\-?[0-9]{2})$/\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Número do Título</label> <input type=\"text\" name=\"documento\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"relatorio.documento\"></md-input-container></div><div class=\"col-sm-1\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Carteira</label> <input type=\"number\" name=\"carteira\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"relatorio.carteira\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Emite Pendências</label><md-select aria-label=\"relatorio.emitePendencias\" ng-model=\"relatorio.emitePendencias\" placeholder=\"Emite Pendência...\" ng-change=\"validaPendencias(relatorio.emitePendencias)\"><md-option ng-repeat=\"pendencia in opcaoPendencia\" ng-value=\"{{pendencia.id}}\">{{ pendencia.nome }}</md-option></md-select></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Recebimentos</label><md-select class=\"fixed\" ng-model=\"relatorio.selectedRecebimentos\" ng-click=\"searchTerm = \'\'\" ng-disabled=\"desabilitaRecebidos\" uib-tooltip=\"{{ desabilitaRecebidos == true ? \'Período diferente de Recebimento\' : \'Escolha os tipos de recebimento\' }}\" multiple=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" placeholder=\"Pesquise...\" class=\"demo-header-searchbox md-text\"></md-select-header><md-button ng-click=\"validaRecebimento(relatorio.selectedRecebimentos)\">{{relatorio.selectedRecebimentos.length !== opcaoRecebimento.length ? \'MARCAR \' : \'DESMARCAR \'}}TODOS</md-button><md-option ng-value=\"recebimento.id\" ng-repeat=\"recebimento in opcaoRecebimento | filter:searchTerm\">{{recebimento.nome}}</md-option></md-select></md-input-container></div></div><h3 class=\"with-line-same\">Opções</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"col-sm-4\"><md-radio-group ng-model=\"relatorio.tipoPeriodo\" class=\"md-block\" ng-change=\"validaPeriodo(relatorio.tipoPeriodo)\" flex-gt-xs=\"\"><label class=\"label-cor\">Tipo de Período</label><md-radio-button ng-repeat=\"periodo in tipoPeriodo\" ng-value=\"periodo.value\" aria-label=\"{{periodo.title}}\">{{periodo.nome}}</md-radio-button></md-radio-group></div><div class=\"col-sm-4\"><md-radio-group ng-model=\"relatorio.tipoOperacao\" ng-change=\"valorTipoOperacao(relatorio.tipoOperacao)\" class=\"md-block\" flex-gt-xs=\"\"><label class=\"label-cor\">Operação</label><md-radio-button ng-repeat=\"operacao in tipoOperacao\" ng-value=\"operacao.value\" aria-label=\"{{operacao.title}}\">{{operacao.nome}}</md-radio-button></md-radio-group></div><div class=\"col-sm-4\"><md-radio-group ng-model=\"relatorio.tipoSituacao\" class=\"md-block\" flex-gt-xs=\"\"><label class=\"label-cor\">Situação</label><md-radio-button ng-repeat=\"situacao in tipoSituacao\" ng-value=\"situacao.value\" aria-label=\"{{situacao.title}}\">{{situacao.nome}}</md-radio-button></md-radio-group></div></div><div class=\"col-sm-6\"><div class=\"col-sm-4\"><div flex=\"100\" flex-gt-sm=\"72\" layout=\"column\"><label class=\"label-cor\">Pendências</label><md-checkbox ng-disabled=\"desabilitaCheckDevolvidos\" ng-model=\"relatorio.devolvidos\" aria-label=\"relatorio.devolvidos\" class=\"md-block\">Devolvidos</md-checkbox><md-checkbox ng-disabled=\"desabilitaCheckProrrogados\" ng-model=\"relatorio.prorrogados\" aria-label=\"relatorio.prorrogados\" class=\"md-block\">Prorrogados</md-checkbox><md-checkbox ng-disabled=\"desabilitaCheckProtestados\" ng-model=\"relatorio.protestados\" aria-label=\"relatorio.protestados\" class=\"md-block\">Protestados</md-checkbox><md-checkbox ng-disabled=\"desabilitaCheckCartorio\" ng-model=\"relatorio.cartorio\" aria-label=\"relatorio.cartorio\" class=\"md-block\">Em Cartório</md-checkbox></div></div><div class=\"col-sm-4\"><div flex=\"100\" flex-gt-sm=\"72\" layout=\"column\"><label class=\"label-cor\">Atualiza Saldos</label><md-checkbox ng-disabled=\"desabilitaVencidos\" ng-model=\"relatorio.atualizaVencidos\" aria-label=\"relatorio.atualizaVencidos\" class=\"md-block\" flex-gt-xs=\"\">Vencidos</md-checkbox><md-checkbox ng-disabled=\"desabilitaVencer\" ng-model=\"relatorio.atualizaVencer\" aria-label=\"relatorio.atualizaVencer\" class=\"md-block\" flex-gt-xs=\"\">A Vencer</md-checkbox></div></div><div class=\"col-sm-4\"><div flex=\"100\" flex-gt-sm=\"72\" layout=\"column\"><label class=\"label-cor\">Check-List Documento</label><md-checkbox ng-model=\"relatorio.documentoCanhoto\" aria-label=\"relatorio.documentoCanhoto\" class=\"md-block\" flex-gt-xs=\"\">Sem Canhoto</md-checkbox></div></div></div></div><div class=\"row\"><div class=\"col-xs-10 col-sm-1 col-sm-offset-6 col-md-1 col-md-offset-9\"><div class=\"fabSpeedDialdemoBasicUsage\"><div class=\"lock-size\" layout=\"row\"><md-fab-speed-dial md-open=\"isOpen\" md-direction=\"{{selectedDirection}}\" ng-class=\"selectedMode\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-warn\"><i class=\"ion-printer\"></i></md-button></md-fab-trigger><md-fab-actions><div class=\"pull-right tooltip-posicao\"><a uib-tooltip=\"Arquivo PDF\" tooltip-placement=\"top\"><md-button aria-label=\"grafico\" class=\"md-fab md-raised md-mini\" ng-click=\"visualizarDados(\'pdf\')\"><i class=\"ion-android-desktop fabButton-tamanho\"></i></md-button></a></div><div class=\"pull-right tooltip-posicao\"><a uib-tooltip=\"Arquivo TXT\" tooltip-placement=\"top\"><md-button aria-label=\"txt\" class=\"md-fab md-raised md-mini\" ng-click=\"visualizarDados(\'txt\')\"><i class=\"ion-ios-paper-outline fabButton-tamanho\"></i></md-button></a></div><div class=\"pull-right tooltip-posicao\"><a uib-tooltip=\"Arquivo CSV\" tooltip-placement=\"top\"><md-button aria-label=\"csv\" class=\"md-fab md-raised md-mini\" ng-click=\"visualizarDados(\'csv\')\"><i class=\"ion-pie-graph fabButton-tamanho\"></i></md-button></a></div></md-fab-actions></md-fab-speed-dial></div></div></div></div></form></div>");
$templateCache.put("app/pages/painel_relatorio/painel.relatorio.html","<div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/painel_relatorio/painel.relatorio.form.html\'\"></div></div></div>");
$templateCache.put("app/pages/painel_operacao/painel.operacao.grid.html","<div class=\"horizontal-scroll\"><h3 class=\"with-line-same\">Operações Realizadas</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"operacoes\" st-safe-src=\"operacaoOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"data\"><strong>Data da Operação</strong></th><th class=\"text-right\" st-sort=\"numero\"><strong>Operação</strong></th><th class=\"text-right\" st-sort=\"quantidade\"><strong>Qtd. Títulos</strong></th><th class=\"text-right\" st-sort=\"valor\"><strong>Valor Títulos</strong></th><th st-sort=\"documentos\"><strong>Documentos</strong></th></tr><tr><th><input st-search=\"data\" placeholder=\"Data da Operação\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"numero\" placeholder=\"Operação\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th><input st-search=\"quantidade\" placeholder=\"Qtd. Títulos\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th><input st-search=\"valor\" placeholder=\"Valor Títulos\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in operacoes |filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{::item.data}}</td><td class=\"preenchimento table-id\">{{::item.opeNumBase}}</td><td class=\"preenchimento table-id\">{{::item.quantidade}}</td><td class=\"preenchimento\" align=\"right\">{{::item.valor | moedaFilter}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button ng-if=\"ocultarAditivo == true\" ng-disabled=\"{{!item.arquivoTermo}}\" class=\"btn btn-primary editable-table-button btn-xs\" title=\"Emitir Aditivo\" ng-click=\"abrirTermo(item, \'aditivo\')\" ng-style=\"{{!item.arquivoTermo}} && ({\'background\': \'#6a706f\'}) || {\'background\': \'#209E91\'}\">Aditivo</button> <button ng-if=\"ocultarRecibo == true\" ng-disabled=\"{{!item.arquivoRecibo}}\" class=\"btn btn-primary editable-table-button btn-xs\" title=\"Emitir Recibo\" ng-click=\"abrirTermo(item, \'recibo\')\" ng-style=\"{{!item.arquivoRecibo}} && {\'background\': \'#6a706f\'} || {\'background\': \'#209E91\'}\">Recibo</button> <button ng-if=\"ocultarDuplicata == true\" ng-disabled=\"{{!item.arquivoDuplicata}}\" class=\"btn btn-primary editable-table-button btn-xs\" title=\"Emitir Duplicatas\" ng-click=\"abrirTermo(item, \'duplicata\')\" ng-style=\"{{!item.arquivoDuplicata}} && {\'background\': \'#6a706f\'} || {\'background\': \'#209E91\'}\">Duplicatas</button> <button ng-if=\"ocultarCartaSacado == true\" ng-disabled=\"{{!item.arquivoCartaSacado}}\" class=\"btn btn-primary editable-table-button btn-xs\" title=\"Emitir Carta ao Sacado\" ng-click=\"abrirTermo(item, \'carta ao sacado\')\" ng-style=\"{{!item.arquivoCartaSacado}} && {\'background\': \'#6a706f\'} || {\'background\': \'#209E91\'}\">Carta</button> <button ng-if=\"ocultarModoGrafico == true\" ng-disabled=\"!habilitaTermo\" class=\"btn btn-primary btn-xs\" ng-click=\"abrirTermoModoGrafico(item)\" title=\"Emitir Termo Aditivo\" ng-style=\"!habilitaTermo && {\'background\': \'#6a706f\'} || {\'background\': \'#209E91\'}\">Termo Aditivo</button><button ng-if=\"emiteBoleto == true\" class=\"btn btn-primary editable-table-button btn-xs\" title=\"Baixar 2ª Via Boleto\" ng-click=\"imprimirBoleto(item)\">Boleto</button> <a id=\"dwnldLnk\" download=\"2ª via boleto.pdf\" style=\"display:none;\"></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"operacoes.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></div></table></div><br><span ng-if=\"mensagemVazio\">{{mensagemVazio}}</span></div>");
$templateCache.put("app/pages/painel_operacao/painel.operacao.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/painel_operacao/painel.operacao.grid.html\"></div></div></div></div></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><div ng-if=\"animacaoMenu\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"(item.stateRef || \'\')\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i>{{ ::item.title }}</a></div><div ng-if=\"!animacaoMenu\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"(item.stateRef || \'\')\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" data-toggle=\"tooltip\" title=\"{{ ::item.title }}\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a></div><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::item.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div ng-if=\"animacaoMenu && papelUsuario == \'cliente\'\" style=\"position: relative; margin-top: -68px; text-align: center\"><a href=\"#/{{empcod}}/{{empfaccod}}/comoUsar\"><img style=\"text-align: center;\" src=\"assets/img/assistaVideo.png\"></a></div><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Voltar ao Topo\"></i>");
$templateCache.put("app/theme/components/pageTop/efetuarLogof.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-exit modal-icon\"></i><span>Sair do Sistema</span></div><div class=\"modal-body text-center\">Deseja realmente sair?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close(); finalizarSessao()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Não</button></div></div>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<style>\r\n  @media screen and (max-width: 380px) {\r\n    form {\r\n      width: 338px\r\n    }\r\n  }\r\n</style><form><div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a ng-if=\"papel != \'factoring\' && papel != \'administrador\'\" href=\"#/inicio\" class=\"al-logo clearfix\"><span>Difact</span>Web</a> <a ng-if=\"papel == \'factoring\' || papel == \'administrador\'\" href=\"\" class=\"al-logo clearfix\"><span>Difact</span>Web</a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a> <a hide-xs=\"\" class=\"al-logo clearfix\" style=\"padding-left:20px;font-size:17px;\">{{nomeHeader | capitalize}}</a> <a hide-gt-xs=\"\" class=\"al-logo clearfix\" style=\"padding-left:20px;font-size:17px;\">{{nomeHeaderSimplif | capitalize}}</a><div ng-if=\"empresas.length > 1\" class=\"al-user-profile\" uib-dropdown=\"\" style=\"float: left;margin-left: 12px; width: 120px;padding-top: 24px\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link dropdown-toggle\" aria-haspopup=\"true\" aria-expanded=\"true\"><span><i class=\"fa fa-industry\"></i> Empresas <i class=\"fa fa-chevron-down\"></i></span></a><ul class=\"top-dropdown-menu profile-dropdown dropdown-menu\" uib-dropdown-menu=\"\" style=\"width: auto; right: 47px; top:50px\"><li><i class=\"dropdown-arr\"></i></li><li ng-repeat=\"empresa in empresas | filter: { empcod: \'!\' + empcodUrl} && {empfaccod: \'!\' + empfaccodUrl }\"><a ng-href=\"{{::urlEmpresa(empresa.empcod, empresa.empfaccod)}}\" target=\"_blank\">{{empresa.nomeEmpresa}}</a></li></ul></div><div class=\"user-profile clearfix\" align=\"right\"><a ng-click=\"sair()\" class=\"signout\" style=\"cursor:pointer;\" scroll-on-click=\"\"><i class=\"fa fa-power-off\"></i> Sair</a></div></div></form>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb\"></ul></div>");
$templateCache.put("app/pages/cadastros/painel_bancos/observacao.html","<form><br><div class=\"form-group\"><textarea class=\"form-control\" placeholder=\"Digite aqui observações gerais para a factoring...\"></textarea></div></form>");
$templateCache.put("app/pages/cadastros/painel_bancos/painel.bancos.grid.html","<style>\r\na{\r\n  cursor:pointer;\r\n}\r\n</style><div ng-init=\"buscaBancosCadastrados()\" class=\"horizontal-scroll\"><h3 style=\"line-height: 20px\" class=\"with-line-same\">Dados Bancários</h3><table class=\"table\" st-table=\"bancos\" st-safe-src=\"bancoOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"numdoc\">Banco</th><th st-sort=\"vencimento\">Agência</th><th st-sort=\"valor\">Conta</th><th st-sort=\"gerente\">Gerente</th><th st-sort=\"action\">Ação</th></tr></thead><tbody><tr ng-repeat=\"item in bancos|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{item.nomeBanco}}</td><td>{{item.agencia}}</td><td>{{item.conta}}</td><td>{{item.gerente}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><a title=\"Alterar Banco\" ng-click=\"editarBanco(item)\" scroll-on-click=\"\"><i class=\"ion-android-create\" style=\"font-size: 26px;padding-right:10px;\"></i></a> <a title=\"Excluir Banco\" ng-click=\"verificaExclusao(item);\" scroll-on-click=\"\"><i class=\"ion-android-delete\" style=\"font-size: 26px;padding-right:10px;\"></i></a></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"bancos.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/cadastros/painel_bancos/painel.bancos.html","<style>\r\n	md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n	md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n		border-color: #1B867B;\r\n	}\r\n	\r\n	md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n	md-input-container:not(.md-input-invalid).md-input-focused label {\r\n		color: #1B867B;\r\n	}\r\n	\r\n	md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n	md-select:not([disabled]):focus .md-select-value {\r\n		border-bottom-color: #1B867B;\r\n		color: rgba(0, 0, 0, 0.87);\r\n	}\r\n	\r\n	md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n	md-select-menu md-content md-option:not([disabled]):focus,\r\n	md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n	md-select-menu md-content md-option:not([disabled]):hover {\r\n		background: rgb(238, 238, 238);\r\n		color: #1B867B;\r\n	}\r\n</style><script language=\"JavaScript\">\r\n	function somenteNumero(e){\r\n		var tecla=(window.event)?event.keyCode:e.which;   \r\n		if((tecla>47 && tecla<58)) return true;\r\n		else{\r\n			if (tecla==8 || tecla==0) return true;\r\n		else  return false;\r\n		}\r\n	}\r\n</script><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"dadosBancariosForm\"><div ba-panel=\"\" ba-panel-button=\"adicionar\" ba-panel-class=\"with-scroll\"><a type=\"button\" data-toggle=\"modal\" title=\"{{tituloIcone}}\" ng-click=\"alteraIcone()\" style=\"cursor:pointer;\"><i ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a><div ng-init=\"parametrosIniciais()\" ng-show=\"ocultar\" layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><md-content layout-padding=\"\"><div><h3 class=\"with-line-same\">Dados</h3><div layout-gt-xs=\"row\"><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Banco</label> <input required=\"\" type=\"nomeBanco\" name=\"nomeBanco\" focus-me=\"{{acionarFocoBotao}}\" restrict=\"reject\" autocomplete=\"off\" maxlength=\"20\" ng-model=\"dadosBancarios.nomeBanco\"><div ng-messages=\"dadosBancariosForm.nomeBanco.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"dadosBancariosForm.nomeBanco.$touched\">O banco deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Agência</label> <input required=\"\" type=\"agencia\" name=\"agencia\" restrict=\"reject\" autocomplete=\"off\" maxlength=\"20\" ng-model=\"dadosBancarios.agencia\"><div ng-messages=\"dadosBancariosForm.agencia.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"dadosBancariosForm.agencia.$touched\">A agência deve ser informada.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Conta</label> <input required=\"\" onkeypress=\"return somenteNumero(event)\" name=\"conta\" restrict=\"reject\" autocomplete=\"off\" minlength=\"1\" maxlength=\"10\" ng-model=\"dadosBancarios.conta\"><div ng-messages=\"dadosBancariosForm.conta.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"dadosBancariosForm.conta.$touched\">A conta deve ser informada.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Gerente</label> <input type=\"gerente\" name=\"gerente\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"dadosBancarios.gerente\"></md-input-container></div></div></div></md-content><div align=\"right\"><button title=\"Salvar Dados\" ng-click=\"salvarDadosBancarios()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i> Salvar</button></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/cadastros/painel_bancos/painel.bancos.grid.html\"></div></div></form></div></div></div>");
$templateCache.put("app/pages/cadastros/painel_bancos/removemodal.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-delete modal-icon\"></i><span>Exclusão de dados.</span></div><div class=\"modal-body text-center\">Deseja excluir esta informação?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Não</button></div></div>");
$templateCache.put("app/pages/cadastros/painel_sacado/painel.endereco.grid.html","<style>\r\n  .col-sm-1 {\r\n    width: 3.333333%;\r\n  }\r\n</style><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-sm-1\"><a type=\"button\" data-toggle=\"modal\" title=\"Incluir novo endereço\" ng-click=\"addEnd()\"><i class=\"ion-android-add-circle\" style=\"font-size: 30px;padding-right:10px;\"></i></a></div><div style=\"margin-top: 7px;\" class=\"col-sm-11\"><h5 class=\"with-line\">Endereços</h5></div></div></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td></td><td>CEP</td><td>Logradouro</td><td>Complemento</td><td>Bairro</td><td>Cidade/UF</td><td>Ações</td></tr><tr ng-repeat=\"endereco in enderecos track by $index\" class=\"editable-row\"><td style=\"padding-top: 20px; padding-left: 10px;\"><div ng-if=\"endereco.cepInvalido == \'S\'\"><i class=\"ion-close\" title=\"CEP inválido\" style=\"font-size: 15px;padding-left: 12px; color:#e02f2f\"></i></div><div ng-if=\"endereco.cepInvalido == \'N\'\"><i class=\"ion-checkmark\" title=\"CEP válido\" style=\"font-size: 15px;padding-left: 12px; color:#209e91\"></i></div></td><td><md-input-container style=\"width: 100px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" mask=\"99999-999\" name=\"CEP\" ng-model=\"endereco.CepId\" autocomplete=\"off\" ng-blur=\"pegaCEP(endereco, $index)\" form=\"rowform\"></md-input-container></td>{{$index}}<td><md-input-container style=\"width: 150px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" name=\"CepLog\" ng-model=\"endereco.CepLog\" autocomplete=\"off\" form=\"rowform\"></md-input-container></td><td><md-input-container style=\"width: 150px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" name=\"complemento\" ng-model=\"endereco.CepComp\" autocomplete=\"off\" form=\"rowform\"></md-input-container></td><td><md-input-container style=\"width: 150px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" name=\"bairro\" ng-model=\"endereco.CepBai\" autocomplete=\"off\" form=\"rowform\"></md-input-container></td><td><md-input-container style=\"width: 150px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" name=\"ciduf\" ng-model=\"endereco.CidUf\" disabled=\"\" autocomplete=\"off\" form=\"rowform\"></md-input-container></td><td><form editable-form=\"\" name=\"rowform\" class=\"form-buttons form-inline\" shown=\"inserted == endereco\"><div class=\"buttons\" style=\"margin-top:16px; color:#1B867B; text-align: center;\"><i class=\"ion-android-delete\" ng-click=\"cancelarEndereco($index)\" style=\"font-size: 24px;padding-right:10px;\"></i></div></form></td></tr></table>");
$templateCache.put("app/pages/cadastros/painel_sacado/painel.sacado.html","<style>\r\n  md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n  md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n    border-color: #1B867B;\r\n  }\r\n  \r\n  md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n  md-input-container:not(.md-input-invalid).md-input-focused label {\r\n    color: #1B867B;\r\n  }\r\n</style><script language=\"JavaScript\">\r\n  function somenteNumero(e) {\r\n    var tecla = (window.event) ? event.keyCode : e.which;\r\n    if ((tecla > 47 && tecla < 58)) return true;\r\n    else {\r\n      if (tecla == 8 || tecla == 0) return true;\r\n      else return false;\r\n    }\r\n  }\r\n</script><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"sacadoForm\"><div ba-panel=\"\" ba-panel-button=\"adicionar\" ba-panel-class=\"with-scroll\"><a type=\"button\" data-toggle=\"modal\" title=\"{{tituloIcone}}\" ng-click=\"alteraIcone()\" style=\"cursor:pointer;\"><i ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a><div ng-show=\"ocultar\" layout=\"column\" ng-cloak=\"\" class=\"md-inline-form\"><div><h3 class=\"with-line-same\">Sacado</h3><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>CNPJ/CPF</label> <input required=\"\" ui-br-cpfcnpj-mask=\"\" name=\"cgccic\" focus-me=\"{{acionarFocoBotao}}\" restrict=\"reject\" ng-blur=\"buscaSacado(true)\" autocomplete=\"off\" ng-model=\"sacado.cgccic\" ng-pattern=\"/^([0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}|[0-9]{2}\\.?[0-9]{3}\\.?[0-9]{3}\\/?[0-9]{4}\\-?[0-9]{2})$/\"><div ng-messages=\"sacadoForm.cgccic.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"cpfInvalido || required\" ng-show=\"cpfInvalido || required\">O CNPJ/CPF informado é inválido.</div></div></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nome</label> <input required=\"\" name=\"nome\" ng-model=\"sacado.nome\" autocomplete=\"off\" md-maxlength=\"80\" rows=\"5\"><div ng-messages=\"sacadoForm.nome.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"sacadoForm.nome.$touched\">O nome deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-4\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>E-mail</label> <input type=\"email\" name=\"email\" ng-model=\"sacado.email\" autocomplete=\"off\" minlength=\"10\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"sacadoForm.email.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'pattern\']\" ng-show=\"sacadoForm.nome.$touched\">O e-mail informado é inválido.</div></div></md-input-container></div><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nascimento</label> <input name=\"nascimento\" mask=\"99/99/9999\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"sacado.nascimento\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\"></md-input-container></div></div></div></div></div><div class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.endereco.grid.html\"></div></div></div></div></div><div class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.telefone.grid.html\"></div></div></div></div></div><div align=\"right\"><button ng-click=\"gravarSacado()\" title=\"Salvar Dados\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Salvar</button></div></div></div></form><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/cadastros/painel_sacados/painel.sacados.grid.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/cadastros/painel_sacado/painel.telefone.grid.html","<style>\r\n  .col-sm-1 {\r\n    width: 3.333333%;\r\n  }\r\n  \r\n  md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n  md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n    border-color: #1B867B;\r\n  }\r\n  \r\n  md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n  md-input-container:not(.md-input-invalid).md-input-focused label {\r\n    color: #1B867B;\r\n  }\r\n  \r\n  md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n  md-select:not([disabled]):focus .md-select-value {\r\n    border-bottom-color: #1B867B;\r\n    color: rgba(0, 0, 0, 0.87);\r\n  }\r\n  \r\n  md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n  md-select-menu md-content md-option:not([disabled]):focus,\r\n  md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n  md-select-menu md-content md-option:not([disabled]):hover {\r\n    background: rgb(238, 238, 238);\r\n    color: #1B867B;\r\n  }\r\n</style><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-sm-1\"><a type=\"button\" data-toggle=\"modal\" title=\"Incluir novo telefone\" ng-click=\"addTel()\"><i class=\"ion-android-add-circle\" style=\"font-size: 30px;padding-right:10px;\"></i></a></div><div style=\"margin-top: 7px;\" class=\"col-sm-11\"><h5 class=\"with-line\">Telefones</h5></div></div></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td>Tipo</td><td>Número</td><td>Observação</td><td>Ações</td></tr><tr ng-repeat=\"telefone in telefones track by $index\" class=\"editable-row\"><td><md-input-container style=\"width: 200px;\" class=\"form-group row clearfix\"><md-select style=\"margin: -17px 13px; width: 117%\" name=\"telefone.tipo\" type=\"tipo\" ng-model=\"telefone.tipo\" placeholder=\"Selecione o tipo...\"><md-option ng-value=\"tipo.name\" ng-repeat=\"tipo in tiposTelefones\">{{ tipo.name }}</md-option></md-select></md-input-container></td>{{$index}}<td><md-input-container style=\"width: 250px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input class=\"phoneinput\" style=\"width: 117%;\" name=\"numero\" ng-model=\"telefone.numero\" maxlength=\"15\" autocomplete=\"off\" form=\"rowform\" restrict=\"reject\"></md-input-container></td><td><md-input-container style=\"width: 250px; margin: 1px 0;\" class=\"form-group row clearfix\"><label></label> <input style=\"width: 117%;\" type=\"text\" name=\"obs\" ng-model=\"telefone.obs\" autocomplete=\"off\" form=\"rowform\"></md-input-container></td><td><form editable-form=\"\" name=\"rowform\" class=\"form-buttons form-inline\" shown=\"inserted == telefone\"><div class=\"buttons\" style=\"margin-top:16px; color:#1B867B; text-align: center;\"><i class=\"ion-android-delete\" ng-click=\"cancelarTelefone($index)\" style=\"font-size: 24px;padding-right:10px;\"></i></div></form></td></tr></table>");
$templateCache.put("app/pages/cadastros/painel_sacados/painel.sacados.grid.html","<div ng-init=\"buscarSacadosCadastrados()\" class=\"horizontal-scroll\"><h3 class=\"with-line-same\">Sacados</h3><table class=\"table\" st-table=\"sacados\" st-safe-src=\"sacadosOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"SacCgcCic\">CNPJ/CPF</th><th st-sort=\"SacNom\">Nome</th><th st-sort=\"PesTip\">Tipo</th><th st-sort=\"PesEmail\">E-mail</th><th st-sort=\"action\">Ação</th></tr><tr><th><input st-search=\"SacCgcCic\" placeholder=\"CNPJ/CPF\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"SacNom\" placeholder=\"Nome\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"PesTip\" placeholder=\"Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"PesEmail\" placeholder=\"E-mail\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in sacados |filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{item.SacCgcCic}}</td><td>{{item.SacNom}}</td><td>{{item.PesTip}}</td><td>{{item.PesEmail}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><a title=\"Alterar Sacado\" ng-click=\"buscaDados(item)\" scroll-on-click=\"\"><i class=\"ion-android-create\" style=\"font-size: 26px;padding-right:10px;\"></i></a></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"sacados.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/cadastros/painel_sacados/painel.sacados.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/cadastros/painel_sacados/painel.sacados.grid.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/prorrogacoes/enviar_prorrogacao/new-prorrogacao.html","<style>\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value.md-select-placeholder {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n    md-select:not([disabled]):focus .md-select-value {\r\n        border-bottom-color: #1B867B;\r\n        color: rgba(0, 0, 0, 0.87);\r\n    }\r\n\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n    md-select-menu md-content md-option:not([disabled]):focus,\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n    md-select-menu md-content md-option:not([disabled]):hover {\r\n        background: rgb(238, 238, 238);\r\n        color: #1B867B;\r\n    }\r\n\r\n    .switchdemoBasicUsage .inset {\r\n        padding-left: 25px;\r\n        padding-top: 25px;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-thumb,\r\n    md-switch.md-checked .md-thumb {\r\n        background-color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-ink-ripple,\r\n    md-switch.md-checked .md-ink-ripple {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-bar,\r\n    md-switch.md-checked .md-bar {\r\n        background-color: #8fc5c0;\r\n    }\r\n\r\n    md-input-container {\r\n        margin: 14px 0;\r\n    }\r\n\r\n    md-switch {\r\n        margin: 10px 0px;\r\n        height: 19px;\r\n    }\r\n\r\n    h3.with-line {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    h5.with-line {\r\n        padding-top: 0px;\r\n    }\r\n</style><script language=\"JavaScript\">\r\n    function somenteNumero(e) {\r\n        var tecla = (window.event) ? event.keyCode : e.which;\r\n        if ((tecla > 47 && tecla < 58)) return true;\r\n        else {\r\n            if (tecla == 8 || tecla == 0) return true;\r\n            else return false;\r\n        }\r\n    }\r\n</script><div class=\"widgets\" ng-init=\"buscarTitulos(); buscaProrragaNaoEnviadas();\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><form name=\"novaRemessaForm\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><h3 class=\"with-line-same\">Títulos para Prorrogação</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulos\" st-safe-src=\"titulosOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th st-sort=\"numeroDoc\"><strong>Número</strong></th><td st-sort=\"nossoNumero\"><strong>Nosso Número</strong></td><th st-sort=\"nomeSacado\"><strong>Sacado</strong></th><th style=\"text-align: right;\" st-sort=\"docValor\"><strong>Valor</strong></th></tr><tr><th><input st-search=\"vencimento\" placeholder=\"Vencimento\" class=\"input-sm form-control search-input\" type=\"search\" mask=\"99/99/9999\" ng-model=\"Vencimento\"></th><th><input st-search=\"numeroDoc\" placeholder=\"Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nossoNumero\" placeholder=\"Nosso Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nomeSacado\" placeholder=\"Sacado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"docValor\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in titulos|filter:search |startFrom:(pagination.currentPage - 1) * pagination.pageSize|limitTo: pagination.pageSize\"><td style=\"width: 10%;\">{{item.vencimento}}</td><td style=\"width: 15%;\">{{item.numeroDoc}}</td><td style=\"width: 15%;\">{{item.nossoNumero}}</td><td style=\"width: 40%;\" title=\"{{item.nomeSacado}}\">{{item.nomeSacado | limitTo: 45 }} {{item.nomeSacado.length > 45 ? \'...\' : \'\'}}</td><td align=\"right\" style=\"padding-right: 22px; width: 10%;\">{{item.docValor}}</td><td style=\"width: 10%;\"><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-info btn-xs\" title=\"Prorrogar Títulos\" ng-style=\"{\'background\': \'#209e91\'}\" ng-click=\"prorrogar(item, operacao)\">Prorrogar</button> <a id=\"dwnldLnk\" download=\"2ª via boleto.pdf\" style=\"display:none;\"></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulos.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" items-per-page=\"pagination.pageSize\" num-pages=\"qtdPages\" ng-model=\"pagination.currentPage\" max-size=\"pagination.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"true\"></ul></div></td></tr></tfoot></div></table></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-sm-1\" style=\"width: 3.333333% !important;\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" nv-file-select=\"\" uploader=\"uploaderAnexos\" multiple=\"\"> <label align=\"left\" style=\"font-size: 24px;\" for=\"fileInput\"><i style=\"cursor: pointer; color: #209e91\" class=\"ion-android-attach\"></i></label></div><div class=\"col-sm-11\"><md-chips style=\"outline: none !important;\" ng-model=\"fileStrings\" name=\"Anexos\" readonly=\"true\" md-max-chips=\"5\" placeholder=\"Anexos\"><md-chip-template><span>{{$chip.name | limitTo: 10 }} {{$chip.name.length > 10 ? \'...\' : \'\'}}</span><md-icon style=\"width: 10px !important; min-width: 10px !important;\" ng-click=\"removeAnexo($chip)\" md-font-icon=\"ion-android-close\" class=\"s16\"></md-icon></md-chip-template></md-chips></div></div></div><div class=\"col-sm-2\" align=\"right\"><a ng-click=\"verificaEnvio()\"><button ng-disabled=\"!titulosRemessa.length\" title=\"Enviar prorrogações à Factoring\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-send\"></i>Enviar</button></a></div></div><h3 style=\"line-height: 20px\" class=\"with-line-same\">Títulos Prorrogados para Envio</h3><div class=\"row\"><div class=\"col-sm-12\"><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Data de Criação:</strong> {{dataOperacao}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Quantidade:</strong> {{qtdTitulos}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Valor Total:</strong> {{valorTitulos}}</div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div include-with-scope=\"app/pages/prorrogacoes/enviar_prorrogacao/painel.prorrogacao.grid.html\"></div></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/prorrogacoes/enviar_prorrogacao/painel.prorrogacao.grid.html","<div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulosRemessa\" st-safe-src=\"remessasOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"numdoc\"><strong>Número</strong></th><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th st-sort=\"novoVenc\"><strong>Prorrogação</strong></th><th style=\"text-align: right;\" st-sort=\"valor\"><strong>Valor</strong></th><th st-sort=\"nome\"><strong>Sacado</strong></th><th st-sort=\"tipodoc\"><strong>Tipo</strong></th><th st-sort=\"action\"><strong>Ação</strong></th></tr></thead><tbody><tr ng-repeat=\"item in titulosRemessa|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td>{{item.numdoc}}</td><td>{{item.vencimento}}</td><td>{{item.novoVenc}}</td><td align=\"right\" style=\"padding-right: 22px;\">{{item.valor | moedaFilter}}</td><td title=\"{{item.nome}}\">{{item.nome | limitTo: 45}} {{item.nome.length > 45 ? \'...\' : \'\'}}</td><td>{{item.tipodoc | nomeTipoDocumento}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><a title=\"Alterar Título\" ng-click=\"editarTitulo(item, operacao)\" scroll-on-click=\"\"><i class=\"ion-android-create\" style=\"font-size: 26px;padding-right:10px;\"></i></a> <a title=\"Excluir Título\" ng-click=\"verificaExclusao(item);\" scroll-on-click=\"\"><i class=\"ion-android-delete\" style=\"font-size: 26px;\"></i></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulosRemessa.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></div></table></div><br><span ng-if=\"mensagemVazio\">{{mensagemVazio}}</span></div>");
$templateCache.put("app/pages/prorrogacoes/enviar_prorrogacao/prorrogar-titulo.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll\" ng-init=\"carregarTitulo()\"><button class=\"ion-android-cancel\" style=\"font-size: 30px; color: #9e2020; background:none; border: none; padding-left: 0;\" align=\"left\" ng-click=\"retornar()\"></button><h3 class=\"with-line-same\">Prorrogar Título</h3><div class=\"row\"><div class=\"col-sm-2\"><strong>Vencimento</strong></div><div class=\"col-sm-2\"><strong>Número</strong></div><div class=\"col-sm-2\"><strong>Nosso Numero</strong></div><div class=\"col-sm-1\" align=\"right\"><strong>Valor</strong></div><div class=\"col-sm-4\"><strong>Sacado</strong></div></div><br><div class=\"row\"><div class=\"col-sm-2\">{{vencimento}}</div><div class=\"col-sm-2\">{{numeroDoc}}</div><div class=\"col-sm-2\">{{nossoNumero}}</div><div class=\"col-sm-1\" align=\"right\">{{docValor}}</div><div class=\"col-sm-4\">{{nomeSacado}}</div></div><br><br><br><div class=\"row\"><div class=\"col-sm-2\"><strong>Novo Vencimento</strong></div><div class=\"col-sm-10\"><strong>Observações</strong></div></div><br><div class=\"row\"><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><input required=\"\" mask=\"99/99/9999\" name=\"vencimento\" restrict=\"reject\" placeholder=\"Digite uma nova data\" autocomplete=\"off\" ng-model=\"novaProrrogacao.vencimento\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\"></md-input-container></div><div class=\"col-sm-6\"><textarea maxlength=\"240\" class=\"form-control tamanho-instrucaoArea\" ng-model=\"novaProrrogacao.observacao\" placeholder=\"Digite aqui observações gerais para a factoring...\"></textarea></div><div class=\"col-sm-1\"><div align=\"left\"><div style=\"margin-top: 60px;\"><a ng-click=\"\"><button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"salvar()\" scroll-on-click=\"\"><i class=\"ion-android-checkmark-circle\"></i>Salvar</button></a></div></div></div></div></div>");
$templateCache.put("app/pages/remessas/enviar_remessas/remessa.enviar.html","<div class=\"modal-content\" ng-controller=\"SelectpickerPanelCtrl as selectpickerVm\"><div class=\"modal-header cabecalho-instrucao\"><i></i><span>Instruções de Pagamento e Recomendações para a Factoring</span></div><div class=\"modal-body\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control tamanho-instrucaoArea\" ng-model=\"selectpickerVm.observacao\" placeholder=\"Digite aqui observações gerais para a factoring...\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-if=\"mostraImprimeDup\" ng-model=\"selectpickerVm.imprimirDuplicata\" aria-label=\"selectpickerVm.imprimirDuplicata\">Imprimir Duplicata após o envio da Operação?</md-checkbox></div></div></div></div><div class=\"modal-footer\"><a><button ng-click=\"enviarEmail(); $dismiss()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Enviar</button></a> <button ng-click=\"$dismiss()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-ios-close-outline\"></i>Cancelar</button></div></div>");
$templateCache.put("app/pages/prorrogacoes/painel_prorrogacoes/painel.prorrogacoes.html","<style>\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value.md-select-placeholder {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n    md-select:not([disabled]):focus .md-select-value {\r\n        border-bottom-color: #1B867B;\r\n        color: rgba(0, 0, 0, 0.87);\r\n    }\r\n\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n    md-select-menu md-content md-option:not([disabled]):focus,\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n    md-select-menu md-content md-option:not([disabled]):hover {\r\n        background: rgb(238, 238, 238);\r\n        color: #1B867B;\r\n    }\r\n\r\n    .switchdemoBasicUsage .inset {\r\n        padding-left: 25px;\r\n        padding-top: 25px;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-thumb,\r\n    md-switch.md-checked .md-thumb {\r\n        background-color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-ink-ripple,\r\n    md-switch.md-checked .md-ink-ripple {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-bar,\r\n    md-switch.md-checked .md-bar {\r\n        background-color: #8fc5c0;\r\n    }\r\n\r\n    md-input-container {\r\n        margin: 14px 0;\r\n    }\r\n\r\n    md-switch {\r\n        margin: 10px 0px;\r\n        height: 19px;\r\n    }\r\n\r\n    h3.with-line {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    h5.with-line {\r\n        padding-top: 0px;\r\n    }\r\n</style><script language=\"JavaScript\">\r\n    function somenteNumero(e) {\r\n        var tecla = (window.event) ? event.keyCode : e.which;\r\n        if ((tecla > 47 && tecla < 58)) return true;\r\n        else {\r\n            if (tecla == 8 || tecla == 0) return true;\r\n            else return false;\r\n        }\r\n    }\r\n</script><div class=\"widgets\" ng-init=\"buscarTitulos()\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><form name=\"novaRemessaForm\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><h3 class=\"with-line-same\">Situação das Prorrogações Enviadas</h3><div class=\"table-responsive\"><table class=\"table\" st-table=\"dadosRemessa\" st-safe-src=\"titulosOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th st-sort=\"novoVenc\"><strong>Prorrogação</strong></th><th st-sort=\"numdoc\"><strong>Número</strong></th><th st-sort=\"nome\"><strong>Sacado</strong></th><th style=\"text-align: right;\" st-sort=\"valor\"><strong>Valor</strong></th><th><strong>Situação</strong></th><th><strong>Parecer</strong></th></tr><tr><th><input st-search=\"vencimento\" placeholder=\"Vencimento\" class=\"input-sm form-control search-input\" type=\"search\" mask=\"99/99/9999\" ng-model=\"Vencimento\"></th><th><input st-search=\"novoVenc\" placeholder=\"Prorrogação\" class=\"input-sm form-control search-input\" type=\"search\" mask=\"99/99/9999\" ng-model=\"novoVenc\"></th><th><input st-search=\"numdoc\" placeholder=\"Número\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nome\" placeholder=\"Sacado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"valor\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"></th><th><select name=\"select\" st-search=\"situacaoProrrogacao\" placeholder=\"situacaoProrrogacao\" class=\"input-sm form-control search-input input-filtroOperacao\" type=\"search\"><option value=\"\" selected=\"\">Todos</option><option value=\"A\">Aguardando</option><option value=\"P\">Prorrogado</option><option value=\"R\">Recusado</option></select></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in dadosRemessa|filter:search |startFrom:(pagination.currentPage - 1) * pagination.pageSize|limitTo: pagination.pageSize\"><td style=\"width: 10%;\">{{item.vencimento}}</td><td style=\"width: 10%;\">{{item.novoVenc}}</td><td style=\"width: 15%;\">{{item.numdoc}}</td><td style=\"width: 45%;\" title=\"{{item.nome}}\">{{item.nome | limitTo: 45}} {{item.nome.length > 45 ? \'...\' : \'\'}}</td><td align=\"right\" style=\"padding-right: 22px; width: 10%;\">{{item.valor}}</td><td style=\"width: 10%;\"><div ng-if=\"item.situacaoProrrogacao == \'R\'\" style=\"text-align:center\"><i class=\"ion-close\" title=\"Prorrogação recusada\" style=\"font-size: 26px; color:#e02f2f\"></i></div><div ng-if=\"item.situacaoProrrogacao == \'P\'\" style=\"text-align:center\"><i class=\"ion-checkmark\" title=\"Prorrogação aprovada\" style=\"font-size: 26px; color:#209e91\"></i></div><div ng-if=\"item.situacaoProrrogacao == \'A\'\" style=\"text-align:center\"><i class=\"ion-loop\" title=\"Aguardando parecer da empresa\" style=\"font-size: 26px; color:#707e94\"></i></div></td><td style=\"width: 10%;\"><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-info btn-xs\" title=\"Parecer\" ng-style=\"{\'background\': \'#209e91\'}\" ng-disabled=\"item.parecerProrrogacao == \'\'\" ng-click=\"verificaParecer(item)\">Parecer</button></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"dadosRemessa.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" items-per-page=\"pagination.pageSize\" num-pages=\"qtdPages\" ng-model=\"pagination.currentPage\" max-size=\"pagination.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"true\"></ul></div></td></tr></tfoot></div></table></div></div></form></div></div></div>");
$templateCache.put("app/pages/prorrogacoes/painel_prorrogacoes/parecer.prorrogacoes.modal.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"modal-icon\"></i> <span>Parecer da Solicitação de Prorrogação</span></div><div class=\"modal-body text-center\">{{parecer}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss();\">Ok</button></div></div>");
$templateCache.put("app/pages/remessas/importar_titulos/titulos.importar.html","<h3 class=\"with-line\">Importar Arquivos</h3><div nv-file-drop=\"\" uploader=\"uploader\" filters=\"queueLimit, customFilter\"><div class=\"col-md-3\"><div ng-show=\"uploader.isHTML5\"><div class=\"well my-drop-zone\" nv-file-over=\"\" uploader=\"uploader\"><p align=\"center\"><center>Arraste arquivo para esta área</center></p></div></div><input type=\"file\" name=\"file\" id=\"file\" class=\"inputfile\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\"> <label for=\"file\" class=\"labeltext\">Selecionar Arquivo</label></div><div class=\"col-md-9\"><u><h5>Arquivos de Importação (Tipos suportados: CNAB e NF-e)</h5></u><table class=\"table\"><thead><tr><th width=\"70%\">Nome</th><th ng-show=\"uploader.isHTML5\">Tamanho</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024|number:2 }} KB</td><td><div ng-if=\"item.isSucess == false\"><i class=\"ion-close item-erro-cor\" title=\"Erro\"></i></div><div ng-if=\"item.isSucess == true\"><i class=\"ion-checkmark item-sucesso-cor\" title=\"Sucesso\"></i></div></td><td class=\"text-center\"><span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span></td><td nowrap=\"\"><div ng-if=\"desabilitarItem == false\"><a title=\"Excluir Arquivo\" ng-click=\"item.remove(); remover();\"><i class=\"ion-android-delete tamanho-botao-progresso\"></i></a></div><div ng-if=\"desabilitarItem == true\"><a title=\"Excluir Arquivo\" ng-click=\"item.remove(); remover(item);\"><i class=\"ion-android-delete tamanho-botao-progresso\"></i></a></div></td></tr></tbody></table><div><div>Progresso:<div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': uploader.progress + \'%\' }\"></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\" title=\"Importa cada arquivo em uma nova remessa\"><i class=\"ion-android-upload\"></i>Importar</button> <button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\"><i class=\"ion-android-delete\"></i>Remover</button></div></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/observacao.html","<div class=\"modal-content\"><div ng-if=\"!prorroga\" class=\"modal-header cabecalho-instrucao\"><i></i><span>Instruções de Pagamento e Recomendações para a Factoring</span></div><div ng-if=\"prorroga\" class=\"modal-header cabecalho-instrucao\"><i></i><span>Instruções de Prorrogação e Recomendações para a Factoring</span></div><div class=\"modal-body\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control tamanho-instrucaoArea\" ng-model=\"email.observacao\" placeholder=\"Digite aqui observações gerais para a factoring...\"></textarea></div></div></div></div></div><div class=\"modal-footer\"><a><button ng-click=\"enviarRemessa(); $close()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Enviar</button></a> <button ng-click=\"$dismiss()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-ios-close-outline\"></i>Cancelar</button></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/painel.alteraremessa.grid.html","<div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulosRemessa\" st-safe-src=\"remessasOrdena\"><thead><tr class=\"sortable\"><th style=\"width: 1px\" st-sort=\"situacao\"><strong>Situação</strong></th><th st-sort=\"numdoc\"><strong>Número</strong></th><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th style=\"text-align: right;\" st-sort=\"valor\"><strong>Valor</strong></th><th st-sort=\"nome\"><strong>Sacado</strong></th><th st-sort=\"tipodoc\"><strong>Tipo</strong></th><th st-sort=\"action\"><strong>Ação</strong></th></tr></thead><tbody><tr ng-repeat=\"item in titulosRemessa|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td><div ng-if=\"item.docinderr == \'S\'\"><i class=\"ion-close\" title=\"Título inconsistente - Não será importado\" style=\"font-size: 26px;padding-left: 15px; color:#e02f2f\"></i></div><div ng-if=\"item.docinderr == \'N\'\"><i class=\"ion-checkmark\" title=\"Título consistente\" style=\"font-size: 26px;padding-left: 15px; color:#209e91\"></i></div></td><td>{{item.numdoc}}</td><td>{{item.vencimento}}</td><td align=\"right\" style=\"padding-right: 22px;\">{{item.valor | moedaFilter}}</td><td>{{item.nome}}</td><td>{{item.tipodoc | nomeTipoDocumento}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><a title=\"Alterar Título\" ng-click=\"editarTitulo(item)\" scroll-on-click=\"\"><i class=\"ion-android-create\" style=\"font-size: 26px;padding-right:10px;\"></i></a> <a title=\"Excluir Título\" ng-click=\"verificaExclusao(item);\" scroll-on-click=\"\"><i class=\"ion-android-delete\" style=\"font-size: 26px;\"></i></a></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulosRemessa.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/painel.alteraremessa.html","<style>\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n    \r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n    \r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value.md-select-placeholder {\r\n        color: #1B867B;\r\n    }\r\n    \r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value {\r\n        color: #1B867B;\r\n    }\r\n    \r\n    md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n    md-select:not([disabled]):focus .md-select-value {\r\n        border-bottom-color: #1B867B;\r\n        color: rgba(0, 0, 0, 0.87);\r\n    }\r\n    \r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n    md-select-menu md-content md-option:not([disabled]):focus,\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n    md-select-menu md-content md-option:not([disabled]):hover {\r\n        background: rgb(238, 238, 238);\r\n        color: #1B867B;\r\n    }\r\n</style><script language=\"JavaScript\">\r\n    function somenteNumero(e) {\r\n        var tecla = (window.event) ? event.keyCode : e.which;\r\n        if ((tecla > 47 && tecla < 58)) return true;\r\n        else {\r\n            if (tecla == 8 || tecla == 0) return true;\r\n            else return false;\r\n        }\r\n    }\r\n</script><div class=\"widgets\" ng-init=\"parametrosIniciais()\"><form name=\"novaRemessaForm\"><div class=\"row\"><div class=\"col-md-12\"><div ng-if=\"ocultaPanel\" ba-panel=\"\" ba-panel-button=\"adicionar\" ba-panel-class=\"with-scroll\"><a ng-if=\"ocultaPanel\" type=\"button\" data-toggle=\"modal\" title=\"{{tituloIcone}}\" ng-click=\"alteraIcone()\"><i ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a><div ng-show=\"ocultar\"><h3 class=\"with-line\">Título2</h3><div class=\"row\"><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Tipo</label><md-select name=\"tipodoc\" ng-model=\"novaRemessa.tipodoc\" placeholder=\"Selecione o tipo do título...\" ng-change=\"validaTipo(novaRemessa.tipodoc, \'tela\')\"><md-option ng-repeat=\"tipo in tipoDocumentos\" value=\"{{tipo.id}}\">{{ tipo.nome }}</md-option></md-select></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Número</label> <input required=\"\" name=\"numdoc\" restrict=\"reject\" autocomplete=\"off\" limit-to=\"20\" maxlength=\"20\" ng-model=\"novaRemessa.numdoc\" ng-pattern=\"\" ng-blur=\"validarTituloDuplicado()\"><div ng-messages=\"novaRemessaForm.numdoc.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"numDocInvalido\" ng-show=\"numDocInvalido || novaRemessaForm.numdoc.$touched\">O número do título deve ser informado.</div><div style=\"font-size:12px\" ng-if=\"docSacErro\" ng-show=\"novaRemessaForm.numdoc.$touched\">O número informado já existe para o sacado.</div><div style=\"font-size:12px\" ng-if=\"docCliErro\" ng-show=\"novaRemessaForm.numdoc.$touched\">O número informado já existe para o cliente.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Vencimento</label> <input required=\"\" mask=\"99/99/9999\" name=\"vencimento\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.vencimento\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\" ng-blur=\"buscaSacado(\'dtVenc\')\"><div ng-messages=\"novaRemessaForm.vencimento.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"required || dataInvalida\" ng-show=\"dataInvalida || novaRemessaForm.vencimento.$touched\">O vencimento informado é inválido.</div><div style=\"font-size:12px\" ng-if=\"dtVencErro\" ng-show=\"novaRemessaForm.vencimento.$touched\">O vencimento deve ser maior que a data do lote.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Valor</label> <input format=\"\" required=\"\" type=\"valor\" name=\"valor\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.valor\" ng-blur=\"buscaSacado(\'valorDoc\')\"><div ng-messages=\"novaRemessaForm.valor.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"novaRemessaForm.valor.$touched\">O valor deve ser informado.</div><div style=\"font-size:12px\" ng-if=\"docValErro\" ng-show=\"novaRemessaForm.valor.$touched\">O valor informado é inválido.</div></div></md-input-container></div></div><div layout-gt-xs=\"row\" ng-show=\"mostraCMC7NFe\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{labelDocumento}}</label> <input type=\"cmc7\" name=\"cmc7\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.cmc7\" maxlength=\"44\" ng-blur=\"buscaSacado(\'cmc7\')\"><div ng-messages=\"novaRemessaForm.cmc7.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"cmc7Erro\" ng-show=\"novaRemessaForm.cmc7.$touched\">CMC7 informado errado.</div></div></md-input-container></div><div ng-show=\"ocultarDadosFatura\"><div class=\"row\"><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Número da Fatura</label> <input name=\"numfatura\" maxlength=\"10\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.numfatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Data da Fatura</label> <input name=\"datafatura\" mask=\"99/99/9999\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.datafatura\" ng-blur=\"buscaSacado(false)\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Série da Fatura</label> <input name=\"seriefatura\" maxlength=\"3\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.seriefatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Valor da Fatura</label> <input format=\"\" name=\"valorfatura\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.valorfatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div></div></div><div class=\"row\"><h5 style=\"padding-left: 17px;\" class=\"with-line\">Sacado</h5><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>CNPJ/CPF</label> <input required=\"\" name=\"cgccic\" ui-br-cpfcnpj-mask=\"\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.cgccic\" ng-blur=\"buscaSacado(\'cgccic\')\"><div ng-messages=\"novaRemessaForm.cgccic.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"cpfInvalido || required\" ng-show=\"cpfInvalido || novaRemessaForm.cgccic.$touched\">O CNPJ/CPF informado é inválido.</div></div></md-input-container></div><div class=\"col-sm-5\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nome</label> <input required=\"\" name=\"nome\" restrict=\"reject\" autocomplete=\"off\" limit-to=\"50\" md-maxlength=\"50\" rows=\"5\" style=\"text-transform:uppercase\" ng-model=\"novaRemessa.nome\"><div ng-messages=\"novaRemessaForm.nome.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"novaRemessaForm.nome.$touched\">O nome do sacado deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-5\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>E-mail</label> <input type=\"email\" name=\"email\" restrict=\"reject\" autocomplete=\"off\" limit-to=\"80\" ng-model=\"novaRemessa.email\" minlength=\"10\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"novaRemessaForm.email.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-message-exp=\"[\'required\', \'pattern\']\">O E-mail informado é inválido.</div></div></md-input-container></div></div><div class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.endereco.grid.html\"></div></div></div></div></div><div style=\"margin-top: 18px;\" class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.telefone.grid.html\" style=\"padding-bottom: 40px\"></div></div></div></div></div><div align=\"right\"><div><a ng-click=\"gravarDadosTitulo()\"><button type=\"button\" class=\"btn btn-primary btn-with-icon\" scroll-on-click=\"\"><i class=\"ion-android-checkmark-circle\"></i>Salvar</button></a></div></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div align=\"right\"><a ng-if=\"permiteReenvio == true\"><button title=\"Reenviar Títulos à Factoring\" type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"envioLote == \'T\' ? open(\'app/pages/remessas/painel_remessa/observacao.html\', \'\', \'\') : enviarRemessa()\"><i class=\"ion-android-send\"></i>Reenviar</button></a> <a title=\"Há títulos já importados pela Factoring\" ng-if=\"permiteReenvio == false\" style=\"cursor: no-drop\"><button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-disabled=\"permiteReenvio == false\"><i class=\"ion-android-send\"></i>Reenviar</button></a><div class=\"col-sm-1\" style=\"width: 3.333333% !important;\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" nv-file-select=\"\" uploader=\"uploaderAnexos\" multiple=\"\"> <label align=\"right\" style=\"font-size: 24px;\" for=\"fileInput\"><i style=\"cursor: pointer; color: #209e91\" class=\"ion-android-attach\"></i></label></div><div><md-chips style=\"outline: none !important;\" ng-model=\"fileStrings\" name=\"Anexos\" readonly=\"true\" md-max-chips=\"5\" placeholder=\"Anexos\"><md-chip-template><span>{{$chip.name | limitTo: 10 }} {{$chip.name.length > 10 ? \'...\' : \'\'}}</span><md-icon style=\"width: 10px !important; min-width: 10px !important;\" ng-click=\"removeAnexo($chip)\" md-font-icon=\"ion-android-close\" class=\"s16\"></md-icon></md-chip-template></md-chips></div></div><h3 style=\"line-height: 20px\" class=\"with-line-same\">Lote de Títulos Enviados</h3><div class=\"row\"><div class=\"col-sm-12\"><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Data de Criação:</strong> {{dataOperacao}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Quantidade:</strong> {{qtdTitulos}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Valor Total:</strong> {{valorTitulos}}</div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div include-with-scope=\"app/pages/remessas/painel_remessa/painel.alteraremessa.grid.html\"></div></div></div></div></div></div></form></div>");
$templateCache.put("app/pages/remessas/painel_remessa/painel.remessa.grid.html","<div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table\" st-table=\"titulosRemessa\" st-safe-src=\"remessasOrdena\"><thead><tr class=\"sortable\"><th style=\"width: 1px\" st-sort=\"situacao\"><strong>Situação</strong></th><th st-sort=\"numdoc\"><strong>Número</strong></th><th st-sort=\"vencimento\"><strong>Vencimento</strong></th><th style=\"text-align: right;\" st-sort=\"valor\"><strong>Valor</strong></th><th st-sort=\"nome\"><strong>Sacado</strong></th><th st-sort=\"tipodoc\"><strong>Tipo</strong></th><th st-sort=\"action\"><strong>Ação</strong></th></tr></thead><tbody><tr ng-repeat=\"item in titulosRemessa|filter:search |startFrom:(currentPage - 1) * pageSize|limitTo: pageSize\"><td><div ng-if=\"item.docinderr == \'S\'\"><i class=\"ion-close\" title=\"Título inconsistente - Não será importado\" style=\"font-size: 26px;padding-left: 15px; color:#e02f2f\"></i></div><div ng-if=\"item.docinderr == \'N\'\"><i class=\"ion-checkmark\" title=\"Título consistente\" style=\"font-size: 26px;padding-left: 15px; color:#209e91\"></i></div></td><td>{{item.numdoc}}</td><td>{{item.vencimento}}</td><td align=\"right\" style=\"padding-right: 22px;\">{{item.valor | moedaFilter}}</td><td>{{item.nome}}</td><td>{{item.tipodoc | nomeTipoDocumento}}</td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><a title=\"Alterar Título\" ng-click=\"editarTitulo(item)\" scroll-on-click=\"\"><i class=\"ion-android-create\" style=\"font-size: 26px;padding-right:10px;\"></i></a> <a title=\"Excluir Título\" ng-click=\"verificaExclusao(item);\" scroll-on-click=\"\"><i class=\"ion-android-delete\" style=\"font-size: 26px;\"></i></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"titulosRemessa.length\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" num-pages=\"qtdPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"false\"></ul></div></td></tr></tfoot></div></table></div><br><span ng-if=\"mensagemVazio\">{{mensagemVazio}}</span></div>");
$templateCache.put("app/pages/remessas/painel_remessa/painel.remessa.html","<style>\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused .md-input,\r\n    md-input-container:not(.md-input-invalid).md-input-focused .md-input {\r\n        border-color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-default-theme:not(.md-input-invalid).md-input-focused label,\r\n    md-input-container:not(.md-input-invalid).md-input-focused label {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value.md-select-placeholder,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value.md-select-placeholder {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-default-theme .md-select-value,\r\n    md-input-container.md-input-focused:not(.md-input-has-value) md-select .md-select-value {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-select.md-default-theme:not([disabled]):focus .md-select-value,\r\n    md-select:not([disabled]):focus .md-select-value {\r\n        border-bottom-color: #1B867B;\r\n        color: rgba(0, 0, 0, 0.87);\r\n    }\r\n\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\r\n    md-select-menu md-content md-option:not([disabled]):focus,\r\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\r\n    md-select-menu md-content md-option:not([disabled]):hover {\r\n        background: rgb(238, 238, 238);\r\n        color: #1B867B;\r\n    }\r\n\r\n    .switchdemoBasicUsage .inset {\r\n        padding-left: 25px;\r\n        padding-top: 25px;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-thumb,\r\n    md-switch.md-checked .md-thumb {\r\n        background-color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-ink-ripple,\r\n    md-switch.md-checked .md-ink-ripple {\r\n        color: #1B867B;\r\n    }\r\n\r\n    md-switch.md-default-theme.md-checked .md-bar,\r\n    md-switch.md-checked .md-bar {\r\n        background-color: #8fc5c0;\r\n    }\r\n\r\n    md-input-container {\r\n        margin: 14px 0;\r\n    }\r\n\r\n    md-switch {\r\n        margin: 10px 0px;\r\n        height: 19px;\r\n    }\r\n\r\n    h3.with-line {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    h5.with-line {\r\n        padding-top: 0px;\r\n    }\r\n</style><script language=\"JavaScript\">\r\n    function somenteNumero(e) {\r\n        var tecla = (window.event) ? event.keyCode : e.which;\r\n        if ((tecla > 47 && tecla < 58)) return true;\r\n        else {\r\n            if (tecla == 8 || tecla == 0) return true;\r\n            else return false;\r\n        }\r\n    }\r\n</script><div class=\"widgets\" ng-init=\"parametrosIniciais(); buscaTitulosNaoEnviados();\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><form name=\"novaRemessaForm\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><a ng-if=\"ocultaInclusao\" type=\"button\" data-toggle=\"modal\" title=\"{{tituloIcone}}\" ng-click=\"alteraIcone()\"><i ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a> <span style=\"padding-right:15px;\"></span> <a ng-if=\"ocultaImportacao\" type=\"button\" data-toggle=\"modal\" title=\"{{tituloImportacao}}\" ng-click=\"alteraIcone2()\"><i ng-if=\"trocaBotao\" class=\"ion-android-upload\" style=\"font-size: 30px;\"></i> <i ng-if=\"!trocaBotao\" ng-class=\"{\'ion-android-cancel\': ocultar, \'ion-android-add-circle\': !ocultar }\" style=\"font-size: 30px;\" ng-style=\"ocultar && {\'color\':\'#9e2020\'} || {\'color\': \'#1B867B\'}\"></i></a> <span style=\"padding-right:15px;\"></span><div ng-if=\"mostraTelaDados == \'importa\'\" ng-show=\"ocultar\"><div include-with-scope=\"app/pages/remessas/importar_titulos/titulos.importar.html\"></div></div><div ng-if=\"mostraTelaDados == \'dados\'\" ng-show=\"ocultar\"><h3 class=\"with-line\">Título</h3><div class=\"row\"><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Tipo</label><md-select name=\"tipodoc\" ng-model=\"novaRemessa.tipodoc\" placeholder=\"Selecione o tipo do título...\" ng-change=\"validaTipo(novaRemessa.tipodoc, \'tela\')\"><md-option ng-repeat=\"tipo in tipoDocumentos\" value=\"{{tipo.id}}\">{{ tipo.nome }}</md-option></md-select><div ng-messages=\"novaRemessaForm.tipodoc.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"tipoDocInvalido\" ng-show=\"tipoDocInvalido\">O tipo do título deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Número</label> <input required=\"\" name=\"numdoc\" restrict=\"reject\" limit-to=\"20\" autocomplete=\"off\" maxlength=\"20\" ng-model=\"novaRemessa.numdoc\" ng-pattern=\"\" ng-blur=\"validarTituloDuplicado()\"><div ng-messages=\"novaRemessaForm.numdoc.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"numDocInvalido\" ng-show=\"numDocInvalido || novaRemessaForm.numdoc.$touched\">O número do título deve ser informado.</div><div style=\"font-size:12px\" ng-if=\"docSacErro\" ng-show=\"docSacErro || novaRemessaForm.numdoc.$touched\">O número informado já existe para o sacado.</div><div style=\"font-size:12px\" ng-if=\"docCliErro || ErroCliImport\" ng-show=\"docCliErro || ErroCliImport || novaRemessaForm.numdoc.$touched\">O número informado já existe para o cliente.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Vencimento</label> <input required=\"\" mask=\"99/99/9999\" name=\"vencimento\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.vencimento\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\" ng-blur=\"buscaSacado(\'dtVenc\')\"><div ng-messages=\"novaRemessaForm.vencimento.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"required || dataInvalida\" ng-show=\"dataInvalida || novaRemessaForm.vencimento.$touched\">O vencimento informado é inválido.</div><div style=\"font-size:12px\" ng-if=\"dtVencErro || ErroVencImport\" ng-show=\"dtVencErro || ErroVencImport\">O vencimento deve ser maior que a data do lote.</div></div></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Valor</label> <input format=\"\" required=\"\" type=\"valor\" name=\"valor\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.valor\" ng-blur=\"buscaSacado(\'valorDoc\')\"><div ng-messages=\"novaRemessaForm.valor.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"novaRemessaForm.valor.$touched\">O valor deve ser informado.</div><div style=\"font-size:12px\" ng-if=\"docValErro\" ng-show=\"novaRemessaForm.valor.$touched\">O valor informado é inválido.</div></div></md-input-container></div></div><div layout-gt-xs=\"row\" ng-show=\"mostraCMC7NFe\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{labelDocumento}}</label> <input type=\"cmc7\" name=\"cmc7\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.cmc7\" maxlength=\"44\" ng-blur=\"buscaSacado(\'cmc7\')\"><div ng-messages=\"novaRemessaForm.cmc7.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"cmc7Erro\" ng-show=\"novaRemessaForm.cmc7.$touched\">O CMC7 informado é inválido.</div><div style=\"font-size:12px\" ng-if=\"cmc7NfeObr\" ng-show=\"novaRemessaForm.cmc7.$touched || novaRemessaForm.cmc7.$untouched\">{{ novaRemessa.tipodoc == \'CH\' ? \'O CMC7 é obrigatório.\' : \'A chave da NF-e é obrigatória.\' }}</div></div></md-input-container></div><div ng-show=\"ocultarDadosFatura\"><div class=\"row\"><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Número da Fatura</label> <input name=\"numfatura\" maxlength=\"10\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.numfatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Data da Fatura</label> <input name=\"datafatura\" mask=\"99/99/9999\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.datafatura\" ng-blur=\"buscaSacado(false)\" ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)(?:0?2)\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Série da Fatura</label> <input name=\"seriefatura\" maxlength=\"3\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.seriefatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div><div class=\"col-sm-3\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Valor da Fatura</label> <input format=\"\" name=\"valorfatura\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.valorfatura\" ng-blur=\"buscaSacado(false)\"></md-input-container></div></div></div><div class=\"row\"><h5 style=\"padding-left: 17px;\" class=\"with-line\">Sacado</h5><div class=\"col-sm-2\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>CNPJ/CPF</label> <input required=\"\" name=\"cgccic\" ui-br-cpfcnpj-mask=\"\" restrict=\"reject\" autocomplete=\"off\" ng-model=\"novaRemessa.cgccic\" ng-blur=\"buscaSacado(\'cgccic\')\"><div ng-messages=\"novaRemessaForm.cgccic.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-if=\"required || cpfInvalido || ErroCnpjImport\" ng-show=\"(cpfInvalido || ErroCnpjImport) || novaRemessaForm.cgccic.$touched\">O CNPJ/CPF informado é inválido.</div></div></md-input-container></div><div class=\"col-sm-5\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>Nome</label> <input required=\"\" name=\"nome\" restrict=\"reject\" limit-to=\"50\" autocomplete=\"off\" md-maxlength=\"50\" rows=\"5\" style=\"text-transform:uppercase\" ng-model=\"novaRemessa.nome\"><div ng-messages=\"novaRemessaForm.nome.$error\" role=\"alert\"><div ng-message=\"required\" ng-show=\"novaRemessaForm.nome.$touched\">O nome do sacado deve ser informado.</div></div></md-input-container></div><div class=\"col-sm-5\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>E-mail</label> <input type=\"email\" name=\"email\" restrict=\"reject\" autocomplete=\"off\" limit-to=\"80\" ng-model=\"novaRemessa.email\" minlength=\"10\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"novaRemessaForm.email.$error\" role=\"alert\"><div style=\"font-size:12px\" ng-message-exp=\"[\'required\', \'pattern\']\">O e-mail informado é inválido.</div></div></md-input-container></div></div><div class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.endereco.grid.html\"></div></div></div></div></div><div style=\"margin-top: 18px;\" class=\"col-md-12 control-label\"><div class=\"row\"><div class=\"form-group row clearfix\"><div class=\"col-md-12 control-label\"><div include-with-scope=\"app/pages/cadastros/painel_sacado/painel.telefone.grid.html\" style=\"padding-bottom: 40px\"></div></div></div></div></div><div align=\"right\"><div><a ng-click=\"gravarDadosTitulo()\"><button type=\"button\" class=\"btn btn-primary btn-with-icon\" scroll-on-click=\"\"><i class=\"ion-android-checkmark-circle\"></i>Salvar</button></a></div></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-sm-1\" style=\"width: 3.333333% !important;\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" nv-file-select=\"\" uploader=\"uploaderAnexos\" multiple=\"\"> <label align=\"left\" style=\"font-size: 24px;\" for=\"fileInput\"><i style=\"cursor: pointer; color: #209e91\" class=\"ion-android-attach\"></i></label></div><div class=\"col-sm-11\"><md-chips style=\"outline: none !important;\" ng-model=\"fileStrings\" name=\"Anexos\" readonly=\"true\" md-max-chips=\"5\" placeholder=\"Anexos\"><md-chip-template><span>{{$chip.name | limitTo: 10 }} {{$chip.name.length > 10 ? \'...\' : \'\'}}</span><md-icon style=\"width: 10px !important; min-width: 10px !important;\" ng-click=\"removeAnexo($chip)\" md-font-icon=\"ion-android-close\" class=\"s16\"></md-icon></md-chip-template></md-chips></div></div></div><div class=\"col-sm-2\" align=\"right\"><a ng-click=\"verificaEnvio()\"><button ng-disabled=\"!titulosRemessa.length\" title=\"Enviar títulos à Factoring\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-send\"></i>Enviar</button></a></div></div><h3 style=\"line-height: 20px\" class=\"with-line-same\">Lote de Títulos para Envio</h3><div class=\"row\"><div class=\"col-sm-12\"><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Data de Criação:</strong> {{dataOperacao}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Quantidade:</strong> {{qtdTitulos}}</div><div style=\"color:white;background:#209E91;line-height:200%\" class=\"col-xs-12 col-sm-4 col-md-4\"><strong>Valor Total:</strong> {{valorTitulos}}</div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div include-with-scope=\"app/pages/remessas/painel_remessa/painel.remessa.grid.html\"></div></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/painel.remessa.sucesso.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-checkmark modal-icon\"></i><span>Dados gravados com sucesso!</span></div><div class=\"modal-body text-center\">Deseja continuar inserindo título na remessa?</div><div class=\"modal-footer\" ng-controller=\"painelRemessaController\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Não</button></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/removemodal.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-delete modal-icon\"></i><span>Exclusão de dados.</span></div><div class=\"modal-body text-center\">Deseja excluir esta informação?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss(); atualizarTela();\">Não</button></div></div>");
$templateCache.put("app/pages/remessas/painel_remessa/verifica.envio.modal.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-send modal-icon\"></i> <span>Envio de títulos.</span></div><div ng-if=\"identificaErro && identificaSucesso\" class=\"modal-body text-center\">Títulos inconsistentes seram descartados no envio do lote, deseja confirmar o envio?</div><div ng-if=\"identificaErro && !identificaSucesso\" class=\"modal-body text-center\">Não existe título consistente para realizar envio!</div><div ng-if=\"!identificaErro && identificaSucesso\" class=\"modal-body text-center\">Deseja enviar os títulos?</div><div ng-if=\"identificaErro && !identificaSucesso\" class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss(); atualizarTela();\">Ok</button></div><div ng-if=\"(identificaErro && identificaSucesso) || (!identificaErro && identificaSucesso)\" class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close();\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss(); atualizarTela();\">Não</button></div></div>");
$templateCache.put("app/pages/remessas/painel_remessas/observacao.html","<div class=\"modal-content\"><div class=\"modal-header cabecalho-instrucao\"><i></i><span>Instruções de Pagamento e Recomendações para a Factoring</span></div><div class=\"modal-body\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><textarea class=\"form-control tamanho-instrucaoArea\" ng-model=\"email.observacao\" placeholder=\"Digite aqui observações gerais para a factoring...\"></textarea></div></div></div></div></div><div class=\"modal-footer\"><a><button ng-click=\"enviarEmail(email.numeroOperacao); $close();\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Enviar</button></a> <button ng-click=\"$dismiss()\" type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-ios-close-outline\"></i>Cancelar</button></div></div>");
$templateCache.put("app/pages/remessas/painel_remessas/painel.remessas.grid.html","<div class=\"row\"><div class=\"col-sm-6\"><h3 class=\"with-line-same\">Lotes de Títulos Enviados</h3></div><div class=\"col-sm-6\"><h3 class=\"with-line-same\" style=\"font-size: 12px; color: red; text-align:right;\">*Será exibido o histórico de lotes dos últimos 15 dias</h3></div></div><div class=\"horizontal-scroll\" ng-init=\"buscarRemessasCadastradas()\"><div class=\"table-responsive\"><table class=\"table\" st-table=\"remessas\" st-safe-src=\"remessasOrdena\"><thead><tr class=\"sortable\"><th st-sort=\"data\"><strong>Data</strong></th><th class=\"text-right\" st-sort=\"quantidade\"><strong>Quantidade</strong></th><th class=\"text-right\" st-sort=\"somavalor\"><strong>Valor</strong></th><th st-sort=\"envio\"><strong>Envio</strong></th><th st-sort=\"situacao\"><strong>Situação</strong></th><th st-sort=\"action\"><strong>Ação</strong></th></tr><tr><th><input st-search=\"data\" placeholder=\"Data\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"quantidade\" placeholder=\"Quantidade\" class=\"input-sm form-control search-input input-filtroRemessas\" type=\"search\"></th><th><input st-search=\"somavalor\" placeholder=\"Valor\" class=\"input-sm form-control search-input input-filtroRemessas\" type=\"search\"></th><th><input st-search=\"envio\" placeholder=\"Envio\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in remessas |filter:search\"><td>{{::item.data}}</td>{{$index}}<td align=\"right\" class=\"preenchimento\">{{::item.quantidade}}</td><td align=\"right\" class=\"preenchimento\">{{::item.somavalor | moedaFilter}}</td><td>{{::item.envio}}</td><td style=\"padding-top: 7px;\"><div ng-if=\"item.statusLote == \'PR\'\" class=\"progress-bar progress-bar-success\" title=\"Lote processado na empresa.\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 100%\">Lote Processado</div><div ng-if=\"item.statusLote == \'AR\'\" class=\"progress-bar progress-bar-warning\" title=\"Aguardando reenvio do lote para a empresa.\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 100%\">Aguardando Reenvio</div><div ng-if=\"item.statusLote == \'AP\'\" class=\"progress-bar progress-bar-info\" title=\"Aguardando processamento do lote.\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 100%\">Aguardando Processar</div></td><td><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"estiloBotao\" title=\"Editar Lote de Títulos Enviados\" ng-click=\"editarRemessa(item)\"><i class=\"ion-android-create tamanho\"></i></button> <button class=\"estiloBotao\" title=\"Excluir Lote de Títulos\" ng-click=\"verificaExclusao(item);\"><i class=\"ion-android-delete tamanho\"></i></button> <button ng-hide=\"!permiteDuplicata\" class=\"estiloBotao\" ng-style=\"{{item.statusLote != \'PR\' || !item.temDP}} && ({\'color\': \'#6a706f\'}) || {\'color\': \'#209E91\'}\" ng-disabled=\"{{item.statusLote != \'PR\' || !item.temDP}}\" title=\"Baixar Duplicata\" ng-click=\"imprimeDuplicata(item)\"><i class=\"ion-document-text tamanho\"></i></button> <button ng-hide=\"!permiteBoleto\" class=\"estiloBotao\" ng-style=\"{{item.statusLote != \'PR\' || !item.temDP || !item.boleto}} && ({\'color\': \'#6a706f\'}) || {\'color\': \'#209E91\'}\" ng-disabled=\"{{item.statusLote != \'PR\' || !item.temDP || !item.boleto}}\" title=\"Baixar Boleto Bancário\" ng-click=\"imprimeBoleto(item)\"><i style=\"font-size: 20px;\" class=\"glyphicon glyphicon-barcode\"></i></button><button ng-if=\"envioLote == \'L\'\" class=\"estiloBotao\" data-toggle=\"modal\" title=\"Reenviar Títulos à Factoring\" ng-click=\"open(\'app/pages/remessas/enviar_remessas/remessa.enviar.html\'); param(item)\" ng-disabled=\"item.permiteReenvio == false\" ng-style=\"{{item.permiteReenvio != true}} && ({\'color\': \'#6a706f\'}) || {\'color\': \'#209E91\'}\"><i class=\"ion-android-send tamanho\"></i></button> <button ng-if=\"envioLote == \'T\'\" class=\"estiloBotao\" data-toggle=\"modal\" title=\"Reenviar Títulos à Factoring\" ng-click=\"enviarLote(item)\" ng-disabled=\"item.permiteReenvio == false\" ng-style=\"{{item.permiteReenvio != true}} && ({\'color\': \'#6a706f\'}) || {\'color\': \'#209E91\'}\"><i class=\"ion-android-send tamanho\"></i></button> <a id=\"dwnldLnk\" download=\"boleto bancário.pdf\" style=\"display:none;\"><a id=\"dwnldDup\" download=\"duplicata.pdf\" style=\"display:none;\"></a></a></div></td></tr></tbody><div ng-if=\"!mensagemVazio\"><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div><ul uib-pagination=\"\" total-items=\"totalItens\" previous-text=\"Anterior\" next-text=\"Próximo\" first-text=\"Primeiro\" last-text=\"Último\" ng-model=\"pagination.currentPage\" ng-change=\"buscarRemessasCadastradas()\" max-size=\"pagination.maxSize\" class=\"pagination-sm\" boundary-links=\"true\" rotate=\"true\"></ul></div></td></tr></tfoot></div></table></div><br><span ng-if=\"mensagemVazio\">{{mensagemVazio}}</span></div>");
$templateCache.put("app/pages/remessas/painel_remessas/painel.remessas.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/remessas/painel_remessas/painel.remessas.grid.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/remessas/painel_remessas/removemodal.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"background-color: #1C2B36;\"><i class=\"ion-android-delete modal-icon\"></i><span>Exclusão de dados.</span></div><div class=\"modal-body text-center\">Deseja excluir esta informação?</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$close()\">Sim</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Não</button></div></div>");}]);